(() => {

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7e89"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7e89"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gv7vu", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */ (function(global1, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function objectOrFunction(x) {
        var type = typeof x;
        return x !== null && (type === 'object' || type === 'function');
    }
    function isFunction(x) {
        return typeof x === 'function';
    }
    var _isArray = void 0;
    if (Array.isArray) _isArray = Array.isArray;
    else _isArray = function(x) {
        return Object.prototype.toString.call(x) === '[object Array]';
    };
    var isArray = _isArray;
    var len = 0;
    var vertxNext = void 0;
    var customSchedulerFn = void 0;
    var asap = function asap(callback, arg) {
        queue[len] = callback;
        queue[len + 1] = arg;
        len += 2;
        if (len === 2) {
            // If len is 2, that means that we need to schedule an async flush.
            // If additional callbacks are queued before the queue is flushed, they
            // will be processed by this flush that we are scheduling.
            if (customSchedulerFn) customSchedulerFn(flush);
            else scheduleFlush();
        }
    };
    function setScheduler(scheduleFn) {
        customSchedulerFn = scheduleFn;
    }
    function setAsap(asapFn) {
        asap = asapFn;
    }
    var browserWindow = typeof window !== 'undefined' ? window : undefined;
    var browserGlobal = browserWindow || {};
    var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
    var isNode = typeof self === 'undefined' && false;
    // test for web worker but not in IE10
    var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
    // node
    function useNextTick() {
        // node version 0.10.x displays a deprecation warning when nextTick is used recursively
        // see https://github.com/cujojs/when/issues/410 for details
        return function() {
            return $ibaza.nextTick(flush);
        };
    }
    // vertx
    function useVertxTimer() {
        if (typeof vertxNext !== 'undefined') return function() {
            vertxNext(flush);
        };
        return useSetTimeout();
    }
    function useMutationObserver() {
        var iterations = 0;
        var observer = new BrowserMutationObserver(flush);
        var node = document.createTextNode('');
        observer.observe(node, {
            characterData: true
        });
        return function() {
            node.data = iterations = ++iterations % 2;
        };
    }
    // web worker
    function useMessageChannel() {
        var channel = new MessageChannel();
        channel.port1.onmessage = flush;
        return function() {
            return channel.port2.postMessage(0);
        };
    }
    function useSetTimeout() {
        // Store setTimeout reference so es6-promise will be unaffected by
        // other code modifying setTimeout (like sinon.useFakeTimers())
        var globalSetTimeout = setTimeout;
        return function() {
            return globalSetTimeout(flush, 1);
        };
    }
    var queue = new Array(1000);
    function flush() {
        for(var i = 0; i < len; i += 2){
            var callback = queue[i];
            var arg = queue[i + 1];
            callback(arg);
            queue[i] = undefined;
            queue[i + 1] = undefined;
        }
        len = 0;
    }
    function attemptVertx() {
        try {
            var vertx = Function('return this')().require('vertx');
            vertxNext = vertx.runOnLoop || vertx.runOnContext;
            return useVertxTimer();
        } catch (e) {
            return useSetTimeout();
        }
    }
    var scheduleFlush = void 0;
    // Decide what async method to use to triggering processing of queued callbacks:
    if (isNode) scheduleFlush = useNextTick();
    else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
    else if (isWorker) scheduleFlush = useMessageChannel();
    else if (browserWindow === undefined && true) scheduleFlush = attemptVertx();
    else scheduleFlush = useSetTimeout();
    function then(onFulfillment, onRejection) {
        var parent = this;
        var child = new this.constructor(noop);
        if (child[PROMISE_ID] === undefined) makePromise(child);
        var _state = parent._state;
        if (_state) {
            var callback = arguments[_state - 1];
            asap(function() {
                return invokeCallback(_state, child, callback, parent._result);
            });
        } else subscribe(parent, child, onFulfillment, onRejection);
        return child;
    }
    /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
        /*jshint validthis:true */ var Constructor = this;
        if (object && typeof object === 'object' && object.constructor === Constructor) return object;
        var promise = new Constructor(noop);
        resolve(promise, object);
        return promise;
    }
    var PROMISE_ID = Math.random().toString(36).substring(2);
    function noop() {}
    var PENDING = void 0;
    var FULFILLED = 1;
    var REJECTED = 2;
    function selfFulfillment() {
        return new TypeError("You cannot resolve a promise with itself");
    }
    function cannotReturnOwn() {
        return new TypeError('A promises callback cannot return that same promise.');
    }
    function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
        try {
            then$$1.call(value, fulfillmentHandler, rejectionHandler);
        } catch (e) {
            return e;
        }
    }
    function handleForeignThenable(promise, thenable, then$$1) {
        asap(function(promise) {
            var sealed = false;
            var error = tryThen(then$$1, thenable, function(value) {
                if (sealed) return;
                sealed = true;
                if (thenable !== value) resolve(promise, value);
                else fulfill(promise, value);
            }, function(reason) {
                if (sealed) return;
                sealed = true;
                reject(promise, reason);
            }, 'Settle: ' + (promise._label || ' unknown promise'));
            if (!sealed && error) {
                sealed = true;
                reject(promise, error);
            }
        }, promise);
    }
    function handleOwnThenable(promise, thenable) {
        if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
        else if (thenable._state === REJECTED) reject(promise, thenable._result);
        else subscribe(thenable, undefined, function(value) {
            return resolve(promise, value);
        }, function(reason) {
            return reject(promise, reason);
        });
    }
    function handleMaybeThenable(promise, maybeThenable, then$$1) {
        if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
        else {
            if (then$$1 === undefined) fulfill(promise, maybeThenable);
            else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
            else fulfill(promise, maybeThenable);
        }
    }
    function resolve(promise, value) {
        if (promise === value) reject(promise, selfFulfillment());
        else if (objectOrFunction(value)) {
            var then$$1 = void 0;
            try {
                then$$1 = value.then;
            } catch (error) {
                reject(promise, error);
                return;
            }
            handleMaybeThenable(promise, value, then$$1);
        } else fulfill(promise, value);
    }
    function publishRejection(promise) {
        if (promise._onerror) promise._onerror(promise._result);
        publish(promise);
    }
    function fulfill(promise, value) {
        if (promise._state !== PENDING) return;
        promise._result = value;
        promise._state = FULFILLED;
        if (promise._subscribers.length !== 0) asap(publish, promise);
    }
    function reject(promise, reason) {
        if (promise._state !== PENDING) return;
        promise._state = REJECTED;
        promise._result = reason;
        asap(publishRejection, promise);
    }
    function subscribe(parent, child, onFulfillment, onRejection) {
        var _subscribers = parent._subscribers;
        var length = _subscribers.length;
        parent._onerror = null;
        _subscribers[length] = child;
        _subscribers[length + FULFILLED] = onFulfillment;
        _subscribers[length + REJECTED] = onRejection;
        if (length === 0 && parent._state) asap(publish, parent);
    }
    function publish(promise) {
        var subscribers = promise._subscribers;
        var settled = promise._state;
        if (subscribers.length === 0) return;
        var child = void 0, callback = void 0, detail = promise._result;
        for(var i = 0; i < subscribers.length; i += 3){
            child = subscribers[i];
            callback = subscribers[i + settled];
            if (child) invokeCallback(settled, child, callback, detail);
            else callback(detail);
        }
        promise._subscribers.length = 0;
    }
    function invokeCallback(settled, promise, callback, detail) {
        var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = true;
        if (hasCallback) {
            try {
                value = callback(detail);
            } catch (e) {
                succeeded = false;
                error = e;
            }
            if (promise === value) {
                reject(promise, cannotReturnOwn());
                return;
            }
        } else value = detail;
        if (promise._state !== PENDING) ;
        else if (hasCallback && succeeded) resolve(promise, value);
        else if (succeeded === false) reject(promise, error);
        else if (settled === FULFILLED) fulfill(promise, value);
        else if (settled === REJECTED) reject(promise, value);
    }
    function initializePromise(promise, resolver) {
        try {
            resolver(function resolvePromise(value) {
                resolve(promise, value);
            }, function rejectPromise(reason) {
                reject(promise, reason);
            });
        } catch (e) {
            reject(promise, e);
        }
    }
    var id = 0;
    function nextId() {
        return id++;
    }
    function makePromise(promise) {
        promise[PROMISE_ID] = id++;
        promise._state = undefined;
        promise._result = undefined;
        promise._subscribers = [];
    }
    function validationError() {
        return new Error('Array Methods must be provided an Array');
    }
    var Enumerator = function() {
        function Enumerator(Constructor, input) {
            this._instanceConstructor = Constructor;
            this.promise = new Constructor(noop);
            if (!this.promise[PROMISE_ID]) makePromise(this.promise);
            if (isArray(input)) {
                this.length = input.length;
                this._remaining = input.length;
                this._result = new Array(this.length);
                if (this.length === 0) fulfill(this.promise, this._result);
                else {
                    this.length = this.length || 0;
                    this._enumerate(input);
                    if (this._remaining === 0) fulfill(this.promise, this._result);
                }
            } else reject(this.promise, validationError());
        }
        Enumerator.prototype._enumerate = function _enumerate(input) {
            for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
        };
        Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
            var c = this._instanceConstructor;
            var resolve$$1 = c.resolve;
            if (resolve$$1 === resolve$1) {
                var _then = void 0;
                var error = void 0;
                var didError = false;
                try {
                    _then = entry.then;
                } catch (e) {
                    didError = true;
                    error = e;
                }
                if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                else if (typeof _then !== 'function') {
                    this._remaining--;
                    this._result[i] = entry;
                } else if (c === Promise$1) {
                    var promise = new c(noop);
                    if (didError) reject(promise, error);
                    else handleMaybeThenable(promise, entry, _then);
                    this._willSettleAt(promise, i);
                } else this._willSettleAt(new c(function(resolve$$1) {
                    return resolve$$1(entry);
                }), i);
            } else this._willSettleAt(resolve$$1(entry), i);
        };
        Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
            var promise = this.promise;
            if (promise._state === PENDING) {
                this._remaining--;
                if (state === REJECTED) reject(promise, value);
                else this._result[i] = value;
            }
            if (this._remaining === 0) fulfill(promise, this._result);
        };
        Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
            var enumerator = this;
            subscribe(promise, undefined, function(value) {
                return enumerator._settledAt(FULFILLED, i, value);
            }, function(reason) {
                return enumerator._settledAt(REJECTED, i, reason);
            });
        };
        return Enumerator;
    }();
    /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
        return new Enumerator(this, entries).promise;
    }
    /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
        /*jshint validthis:true */ var Constructor = this;
        if (!isArray(entries)) return new Constructor(function(_, reject) {
            return reject(new TypeError('You must pass an array to race.'));
        });
        else return new Constructor(function(resolve, reject) {
            var length = entries.length;
            for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
        });
    }
    /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
        /*jshint validthis:true */ var Constructor = this;
        var promise = new Constructor(noop);
        reject(promise, reason);
        return promise;
    }
    function needsResolver() {
        throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
    }
    function needsNew() {
        throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }
    /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
        function Promise(resolver) {
            this[PROMISE_ID] = nextId();
            this._result = this._state = undefined;
            this._subscribers = [];
            if (noop !== resolver) {
                typeof resolver !== 'function' && needsResolver();
                this instanceof Promise ? initializePromise(this, resolver) : needsNew();
            }
        }
        /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
            return this.then(null, onRejection);
        };
        /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
            var promise = this;
            var constructor = promise.constructor;
            if (isFunction(callback)) return promise.then(function(value) {
                return constructor.resolve(callback()).then(function() {
                    return value;
                });
            }, function(reason) {
                return constructor.resolve(callback()).then(function() {
                    throw reason;
                });
            });
            return promise.then(callback, callback);
        };
        return Promise;
    }();
    Promise$1.prototype.then = then;
    Promise$1.all = all;
    Promise$1.race = race;
    Promise$1.resolve = resolve$1;
    Promise$1.reject = reject$1;
    Promise$1._setScheduler = setScheduler;
    Promise$1._setAsap = setAsap;
    Promise$1._asap = asap;
    /*global self*/ function polyfill() {
        var local = void 0;
        if (typeof $parcel$global !== 'undefined') local = $parcel$global;
        else if (typeof self !== 'undefined') local = self;
        else try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
        var P = local.Promise;
        if (P) {
            var promiseToString = null;
            try {
                promiseToString = Object.prototype.toString.call(P.resolve());
            } catch (e) {
            // silently ignored
            }
            if (promiseToString === '[object Promise]' && !P.cast) return;
        }
        local.Promise = Promise$1;
    }
    // Strange compat..
    Promise$1.polyfill = polyfill;
    Promise$1.Promise = Promise$1;
    return Promise$1;
});

});
parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = 'browser';
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ''; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d3c1734dacb01657$var$process.cwd = function() {
    return '/';
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});


parcelRegister("81tj9", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");

var $cG9HX = parcelRequire("cG9HX");

var $hBrVA = parcelRequire("hBrVA");

var $1nuTH = parcelRequire("1nuTH");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    var context = new $hBrVA(defaultConfig);
    var instance = $cG9HX($hBrVA.prototype.request, context);
    // Copy axios.prototype to instance
    $eFc3n.extend(instance, $hBrVA.prototype, context);
    // Copy context to instance
    $eFc3n.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance($1nuTH);
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = $hBrVA;
// Factory for creating new instances
$5d7526a7a1e5b3fb$var$axios.create = function create(instanceConfig) {
    return $5d7526a7a1e5b3fb$var$createInstance($eFc3n.merge($1nuTH, instanceConfig));
};

// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.Cancel = (parcelRequire("anxHC"));

$5d7526a7a1e5b3fb$var$axios.CancelToken = (parcelRequire("4iFhx"));

$5d7526a7a1e5b3fb$var$axios.isCancel = (parcelRequire("lCgfr"));
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$5d7526a7a1e5b3fb$var$axios.spread = (parcelRequire("albzn"));
module.exports = $5d7526a7a1e5b3fb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $5d7526a7a1e5b3fb$var$axios;

});
parcelRegister("eFc3n", function(module, exports) {
'use strict';

var $cG9HX = parcelRequire("cG9HX");

var $Ek5Fh = parcelRequire("Ek5Fh");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $aace3e920a0f1e4d$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $aace3e920a0f1e4d$var$isArray(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBuffer(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $aace3e920a0f1e4d$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $aace3e920a0f1e4d$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $aace3e920a0f1e4d$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $aace3e920a0f1e4d$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $aace3e920a0f1e4d$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $aace3e920a0f1e4d$var$isDate(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $aace3e920a0f1e4d$var$isFile(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $aace3e920a0f1e4d$var$isBlob(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $aace3e920a0f1e4d$var$isFunction(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $aace3e920a0f1e4d$var$isStream(val) {
    return $aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $aace3e920a0f1e4d$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $aace3e920a0f1e4d$var$trim(str) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */ function $aace3e920a0f1e4d$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === 'object' && typeof val === 'object') result[key] = $aace3e920a0f1e4d$var$merge(result[key], val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$aace3e920a0f1e4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $aace3e920a0f1e4d$var$extend(a, b, thisArg) {
    $aace3e920a0f1e4d$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $cG9HX(val, thisArg);
        else a[key] = val;
    });
    return a;
}
module.exports = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $Ek5Fh,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isStandardBrowserEnv: $aace3e920a0f1e4d$var$isStandardBrowserEnv,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim
};

});
parcelRegister("cG9HX", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});

parcelRegister("Ek5Fh", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

});


parcelRegister("hBrVA", function(module, exports) {
'use strict';

var $1nuTH = parcelRequire("1nuTH");

var $eFc3n = parcelRequire("eFc3n");

var $9ltoJ = parcelRequire("9ltoJ");

var $cUzFg = parcelRequire("cUzFg");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $cd0b8e3cbef64068$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $9ltoJ(),
        response: new $9ltoJ()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $cd0b8e3cbef64068$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') config = $eFc3n.merge({
        url: arguments[0]
    }, arguments[1]);
    config = $eFc3n.merge($1nuTH, {
        method: 'get'
    }, this.defaults, config);
    config.method = config.method.toLowerCase();
    // Hook up interceptors middleware
    var chain = [
        $cUzFg,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
// Provide aliases for supported request methods
$eFc3n.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request($eFc3n.merge(config || {}, {
            method: method,
            url: url
        }));
    };
});
$eFc3n.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($eFc3n.merge(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $cd0b8e3cbef64068$var$Axios;

});
parcelRegister("1nuTH", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");

var $elOvr = parcelRequire("elOvr");
var $100fe7fc4c7b4810$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $100fe7fc4c7b4810$var$setContentTypeIfUnset(headers, value) {
    if (!$eFc3n.isUndefined(headers) && $eFc3n.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $100fe7fc4c7b4810$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("8nTSD"));
    return adapter;
}
var $100fe7fc4c7b4810$var$defaults = {
    adapter: $100fe7fc4c7b4810$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $elOvr(headers, 'Content-Type');
            if ($eFc3n.isFormData(data) || $eFc3n.isArrayBuffer(data) || $eFc3n.isBuffer(data) || $eFc3n.isStream(data) || $eFc3n.isFile(data) || $eFc3n.isBlob(data)) return data;
            if ($eFc3n.isArrayBufferView(data)) return data.buffer;
            if ($eFc3n.isURLSearchParams(data)) {
                $100fe7fc4c7b4810$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($eFc3n.isObject(data)) {
                $100fe7fc4c7b4810$var$setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === 'string') try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$100fe7fc4c7b4810$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$eFc3n.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $100fe7fc4c7b4810$var$defaults.headers[method] = {};
});
$eFc3n.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $100fe7fc4c7b4810$var$defaults.headers[method] = $eFc3n.merge($100fe7fc4c7b4810$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $100fe7fc4c7b4810$var$defaults;

});
parcelRegister("elOvr", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $eFc3n.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("8nTSD", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");

var $gyIfz = parcelRequire("gyIfz");

var $iOHZJ = parcelRequire("iOHZJ");

var $4Ik1V = parcelRequire("4Ik1V");

var $4YUSN = parcelRequire("4YUSN");

var $hYe4p = parcelRequire("hYe4p");

module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($eFc3n.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password || '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        request.open(config.method.toUpperCase(), $iOHZJ(config.url, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $4Ik1V(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $gyIfz(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($hYe4p('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            reject($hYe4p('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($eFc3n.isStandardBrowserEnv()) {
            var cookies = (parcelRequire("6D8uh"));
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $4YUSN(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $eFc3n.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (config.withCredentials) request.withCredentials = true;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== 'json') throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (requestData === undefined) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("gyIfz", function(module, exports) {
'use strict';

var $hYe4p = parcelRequire("hYe4p");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    // Note: status is not exposed by XDomainRequest
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($hYe4p('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("hYe4p", function(module, exports) {
'use strict';

var $fEfFg = parcelRequire("fEfFg");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $fEfFg(error, config, code, request, response);
};

});
parcelRegister("fEfFg", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    return error;
};

});



parcelRegister("iOHZJ", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");
function $db2f05ec923f2ee7$var$encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($eFc3n.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $eFc3n.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($eFc3n.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $eFc3n.forEach(val, function parseValue(v) {
                if ($eFc3n.isDate(v)) v = v.toISOString();
                else if ($eFc3n.isObject(v)) v = JSON.stringify(v);
                parts.push($db2f05ec923f2ee7$var$encode(key) + '=' + $db2f05ec923f2ee7$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    return url;
};

});

parcelRegister("4Ik1V", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $36eacf0f5ae88424$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $eFc3n.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $eFc3n.trim(line.substr(0, i)).toLowerCase();
        val = $eFc3n.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $36eacf0f5ae88424$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("4YUSN", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");
module.exports = $eFc3n.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $eFc3n.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("6D8uh", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");
module.exports = $eFc3n.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($eFc3n.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($eFc3n.isString(path)) cookie.push('path=' + path);
            if ($eFc3n.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});



parcelRegister("9ltoJ", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");
function $01c17f80085c95b1$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $01c17f80085c95b1$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $01c17f80085c95b1$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $01c17f80085c95b1$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $eFc3n.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $01c17f80085c95b1$var$InterceptorManager;

});

parcelRegister("cUzFg", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");

var $kgh03 = parcelRequire("kgh03");

var $lCgfr = parcelRequire("lCgfr");

var $1nuTH = parcelRequire("1nuTH");

var $uAxSn = parcelRequire("uAxSn");

var $aFAjA = parcelRequire("aFAjA");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    // Support baseURL config
    if (config.baseURL && !$uAxSn(config.url)) config.url = $aFAjA(config.baseURL, config.url);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $kgh03(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $eFc3n.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});
    $eFc3n.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $1nuTH.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $kgh03(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$lCgfr(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $kgh03(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("kgh03", function(module, exports) {
'use strict';

var $eFc3n = parcelRequire("eFc3n");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $eFc3n.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("lCgfr", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("uAxSn", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("aFAjA", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});



parcelRegister("anxHC", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $78e631f68b7e223f$var$Cancel(message) {
    this.message = message;
}
$78e631f68b7e223f$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$78e631f68b7e223f$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $78e631f68b7e223f$var$Cancel;

});

parcelRegister("4iFhx", function(module, exports) {
'use strict';

var $anxHC = parcelRequire("anxHC");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $3218dd97b5460664$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $anxHC(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $3218dd97b5460664$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $3218dd97b5460664$var$CancelToken.source = function source() {
    var cancel;
    var token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $3218dd97b5460664$var$CancelToken;

});

parcelRegister("albzn", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});


// Import SASS

var $bf4ef12aa93688e8$exports = {};
/*! npm.im/object-fit-images 3.2.4 */ 'use strict';
var $bf4ef12aa93688e8$var$OFI = 'bfred-it:object-fit-images';
var $bf4ef12aa93688e8$var$propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var $bf4ef12aa93688e8$var$testImg = typeof Image === 'undefined' ? {
    style: {
        'object-position': 1
    }
} : new Image();
var $bf4ef12aa93688e8$var$supportsObjectFit = 'object-fit' in $bf4ef12aa93688e8$var$testImg.style;
var $bf4ef12aa93688e8$var$supportsObjectPosition = 'object-position' in $bf4ef12aa93688e8$var$testImg.style;
var $bf4ef12aa93688e8$var$supportsOFI = 'background-size' in $bf4ef12aa93688e8$var$testImg.style;
var $bf4ef12aa93688e8$var$supportsCurrentSrc = typeof $bf4ef12aa93688e8$var$testImg.currentSrc === 'string';
var $bf4ef12aa93688e8$var$nativeGetAttribute = $bf4ef12aa93688e8$var$testImg.getAttribute;
var $bf4ef12aa93688e8$var$nativeSetAttribute = $bf4ef12aa93688e8$var$testImg.setAttribute;
var $bf4ef12aa93688e8$var$autoModeEnabled = false;
function $bf4ef12aa93688e8$var$createPlaceholder(w, h) {
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E";
}
function $bf4ef12aa93688e8$var$polyfillCurrentSrc(el) {
    if (el.srcset && !$bf4ef12aa93688e8$var$supportsCurrentSrc && window.picturefill) {
        var pf = window.picturefill._;
        // parse srcset with picturefill where currentSrc isn't available
        if (!el[pf.ns] || !el[pf.ns].evaled) // force synchronous srcset parsing
        pf.fillImg(el, {
            reselect: true
        });
        if (!el[pf.ns].curSrc) {
            // force picturefill to parse srcset
            el[pf.ns].supported = false;
            pf.fillImg(el, {
                reselect: true
            });
        }
        // retrieve parsed currentSrc, if any
        el.currentSrc = el[pf.ns].curSrc || el.src;
    }
}
function $bf4ef12aa93688e8$var$getStyle(el) {
    var style = getComputedStyle(el).fontFamily;
    var parsed;
    var props = {};
    while((parsed = $bf4ef12aa93688e8$var$propRegex.exec(style)) !== null)props[parsed[1]] = parsed[2];
    return props;
}
function $bf4ef12aa93688e8$var$setPlaceholder(img, width, height) {
    // Default: fill width, no height
    var placeholder = $bf4ef12aa93688e8$var$createPlaceholder(width || 1, height || 0);
    // Only set placeholder if it's different
    if ($bf4ef12aa93688e8$var$nativeGetAttribute.call(img, 'src') !== placeholder) $bf4ef12aa93688e8$var$nativeSetAttribute.call(img, 'src', placeholder);
}
function $bf4ef12aa93688e8$var$onImageReady(img, callback) {
    // naturalWidth is only available when the image headers are loaded,
    // this loop will poll it every 100ms.
    if (img.naturalWidth) callback(img);
    else setTimeout($bf4ef12aa93688e8$var$onImageReady, 100, img, callback);
}
function $bf4ef12aa93688e8$var$fixOne(el) {
    var style = $bf4ef12aa93688e8$var$getStyle(el);
    var ofi = el[$bf4ef12aa93688e8$var$OFI];
    style['object-fit'] = style['object-fit'] || 'fill'; // default value
    // Avoid running where unnecessary, unless OFI had already done its deed
    if (!ofi.img) {
        // fill is the default behavior so no action is necessary
        if (style['object-fit'] === 'fill') return;
        // Where object-fit is supported and object-position isn't (Safari < 10)
        if (!ofi.skipTest && // unless user wants to apply regardless of browser support
        $bf4ef12aa93688e8$var$supportsObjectFit && // if browser already supports object-fit
        !style['object-position'] // unless object-position is used
        ) return;
    }
    // keep a clone in memory while resetting the original to a blank
    if (!ofi.img) {
        ofi.img = new Image(el.width, el.height);
        ofi.img.srcset = $bf4ef12aa93688e8$var$nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
        ofi.img.src = $bf4ef12aa93688e8$var$nativeGetAttribute.call(el, "data-ofi-src") || el.src;
        // preserve for any future cloneNode calls
        // https://github.com/bfred-it/object-fit-images/issues/53
        $bf4ef12aa93688e8$var$nativeSetAttribute.call(el, "data-ofi-src", el.src);
        if (el.srcset) $bf4ef12aa93688e8$var$nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
        $bf4ef12aa93688e8$var$setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);
        // remove srcset because it overrides src
        if (el.srcset) el.srcset = '';
        try {
            $bf4ef12aa93688e8$var$keepSrcUsable(el);
        } catch (err) {
            if (window.console) console.warn('https://bit.ly/ofi-old-browser');
        }
    }
    $bf4ef12aa93688e8$var$polyfillCurrentSrc(ofi.img);
    el.style.backgroundImage = "url(\"" + (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') + "\")";
    el.style.backgroundPosition = style['object-position'] || 'center';
    el.style.backgroundRepeat = 'no-repeat';
    el.style.backgroundOrigin = 'content-box';
    if (/scale-down/.test(style['object-fit'])) $bf4ef12aa93688e8$var$onImageReady(ofi.img, function() {
        if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) el.style.backgroundSize = 'contain';
        else el.style.backgroundSize = 'auto';
    });
    else el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
    $bf4ef12aa93688e8$var$onImageReady(ofi.img, function(img) {
        $bf4ef12aa93688e8$var$setPlaceholder(el, img.naturalWidth, img.naturalHeight);
    });
}
function $bf4ef12aa93688e8$var$keepSrcUsable(el) {
    var descriptors = {
        get: function get(prop) {
            return el[$bf4ef12aa93688e8$var$OFI].img[prop ? prop : 'src'];
        },
        set: function set(value, prop) {
            el[$bf4ef12aa93688e8$var$OFI].img[prop ? prop : 'src'] = value;
            $bf4ef12aa93688e8$var$nativeSetAttribute.call(el, "data-ofi-" + prop, value); // preserve for any future cloneNode
            $bf4ef12aa93688e8$var$fixOne(el);
            return value;
        }
    };
    Object.defineProperty(el, 'src', descriptors);
    Object.defineProperty(el, 'currentSrc', {
        get: function() {
            return descriptors.get('currentSrc');
        }
    });
    Object.defineProperty(el, 'srcset', {
        get: function() {
            return descriptors.get('srcset');
        },
        set: function(ss) {
            return descriptors.set(ss, 'srcset');
        }
    });
}
function $bf4ef12aa93688e8$var$hijackAttributes() {
    function getOfiImageMaybe(el, name) {
        return el[$bf4ef12aa93688e8$var$OFI] && el[$bf4ef12aa93688e8$var$OFI].img && (name === 'src' || name === 'srcset') ? el[$bf4ef12aa93688e8$var$OFI].img : el;
    }
    if (!$bf4ef12aa93688e8$var$supportsObjectPosition) {
        HTMLImageElement.prototype.getAttribute = function(name) {
            return $bf4ef12aa93688e8$var$nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
        };
        HTMLImageElement.prototype.setAttribute = function(name, value) {
            return $bf4ef12aa93688e8$var$nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
        };
    }
}
function $bf4ef12aa93688e8$var$fix(imgs, opts) {
    var startAutoMode = !$bf4ef12aa93688e8$var$autoModeEnabled && !imgs;
    opts = opts || {};
    imgs = imgs || 'img';
    if ($bf4ef12aa93688e8$var$supportsObjectPosition && !opts.skipTest || !$bf4ef12aa93688e8$var$supportsOFI) return false;
    // use imgs as a selector or just select all images
    if (imgs === 'img') imgs = document.getElementsByTagName('img');
    else if (typeof imgs === 'string') imgs = document.querySelectorAll(imgs);
    else if (!('length' in imgs)) imgs = [
        imgs
    ];
    // apply fix to all
    for(var i = 0; i < imgs.length; i++){
        imgs[i][$bf4ef12aa93688e8$var$OFI] = imgs[i][$bf4ef12aa93688e8$var$OFI] || {
            skipTest: opts.skipTest
        };
        $bf4ef12aa93688e8$var$fixOne(imgs[i]);
    }
    if (startAutoMode) {
        document.body.addEventListener('load', function(e) {
            if (e.target.tagName === 'IMG') $bf4ef12aa93688e8$var$fix(e.target, {
                skipTest: opts.skipTest
            });
        }, true);
        $bf4ef12aa93688e8$var$autoModeEnabled = true;
        imgs = 'img'; // reset to a generic selector for watchMQ
    }
    // if requested, watch media queries for object-fit change
    if (opts.watchMQ) window.addEventListener('resize', $bf4ef12aa93688e8$var$fix.bind(null, imgs, {
        skipTest: opts.skipTest
    }));
}
$bf4ef12aa93688e8$var$fix.supportsObjectFit = $bf4ef12aa93688e8$var$supportsObjectFit;
$bf4ef12aa93688e8$var$fix.supportsObjectPosition = $bf4ef12aa93688e8$var$supportsObjectPosition;
$bf4ef12aa93688e8$var$hijackAttributes();
$bf4ef12aa93688e8$exports = $bf4ef12aa93688e8$var$fix;


/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */ (function() {
    var isIe = /(trident|msie)/i.test(navigator.userAgent);
    if (isIe && document.getElementById && window.addEventListener) window.addEventListener('hashchange', function() {
        var id = location.hash.substring(1), element;
        if (!/^[A-z0-9_-]+$/.test(id)) return;
        element = document.getElementById(id);
        if (element) {
            if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) element.tabIndex = -1;
            element.focus();
        }
    }, false);
})();


// Object.keys
var $76143cc5646b0a4d$var$win = window;
var $76143cc5646b0a4d$export$27f233d61a9e2fa4 = $76143cc5646b0a4d$var$win.requestAnimationFrame || $76143cc5646b0a4d$var$win.webkitRequestAnimationFrame || $76143cc5646b0a4d$var$win.mozRequestAnimationFrame || $76143cc5646b0a4d$var$win.msRequestAnimationFrame || function(cb) {
    return setTimeout(cb, 16);
};


var $568c83fe70cd0407$var$win = window;
var $568c83fe70cd0407$export$75aab3dbee8deceb = $568c83fe70cd0407$var$win.cancelAnimationFrame || $568c83fe70cd0407$var$win.mozCancelAnimationFrame || function(id) {
    clearTimeout(id);
};


function $2f74ee940b1656a2$export$8b58be045bf06082() {
    var obj, name, copy, target = arguments[0] || {}, i = 1, length = arguments.length;
    for(; i < length; i++){
        if ((obj = arguments[i]) !== null) for(name in obj){
            copy = obj[name];
            if (target === copy) continue;
            else if (copy !== undefined) target[name] = copy;
        }
    }
    return target;
}


function $4799dea8e45dcc26$export$79d1167a24e4e930(value) {
    return [
        'true',
        'false'
    ].indexOf(value) >= 0 ? JSON.parse(value) : value;
}


function $a6fdb0b8b417047a$export$1f73f60bdb811cb1(storage, key, value, access) {
    if (access) try {
        storage.setItem(key, value);
    } catch (e) {}
    return value;
}


function $f7227b323e3b8923$export$ff0ccbbb2d1923f6() {
    var id = window.tnsId;
    window.tnsId = !id ? 1 : id + 1;
    return 'tns' + window.tnsId;
}


// get css-calc 
// @return - false | calc | -webkit-calc | -moz-calc
// @usage - var calc = getCalc(); 
function $7a5d93abf8b8280f$export$135b49d4bc2964c6() {
    var doc = document, body = doc.body;
    if (!body) {
        body = doc.createElement('body');
        body.fake = true;
    }
    return body;
}


var $b4893b42cdc90c1b$export$9dfbf2fa8806212d = document.documentElement;


function $7861223fb780632b$export$4078b67b5eba0c5(body) {
    var docOverflow = '';
    if (body.fake) {
        docOverflow = (0, $b4893b42cdc90c1b$export$9dfbf2fa8806212d).style.overflow;
        //avoid crashing IE8, if background image is used
        body.style.background = '';
        //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
        body.style.overflow = (0, $b4893b42cdc90c1b$export$9dfbf2fa8806212d).style.overflow = 'hidden';
        (0, $b4893b42cdc90c1b$export$9dfbf2fa8806212d).appendChild(body);
    }
    return docOverflow;
}



function $977f60019024b413$export$81b27fa331809b9b(body, docOverflow) {
    if (body.fake) {
        body.remove();
        (0, $b4893b42cdc90c1b$export$9dfbf2fa8806212d).style.overflow = docOverflow;
        // Trigger layout so kinetic scrolling isn't disabled in iOS6+
        // eslint-disable-next-line
        (0, $b4893b42cdc90c1b$export$9dfbf2fa8806212d).offsetHeight;
    }
}


function $8993bac9e85610ea$export$42bfa9b2d4dad91a() {
    var doc = document, body = (0, $7a5d93abf8b8280f$export$135b49d4bc2964c6)(), docOverflow = (0, $7861223fb780632b$export$4078b67b5eba0c5)(body), div = doc.createElement('div'), result = false;
    body.appendChild(div);
    try {
        var str = '(10px * 10)', vals = [
            'calc' + str,
            '-moz-calc' + str,
            '-webkit-calc' + str
        ], val;
        for(var i = 0; i < 3; i++){
            val = vals[i];
            div.style.width = val;
            if (div.offsetWidth === 100) {
                result = val.replace(str, '');
                break;
            }
        }
    } catch (e) {}
    body.fake ? (0, $977f60019024b413$export$81b27fa331809b9b)(body, docOverflow) : div.remove();
    return result;
}


// get subpixel support value
// @return - boolean



function $af76b3bdbc0beb2d$export$7b334bfa4e585549() {
    // check subpixel layout supporting
    var doc = document, body = (0, $7a5d93abf8b8280f$export$135b49d4bc2964c6)(), docOverflow = (0, $7861223fb780632b$export$4078b67b5eba0c5)(body), wrapper = doc.createElement('div'), outer = doc.createElement('div'), str = '', count = 70, perPage = 3, supported = false;
    wrapper.className = "tns-t-subp2";
    outer.className = "tns-t-ct";
    for(var i = 0; i < count; i++)str += '<div></div>';
    outer.innerHTML = str;
    wrapper.appendChild(outer);
    body.appendChild(wrapper);
    supported = Math.abs(wrapper.getBoundingClientRect().left - outer.children[count - perPage].getBoundingClientRect().left) < 2;
    body.fake ? (0, $977f60019024b413$export$81b27fa331809b9b)(body, docOverflow) : wrapper.remove();
    return supported;
}





function $f065c0c7b16428ae$export$48976c233ddfebe2() {
    if (window.matchMedia || window.msMatchMedia) return true;
    var doc = document, body = (0, $7a5d93abf8b8280f$export$135b49d4bc2964c6)(), docOverflow = (0, $7861223fb780632b$export$4078b67b5eba0c5)(body), div = doc.createElement('div'), style = doc.createElement('style'), rule = '@media all and (min-width:1px){.tns-mq-test{position:absolute}}', position;
    style.type = 'text/css';
    div.className = 'tns-mq-test';
    body.appendChild(style);
    body.appendChild(div);
    if (style.styleSheet) style.styleSheet.cssText = rule;
    else style.appendChild(doc.createTextNode(rule));
    position = window.getComputedStyle ? window.getComputedStyle(div).position : div.currentStyle['position'];
    body.fake ? (0, $977f60019024b413$export$81b27fa331809b9b)(body, docOverflow) : div.remove();
    return position === "absolute";
}


// create and append style sheet
function $6ebd3c66db551060$export$d07d6a5154e3b470(media, nonce) {
    // Create the <style> tag
    var style = document.createElement("style");
    // style.setAttribute("type", "text/css");
    // Add a media (and/or media query) here if you'd like!
    // style.setAttribute("media", "screen")
    // style.setAttribute("media", "only screen and (max-width : 1024px)")
    if (media) style.setAttribute("media", media);
    // Add nonce attribute for Content Security Policy
    if (nonce) style.setAttribute("nonce", nonce);
    // WebKit hack :(
    // style.appendChild(document.createTextNode(""));
    // Add the <style> element to the page
    document.querySelector('head').appendChild(style);
    return style.sheet ? style.sheet : style.styleSheet;
}


// cross browsers addRule method

function $165497896d877651$export$bf97e331026f75ba(sheet, selector, rules, index) {
    // return raf(function() {
    'insertRule' in sheet ? sheet.insertRule(selector + '{' + rules + '}', index) : sheet.addRule(selector, rules, index);
// });
}


// cross browsers addRule method

function $48d16a7097310590$export$271e480b8a432c4a(sheet, index) {
    // return raf(function() {
    'deleteRule' in sheet ? sheet.deleteRule(index) : sheet.removeRule(index);
// });
}


function $49a424328cfd7aa5$export$ccd7e907f4f59892(sheet) {
    var rule = 'insertRule' in sheet ? sheet.cssRules : sheet.rules;
    return rule.length;
}


function $9e0a1fc4eb27d007$export$c796d9d3e501591f(y, x) {
    return Math.atan2(y, x) * (180 / Math.PI);
}


function $3aceaf0d1e7fe0e6$export$83b6d73568c72b60(angle, range) {
    var direction = false, gap = Math.abs(90 - Math.abs(angle));
    if (gap >= 90 - range) direction = 'horizontal';
    else if (gap <= range) direction = 'vertical';
    return direction;
}


// https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/
function $0016fe9a1a80ca23$export$4b80e395e36b5a56(arr, callback, scope) {
    for(var i = 0, l = arr.length; i < l; i++)callback.call(scope, arr[i], i);
}


var $9fd8b608a0e107e2$export$8b753db5fc454027 = 'classList' in document.createElement('_');


var $90e8c98c0926e0bc$export$4ea3d958472af68f = (0, $9fd8b608a0e107e2$export$8b753db5fc454027) ? function(el, str) {
    return el.classList.contains(str);
} : function(el, str) {
    return el.className.indexOf(str) >= 0;
};



var $1537e8e483cd0adb$export$d2cf6cd1dc7067d3 = (0, $9fd8b608a0e107e2$export$8b753db5fc454027) ? function(el, str) {
    if (!(0, $90e8c98c0926e0bc$export$4ea3d958472af68f)(el, str)) el.classList.add(str);
} : function(el, str) {
    if (!(0, $90e8c98c0926e0bc$export$4ea3d958472af68f)(el, str)) el.className += ' ' + str;
};



var $e1b2571307448ef4$export$c2255604a80b4506 = (0, $9fd8b608a0e107e2$export$8b753db5fc454027) ? function(el, str) {
    if ((0, $90e8c98c0926e0bc$export$4ea3d958472af68f)(el, str)) el.classList.remove(str);
} : function(el, str) {
    if ((0, $90e8c98c0926e0bc$export$4ea3d958472af68f)(el, str)) el.className = el.className.replace(str, '');
};


function $6bd5c05b8d97f320$export$5608640b1bf2f6d7(el, attr) {
    return el.hasAttribute(attr);
}


function $d1a414c0e2953e57$export$6a93fe6b2b4c71a0(el, attr) {
    return el.getAttribute(attr);
}


function $a8cc8ea2cbc1b56c$export$ff45fc08c57bb9d0(el) {
    // Only NodeList has the "item()" function
    return typeof el.item !== "undefined";
}


function $2b2d8f45f82167d8$export$7e45664a2081efb1(els, attrs) {
    els = (0, $a8cc8ea2cbc1b56c$export$ff45fc08c57bb9d0)(els) || els instanceof Array ? els : [
        els
    ];
    if (Object.prototype.toString.call(attrs) !== '[object Object]') return;
    for(var i = els.length; i--;)for(var key in attrs)els[i].setAttribute(key, attrs[key]);
}



function $16dc06620e7b3f06$export$711225beb0f1ef57(els, attrs) {
    els = (0, $a8cc8ea2cbc1b56c$export$ff45fc08c57bb9d0)(els) || els instanceof Array ? els : [
        els
    ];
    attrs = attrs instanceof Array ? attrs : [
        attrs
    ];
    var attrLength = attrs.length;
    for(var i = els.length; i--;)for(var j = attrLength; j--;)els[i].removeAttribute(attrs[j]);
}


function $f61ba20b97b66e8b$export$19b645cc08e75c7c(nl) {
    var arr = [];
    for(var i = 0, l = nl.length; i < l; i++)arr.push(nl[i]);
    return arr;
}


function $f7020e146810fbf6$export$7669482c90f5c50f(el, forceHide) {
    if (el.style.display !== 'none') el.style.display = 'none';
}


function $3c3bbaff0c3b5176$export$998191bfdf710c72(el, forceHide) {
    if (el.style.display === 'none') el.style.display = '';
}


function $338723c44bd3e26e$export$795910f5f15a9633(el) {
    return window.getComputedStyle(el).display !== 'none';
}


function $ad1adb7a8e426484$export$d7ea39ebd37f24a6(props) {
    if (typeof props === 'string') {
        var arr = [
            props
        ], Props = props.charAt(0).toUpperCase() + props.substr(1), prefixes = [
            'Webkit',
            'Moz',
            'ms',
            'O'
        ];
        prefixes.forEach(function(prefix) {
            if (prefix !== 'ms' || props === 'transform') arr.push(prefix + Props);
        });
        props = arr;
    }
    var el = document.createElement('fakeelement'), len = props.length;
    for(var i = 0; i < props.length; i++){
        var prop = props[i];
        if (el.style[prop] !== undefined) return prop;
    }
    return false; // explicit for ie9-
}





function $a0ebbae82532dba4$export$c0585cbcaae92b06(tf) {
    if (!tf) return false;
    if (!window.getComputedStyle) return false;
    var doc = document, body = (0, $7a5d93abf8b8280f$export$135b49d4bc2964c6)(), docOverflow = (0, $7861223fb780632b$export$4078b67b5eba0c5)(body), el = doc.createElement('p'), has3d, cssTF = tf.length > 9 ? '-' + tf.slice(0, -9).toLowerCase() + '-' : '';
    cssTF += 'transform';
    // Add it to the body to get the computed style
    body.insertBefore(el, null);
    el.style[tf] = 'translate3d(1px,1px,1px)';
    has3d = window.getComputedStyle(el).getPropertyValue(cssTF);
    body.fake ? (0, $977f60019024b413$export$81b27fa331809b9b)(body, docOverflow) : el.remove();
    return has3d !== undefined && has3d.length > 0 && has3d !== "none";
}


// get transitionend, animationend based on transitionDuration
// @propin: string
// @propOut: string, first-letter uppercase
// Usage: getEndProperty('WebkitTransitionDuration', 'Transition') => webkitTransitionEnd
function $0e6c2df2bef727d5$export$41e71ffeacbff65e(propIn, propOut) {
    var endProp = false;
    if (/^Webkit/.test(propIn)) endProp = 'webkit' + propOut + 'End';
    else if (/^O/.test(propIn)) endProp = 'o' + propOut + 'End';
    else if (propIn) endProp = propOut.toLowerCase() + 'end';
    return endProp;
}


// Test via a getter in the options object to see if the passive property is accessed
var $ea367e53af636b20$var$supportsPassive = false;
try {
    var $ea367e53af636b20$var$opts = Object.defineProperty({}, 'passive', {
        get: function() {
            $ea367e53af636b20$var$supportsPassive = true;
        }
    });
    window.addEventListener("test", null, $ea367e53af636b20$var$opts);
} catch (e) {}
var $ea367e53af636b20$export$555390bf67cc3262 = $ea367e53af636b20$var$supportsPassive ? {
    passive: true
} : false;


function $4e0f640ba853a3f9$export$aadfb65bee660f96(el, obj, preventScrolling) {
    for(var prop in obj){
        var option = [
            'touchstart',
            'touchmove'
        ].indexOf(prop) >= 0 && !preventScrolling ? (0, $ea367e53af636b20$export$555390bf67cc3262) : false;
        el.addEventListener(prop, obj[prop], option);
    }
}



function $5bed4e13e408472c$export$da5f6eb3bb522cd(el, obj) {
    for(var prop in obj){
        var option = [
            'touchstart',
            'touchmove'
        ].indexOf(prop) >= 0 ? (0, $ea367e53af636b20$export$555390bf67cc3262) : false;
        el.removeEventListener(prop, obj[prop], option);
    }
}


function $7b7c9118f958f117$export$ada873a34909da65() {
    return {
        topics: {},
        on: function(eventName, fn) {
            this.topics[eventName] = this.topics[eventName] || [];
            this.topics[eventName].push(fn);
        },
        off: function(eventName, fn) {
            if (this.topics[eventName]) {
                for(var i = 0; i < this.topics[eventName].length; i++)if (this.topics[eventName][i] === fn) {
                    this.topics[eventName].splice(i, 1);
                    break;
                }
            }
        },
        emit: function(eventName, data) {
            data.type = eventName;
            if (this.topics[eventName]) this.topics[eventName].forEach(function(fn) {
                fn(data, eventName);
            });
        }
    };
}


function $731f08330d51af49$export$e2705a83c013f564(element, attr, prefix, postfix, to, duration, callback) {
    var tick = Math.min(duration, 10), unit = to.indexOf('%') >= 0 ? '%' : 'px', to = to.replace(unit, ''), from = Number(element.style[attr].replace(prefix, '').replace(postfix, '').replace(unit, '')), positionTick = (to - from) / duration * tick, running;
    setTimeout(moveElement, tick);
    function moveElement() {
        duration -= tick;
        from += positionTick;
        element.style[attr] = prefix + from + unit + postfix;
        if (duration > 0) setTimeout(moveElement, tick);
        else callback();
    }
}


if (!Object.keys) Object.keys = function(object) {
    var keys = [];
    for(var name in object)if (Object.prototype.hasOwnProperty.call(object, name)) keys.push(name);
    return keys;
};
// ChildNode.remove
if (!("remove" in Element.prototype)) Element.prototype.remove = function() {
    if (this.parentNode) this.parentNode.removeChild(this);
};
var $dc7cb0956330e818$export$51fe319e24d9d8c9 = function(options) {
    options = (0, $2f74ee940b1656a2$export$8b58be045bf06082)({
        container: '.slider',
        mode: 'carousel',
        axis: 'horizontal',
        items: 1,
        gutter: 0,
        edgePadding: 0,
        fixedWidth: false,
        autoWidth: false,
        viewportMax: false,
        slideBy: 1,
        center: false,
        controls: true,
        controlsPosition: 'top',
        controlsText: [
            'prev',
            'next'
        ],
        controlsContainer: false,
        prevButton: false,
        nextButton: false,
        nav: true,
        navPosition: 'top',
        navContainer: false,
        navAsThumbnails: false,
        arrowKeys: false,
        speed: 300,
        autoplay: false,
        autoplayPosition: 'top',
        autoplayTimeout: 5000,
        autoplayDirection: 'forward',
        autoplayText: [
            'start',
            'stop'
        ],
        autoplayHoverPause: false,
        autoplayButton: false,
        autoplayButtonOutput: true,
        autoplayResetOnVisibility: true,
        animateIn: 'tns-fadeIn',
        animateOut: 'tns-fadeOut',
        animateNormal: 'tns-normal',
        animateDelay: false,
        loop: true,
        rewind: false,
        autoHeight: false,
        responsive: false,
        lazyload: false,
        lazyloadSelector: '.tns-lazy-img',
        touch: true,
        mouseDrag: false,
        swipeAngle: 15,
        nested: false,
        preventActionWhenRunning: false,
        preventScrollOnTouch: false,
        freezable: true,
        onInit: false,
        useLocalStorage: true,
        nonce: false
    }, options || {});
    var doc = document, win = window, KEYS = {
        ENTER: 13,
        SPACE: 32,
        LEFT: 37,
        RIGHT: 39
    }, tnsStorage = {}, localStorageAccess = options.useLocalStorage;
    if (localStorageAccess) {
        // check browser version and local storage access
        var browserInfo = navigator.userAgent;
        var uid = new Date;
        try {
            tnsStorage = win.localStorage;
            if (tnsStorage) {
                tnsStorage.setItem(uid, uid);
                localStorageAccess = tnsStorage.getItem(uid) == uid;
                tnsStorage.removeItem(uid);
            } else localStorageAccess = false;
            if (!localStorageAccess) tnsStorage = {};
        } catch (e) {
            localStorageAccess = false;
        }
        if (localStorageAccess) {
            // remove storage when browser version changes
            if (tnsStorage['tnsApp'] && tnsStorage['tnsApp'] !== browserInfo) [
                'tC',
                'tPL',
                'tMQ',
                'tTf',
                't3D',
                'tTDu',
                'tTDe',
                'tADu',
                'tADe',
                'tTE',
                'tAE'
            ].forEach(function(item) {
                tnsStorage.removeItem(item);
            });
            // update browserInfo
            localStorage['tnsApp'] = browserInfo;
        }
    }
    var CALC = tnsStorage['tC'] ? (0, $4799dea8e45dcc26$export$79d1167a24e4e930)(tnsStorage['tC']) : (0, $a6fdb0b8b417047a$export$1f73f60bdb811cb1)(tnsStorage, 'tC', (0, $8993bac9e85610ea$export$42bfa9b2d4dad91a)(), localStorageAccess), PERCENTAGELAYOUT = tnsStorage['tPL'] ? (0, $4799dea8e45dcc26$export$79d1167a24e4e930)(tnsStorage['tPL']) : (0, $a6fdb0b8b417047a$export$1f73f60bdb811cb1)(tnsStorage, 'tPL', (0, $af76b3bdbc0beb2d$export$7b334bfa4e585549)(), localStorageAccess), CSSMQ = tnsStorage['tMQ'] ? (0, $4799dea8e45dcc26$export$79d1167a24e4e930)(tnsStorage['tMQ']) : (0, $a6fdb0b8b417047a$export$1f73f60bdb811cb1)(tnsStorage, 'tMQ', (0, $f065c0c7b16428ae$export$48976c233ddfebe2)(), localStorageAccess), TRANSFORM = tnsStorage['tTf'] ? (0, $4799dea8e45dcc26$export$79d1167a24e4e930)(tnsStorage['tTf']) : (0, $a6fdb0b8b417047a$export$1f73f60bdb811cb1)(tnsStorage, 'tTf', (0, $ad1adb7a8e426484$export$d7ea39ebd37f24a6)('transform'), localStorageAccess), HAS3DTRANSFORMS = tnsStorage['t3D'] ? (0, $4799dea8e45dcc26$export$79d1167a24e4e930)(tnsStorage['t3D']) : (0, $a6fdb0b8b417047a$export$1f73f60bdb811cb1)(tnsStorage, 't3D', (0, $a0ebbae82532dba4$export$c0585cbcaae92b06)(TRANSFORM), localStorageAccess), TRANSITIONDURATION = tnsStorage['tTDu'] ? (0, $4799dea8e45dcc26$export$79d1167a24e4e930)(tnsStorage['tTDu']) : (0, $a6fdb0b8b417047a$export$1f73f60bdb811cb1)(tnsStorage, 'tTDu', (0, $ad1adb7a8e426484$export$d7ea39ebd37f24a6)('transitionDuration'), localStorageAccess), TRANSITIONDELAY = tnsStorage['tTDe'] ? (0, $4799dea8e45dcc26$export$79d1167a24e4e930)(tnsStorage['tTDe']) : (0, $a6fdb0b8b417047a$export$1f73f60bdb811cb1)(tnsStorage, 'tTDe', (0, $ad1adb7a8e426484$export$d7ea39ebd37f24a6)('transitionDelay'), localStorageAccess), ANIMATIONDURATION = tnsStorage['tADu'] ? (0, $4799dea8e45dcc26$export$79d1167a24e4e930)(tnsStorage['tADu']) : (0, $a6fdb0b8b417047a$export$1f73f60bdb811cb1)(tnsStorage, 'tADu', (0, $ad1adb7a8e426484$export$d7ea39ebd37f24a6)('animationDuration'), localStorageAccess), ANIMATIONDELAY = tnsStorage['tADe'] ? (0, $4799dea8e45dcc26$export$79d1167a24e4e930)(tnsStorage['tADe']) : (0, $a6fdb0b8b417047a$export$1f73f60bdb811cb1)(tnsStorage, 'tADe', (0, $ad1adb7a8e426484$export$d7ea39ebd37f24a6)('animationDelay'), localStorageAccess), TRANSITIONEND = tnsStorage['tTE'] ? (0, $4799dea8e45dcc26$export$79d1167a24e4e930)(tnsStorage['tTE']) : (0, $a6fdb0b8b417047a$export$1f73f60bdb811cb1)(tnsStorage, 'tTE', (0, $0e6c2df2bef727d5$export$41e71ffeacbff65e)(TRANSITIONDURATION, 'Transition'), localStorageAccess), ANIMATIONEND = tnsStorage['tAE'] ? (0, $4799dea8e45dcc26$export$79d1167a24e4e930)(tnsStorage['tAE']) : (0, $a6fdb0b8b417047a$export$1f73f60bdb811cb1)(tnsStorage, 'tAE', (0, $0e6c2df2bef727d5$export$41e71ffeacbff65e)(ANIMATIONDURATION, 'Animation'), localStorageAccess);
    // get element nodes from selectors
    var supportConsoleWarn = win.console && typeof win.console.warn === "function", tnsList = [
        'container',
        'controlsContainer',
        'prevButton',
        'nextButton',
        'navContainer',
        'autoplayButton'
    ], optionsElements = {};
    tnsList.forEach(function(item) {
        if (typeof options[item] === 'string') {
            var str = options[item], el = doc.querySelector(str);
            optionsElements[item] = str;
            if (el && el.nodeName) options[item] = el;
            else {
                if (supportConsoleWarn) console.warn('Can\'t find', options[item]);
                return;
            }
        }
    });
    // make sure at least 1 slide
    if (options.container.children.length < 1) {
        if (supportConsoleWarn) console.warn('No slides found in', options.container);
        return;
    }
    // update options
    var responsive = options.responsive, nested = options.nested, carousel = options.mode === 'carousel' ? true : false;
    if (responsive) {
        // apply responsive[0] to options and remove it
        if (0 in responsive) {
            options = (0, $2f74ee940b1656a2$export$8b58be045bf06082)(options, responsive[0]);
            delete responsive[0];
        }
        var responsiveTem = {};
        for(var key in responsive){
            var val = responsive[key];
            // update responsive
            // from: 300: 2
            // to:
            //   300: {
            //     items: 2
            //   }
            val = typeof val === 'number' ? {
                items: val
            } : val;
            responsiveTem[key] = val;
        }
        responsive = responsiveTem;
        responsiveTem = null;
    }
    // update options
    function updateOptions(obj) {
        for(var key in obj){
            if (!carousel) {
                if (key === 'slideBy') obj[key] = 'page';
                if (key === 'edgePadding') obj[key] = false;
                if (key === 'autoHeight') obj[key] = false;
            }
            // update responsive options
            if (key === 'responsive') updateOptions(obj[key]);
        }
    }
    if (!carousel) updateOptions(options);
    // === define and set variables ===
    if (!carousel) {
        options.axis = 'horizontal';
        options.slideBy = 'page';
        options.edgePadding = false;
        var animateIn = options.animateIn, animateOut = options.animateOut, animateDelay = options.animateDelay, animateNormal = options.animateNormal;
    }
    var horizontal = options.axis === 'horizontal' ? true : false, outerWrapper = doc.createElement('div'), innerWrapper = doc.createElement('div'), middleWrapper, container = options.container, containerParent = container.parentNode, containerHTML = container.outerHTML, slideItems = container.children, slideCount = slideItems.length, breakpointZone, windowWidth = getWindowWidth(), isOn = false;
    if (responsive) setBreakpointZone();
    if (carousel) container.className += ' tns-vpfix';
    // fixedWidth: viewport > rightBoundary > indexMax
    var autoWidth = options.autoWidth, fixedWidth = getOption('fixedWidth'), edgePadding = getOption('edgePadding'), gutter = getOption('gutter'), viewport = getViewportWidth(), center = getOption('center'), items = !autoWidth ? Math.floor(getOption('items')) : 1, slideBy = getOption('slideBy'), viewportMax = options.viewportMax || options.fixedWidthViewportWidth, arrowKeys = getOption('arrowKeys'), speed = getOption('speed'), rewind = options.rewind, loop = rewind ? false : options.loop, autoHeight = getOption('autoHeight'), controls = getOption('controls'), controlsText = getOption('controlsText'), nav = getOption('nav'), touch = getOption('touch'), mouseDrag = getOption('mouseDrag'), autoplay = getOption('autoplay'), autoplayTimeout = getOption('autoplayTimeout'), autoplayText = getOption('autoplayText'), autoplayHoverPause = getOption('autoplayHoverPause'), autoplayResetOnVisibility = getOption('autoplayResetOnVisibility'), sheet = (0, $6ebd3c66db551060$export$d07d6a5154e3b470)(null, getOption('nonce')), lazyload = options.lazyload, lazyloadSelector = options.lazyloadSelector, slidePositions, slideItemsOut = [], cloneCount = loop ? getCloneCountForLoop() : 0, slideCountNew = !carousel ? slideCount + cloneCount : slideCount + cloneCount * 2, hasRightDeadZone = (fixedWidth || autoWidth) && !loop ? true : false, rightBoundary = fixedWidth ? getRightBoundary() : null, updateIndexBeforeTransform = !carousel || !loop ? true : false, // transform
    transformAttr = horizontal ? 'left' : 'top', transformPrefix = '', transformPostfix = '', // index
    getIndexMax = function() {
        if (fixedWidth) return function() {
            return center && !loop ? slideCount - 1 : Math.ceil(-rightBoundary / (fixedWidth + gutter));
        };
        else if (autoWidth) return function() {
            for(var i = 0; i < slideCountNew; i++){
                if (slidePositions[i] >= -rightBoundary) return i;
            }
        };
        else return function() {
            if (center && carousel && !loop) return slideCount - 1;
            else return loop || carousel ? Math.max(0, slideCountNew - Math.ceil(items)) : slideCountNew - 1;
        };
    }(), index = getStartIndex(getOption('startIndex')), indexCached = index, displayIndex = getCurrentSlide(), indexMin = 0, indexMax = !autoWidth ? getIndexMax() : null, // resize
    resizeTimer, preventActionWhenRunning = options.preventActionWhenRunning, swipeAngle = options.swipeAngle, moveDirectionExpected = swipeAngle ? '?' : true, running = false, onInit = options.onInit, events = new (0, $7b7c9118f958f117$export$ada873a34909da65)(), // id, class
    newContainerClasses = ' tns-slider tns-' + options.mode, slideId = container.id || (0, $f7227b323e3b8923$export$ff0ccbbb2d1923f6)(), disable = getOption('disable'), disabled = false, freezable = options.freezable, freeze = freezable && !autoWidth ? getFreeze() : false, frozen = false, controlsEvents = {
        'click': onControlsClick,
        'keydown': onControlsKeydown
    }, navEvents = {
        'click': onNavClick,
        'keydown': onNavKeydown
    }, hoverEvents = {
        'mouseover': mouseoverPause,
        'mouseout': mouseoutRestart
    }, visibilityEvent = {
        'visibilitychange': onVisibilityChange
    }, docmentKeydownEvent = {
        'keydown': onDocumentKeydown
    }, touchEvents = {
        'touchstart': onPanStart,
        'touchmove': onPanMove,
        'touchend': onPanEnd,
        'touchcancel': onPanEnd
    }, dragEvents = {
        'mousedown': onPanStart,
        'mousemove': onPanMove,
        'mouseup': onPanEnd,
        'mouseleave': onPanEnd
    }, hasControls = hasOption('controls'), hasNav = hasOption('nav'), navAsThumbnails = autoWidth ? true : options.navAsThumbnails, hasAutoplay = hasOption('autoplay'), hasTouch = hasOption('touch'), hasMouseDrag = hasOption('mouseDrag'), slideActiveClass = 'tns-slide-active', slideClonedClass = 'tns-slide-cloned', imgCompleteClass = 'tns-complete', imgEvents = {
        'load': onImgLoaded,
        'error': onImgFailed
    }, imgsComplete, liveregionCurrent, preventScroll = options.preventScrollOnTouch === 'force' ? true : false;
    // controls
    if (hasControls) var controlsContainer = options.controlsContainer, controlsContainerHTML = options.controlsContainer ? options.controlsContainer.outerHTML : '', prevButton = options.prevButton, nextButton = options.nextButton, prevButtonHTML = options.prevButton ? options.prevButton.outerHTML : '', nextButtonHTML = options.nextButton ? options.nextButton.outerHTML : '', prevIsButton, nextIsButton;
    // nav
    if (hasNav) var navContainer = options.navContainer, navContainerHTML = options.navContainer ? options.navContainer.outerHTML : '', navItems, pages = autoWidth ? slideCount : getPages(), pagesCached = 0, navClicked = -1, navCurrentIndex = getCurrentNavIndex(), navCurrentIndexCached = navCurrentIndex, navActiveClass = 'tns-nav-active', navStr = 'Carousel Page ', navStrCurrent = ' (Current Slide)';
    // autoplay
    if (hasAutoplay) var autoplayDirection = options.autoplayDirection === 'forward' ? 1 : -1, autoplayButton = options.autoplayButton, autoplayButtonHTML = options.autoplayButton ? options.autoplayButton.outerHTML : '', autoplayHtmlStrings = [
        '<span class=\'tns-visually-hidden\'>',
        ' animation</span>'
    ], autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused;
    if (hasTouch || hasMouseDrag) var initPosition = {}, lastPosition = {}, translateInit, disX, disY, panStart = false, rafIndex, getDist = horizontal ? function(a, b) {
        return a.x - b.x;
    } : function(a, b) {
        return a.y - b.y;
    };
    // disable slider when slidecount <= items
    if (!autoWidth) resetVariblesWhenDisable(disable || freeze);
    if (TRANSFORM) {
        transformAttr = TRANSFORM;
        transformPrefix = 'translate';
        if (HAS3DTRANSFORMS) {
            transformPrefix += horizontal ? '3d(' : '3d(0px, ';
            transformPostfix = horizontal ? ', 0px, 0px)' : ', 0px)';
        } else {
            transformPrefix += horizontal ? 'X(' : 'Y(';
            transformPostfix = ')';
        }
    }
    if (carousel) container.className = container.className.replace('tns-vpfix', '');
    initStructure();
    initSheet();
    initSliderTransform();
    // === COMMON FUNCTIONS === //
    function resetVariblesWhenDisable(condition) {
        if (condition) controls = nav = touch = mouseDrag = arrowKeys = autoplay = autoplayHoverPause = autoplayResetOnVisibility = false;
    }
    function getCurrentSlide() {
        var tem = carousel ? index - cloneCount : index;
        while(tem < 0)tem += slideCount;
        return tem % slideCount + 1;
    }
    function getStartIndex(ind) {
        ind = ind ? Math.max(0, Math.min(loop ? slideCount - 1 : slideCount - items, ind)) : 0;
        return carousel ? ind + cloneCount : ind;
    }
    function getAbsIndex(i) {
        if (i == null) i = index;
        if (carousel) i -= cloneCount;
        while(i < 0)i += slideCount;
        return Math.floor(i % slideCount);
    }
    function getCurrentNavIndex() {
        var absIndex = getAbsIndex(), result;
        result = navAsThumbnails ? absIndex : fixedWidth || autoWidth ? Math.ceil((absIndex + 1) * pages / slideCount - 1) : Math.floor(absIndex / items);
        // set active nav to the last one when reaches the right edge
        if (!loop && carousel && index === indexMax) result = pages - 1;
        return result;
    }
    function getItemsMax() {
        // fixedWidth or autoWidth while viewportMax is not available
        if (autoWidth || fixedWidth && !viewportMax) return slideCount - 1;
        else {
            var str = fixedWidth ? 'fixedWidth' : 'items', arr = [];
            if (fixedWidth || options[str] < slideCount) arr.push(options[str]);
            if (responsive) for(var bp in responsive){
                var tem = responsive[bp][str];
                if (tem && (fixedWidth || tem < slideCount)) arr.push(tem);
            }
            if (!arr.length) arr.push(0);
            return Math.ceil(fixedWidth ? viewportMax / Math.min.apply(null, arr) : Math.max.apply(null, arr));
        }
    }
    function getCloneCountForLoop() {
        var itemsMax = getItemsMax(), result = carousel ? Math.ceil((itemsMax * 5 - slideCount) / 2) : itemsMax * 4 - slideCount;
        result = Math.max(itemsMax, result);
        return hasOption('edgePadding') ? result + 1 : result;
    }
    function getWindowWidth() {
        return win.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
    }
    function getInsertPosition(pos) {
        return pos === 'top' ? 'afterbegin' : 'beforeend';
    }
    function getClientWidth(el) {
        if (el == null) return;
        var div = doc.createElement('div'), rect, width;
        el.appendChild(div);
        rect = div.getBoundingClientRect();
        width = rect.right - rect.left;
        div.remove();
        return width || getClientWidth(el.parentNode);
    }
    function getViewportWidth() {
        var gap = edgePadding ? edgePadding * 2 - gutter : 0;
        return getClientWidth(containerParent) - gap;
    }
    function hasOption(item) {
        if (options[item]) return true;
        else {
            if (responsive) for(var bp in responsive){
                if (responsive[bp][item]) return true;
            }
            return false;
        }
    }
    // get option:
    // fixed width: viewport, fixedWidth, gutter => items
    // others: window width => all variables
    // all: items => slideBy
    function getOption(item, ww) {
        if (ww == null) ww = windowWidth;
        if (item === 'items' && fixedWidth) return Math.floor((viewport + gutter) / (fixedWidth + gutter)) || 1;
        else {
            var result = options[item];
            if (responsive) for(var bp in responsive){
                // bp: convert string to number
                if (ww >= parseInt(bp)) {
                    if (item in responsive[bp]) result = responsive[bp][item];
                }
            }
            if (item === 'slideBy' && result === 'page') result = getOption('items');
            if (!carousel && (item === 'slideBy' || item === 'items')) result = Math.floor(result);
            return result;
        }
    }
    function getSlideMarginLeft(i) {
        return CALC ? CALC + '(' + i * 100 + '% / ' + slideCountNew + ')' : i * 100 / slideCountNew + '%';
    }
    function getInnerWrapperStyles(edgePaddingTem, gutterTem, fixedWidthTem, speedTem, autoHeightBP) {
        var str = '';
        if (edgePaddingTem !== undefined) {
            var gap = edgePaddingTem;
            if (gutterTem) gap -= gutterTem;
            str = horizontal ? 'margin: 0 ' + gap + 'px 0 ' + edgePaddingTem + 'px;' : 'margin: ' + edgePaddingTem + 'px 0 ' + gap + 'px 0;';
        } else if (gutterTem && !fixedWidthTem) {
            var gutterTemUnit = '-' + gutterTem + 'px', dir = horizontal ? gutterTemUnit + ' 0 0' : '0 ' + gutterTemUnit + ' 0';
            str = 'margin: 0 ' + dir + ';';
        }
        if (!carousel && autoHeightBP && TRANSITIONDURATION && speedTem) str += getTransitionDurationStyle(speedTem);
        return str;
    }
    function getContainerWidth(fixedWidthTem, gutterTem, itemsTem) {
        if (fixedWidthTem) return (fixedWidthTem + gutterTem) * slideCountNew + 'px';
        else return CALC ? CALC + '(' + slideCountNew * 100 + '% / ' + itemsTem + ')' : slideCountNew * 100 / itemsTem + '%';
    }
    function getSlideWidthStyle(fixedWidthTem, gutterTem, itemsTem) {
        var width;
        if (fixedWidthTem) width = fixedWidthTem + gutterTem + 'px';
        else {
            if (!carousel) itemsTem = Math.floor(itemsTem);
            var dividend = carousel ? slideCountNew : itemsTem;
            width = CALC ? CALC + '(100% / ' + dividend + ')' : 100 / dividend + '%';
        }
        width = 'width:' + width;
        // inner slider: overwrite outer slider styles
        return nested !== 'inner' ? width + ';' : width + ' !important;';
    }
    function getSlideGutterStyle(gutterTem) {
        var str = '';
        // gutter maybe interger || 0
        // so can't use 'if (gutter)'
        if (gutterTem !== false) {
            var prop = horizontal ? 'padding-' : 'margin-', dir = horizontal ? 'right' : 'bottom';
            str = prop + dir + ': ' + gutterTem + 'px;';
        }
        return str;
    }
    function getCSSPrefix(name, num) {
        var prefix = name.substring(0, name.length - num).toLowerCase();
        if (prefix) prefix = '-' + prefix + '-';
        return prefix;
    }
    function getTransitionDurationStyle(speed) {
        return getCSSPrefix(TRANSITIONDURATION, 18) + 'transition-duration:' + speed / 1000 + 's;';
    }
    function getAnimationDurationStyle(speed) {
        return getCSSPrefix(ANIMATIONDURATION, 17) + 'animation-duration:' + speed / 1000 + 's;';
    }
    function initStructure() {
        var classOuter = 'tns-outer', classInner = 'tns-inner', hasGutter = hasOption('gutter');
        outerWrapper.className = classOuter;
        innerWrapper.className = classInner;
        outerWrapper.id = slideId + '-ow';
        innerWrapper.id = slideId + '-iw';
        // set container properties
        if (container.id === '') container.id = slideId;
        newContainerClasses += PERCENTAGELAYOUT || autoWidth ? ' tns-subpixel' : ' tns-no-subpixel';
        newContainerClasses += CALC ? ' tns-calc' : ' tns-no-calc';
        if (autoWidth) newContainerClasses += ' tns-autowidth';
        newContainerClasses += ' tns-' + options.axis;
        container.className += newContainerClasses;
        // add constrain layer for carousel
        if (carousel) {
            middleWrapper = doc.createElement('div');
            middleWrapper.id = slideId + '-mw';
            middleWrapper.className = 'tns-ovh';
            outerWrapper.appendChild(middleWrapper);
            middleWrapper.appendChild(innerWrapper);
        } else outerWrapper.appendChild(innerWrapper);
        if (autoHeight) {
            var wp = middleWrapper ? middleWrapper : innerWrapper;
            wp.className += ' tns-ah';
        }
        containerParent.insertBefore(outerWrapper, container);
        innerWrapper.appendChild(container);
        // add id, class, aria attributes
        // before clone slides
        (0, $0016fe9a1a80ca23$export$4b80e395e36b5a56)(slideItems, function(item, i) {
            (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(item, 'tns-item');
            if (!item.id) item.id = slideId + '-item' + i;
            if (!carousel && animateNormal) (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(item, animateNormal);
            (0, $2b2d8f45f82167d8$export$7e45664a2081efb1)(item, {
                'aria-hidden': 'true',
                'tabindex': '-1'
            });
        });
        // ## clone slides
        // carousel: n + slides + n
        // gallery:      slides + n
        if (cloneCount) {
            var fragmentBefore = doc.createDocumentFragment(), fragmentAfter = doc.createDocumentFragment();
            for(var j = cloneCount; j--;){
                var num = j % slideCount, cloneFirst = slideItems[num].cloneNode(true);
                (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(cloneFirst, slideClonedClass);
                (0, $16dc06620e7b3f06$export$711225beb0f1ef57)(cloneFirst, 'id');
                fragmentAfter.insertBefore(cloneFirst, fragmentAfter.firstChild);
                if (carousel) {
                    var cloneLast = slideItems[slideCount - 1 - num].cloneNode(true);
                    (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(cloneLast, slideClonedClass);
                    (0, $16dc06620e7b3f06$export$711225beb0f1ef57)(cloneLast, 'id');
                    fragmentBefore.appendChild(cloneLast);
                }
            }
            container.insertBefore(fragmentBefore, container.firstChild);
            container.appendChild(fragmentAfter);
            slideItems = container.children;
        }
    }
    function initSliderTransform() {
        // ## images loaded/failed
        if (hasOption('autoHeight') || autoWidth || !horizontal) {
            var imgs = container.querySelectorAll('img');
            // add img load event listener
            (0, $0016fe9a1a80ca23$export$4b80e395e36b5a56)(imgs, function(img) {
                var src = img.src;
                if (!lazyload) {
                    // not data img
                    if (src && src.indexOf('data:image') < 0) {
                        img.src = '';
                        (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(img, imgEvents);
                        (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(img, 'loading');
                        img.src = src;
                    // data img
                    } else imgLoaded(img);
                }
            });
            // set imgsComplete
            (0, $76143cc5646b0a4d$export$27f233d61a9e2fa4)(function() {
                imgsLoadedCheck((0, $f61ba20b97b66e8b$export$19b645cc08e75c7c)(imgs), function() {
                    imgsComplete = true;
                });
            });
            // reset imgs for auto height: check visible imgs only
            if (hasOption('autoHeight')) imgs = getImageArray(index, Math.min(index + items - 1, slideCountNew - 1));
            lazyload ? initSliderTransformStyleCheck() : (0, $76143cc5646b0a4d$export$27f233d61a9e2fa4)(function() {
                imgsLoadedCheck((0, $f61ba20b97b66e8b$export$19b645cc08e75c7c)(imgs), initSliderTransformStyleCheck);
            });
        } else {
            // set container transform property
            if (carousel) doContainerTransformSilent();
            // update slider tools and events
            initTools();
            initEvents();
        }
    }
    function initSliderTransformStyleCheck() {
        if (autoWidth && slideCount > 1) {
            // check styles application
            var num = loop ? index : slideCount - 1;
            (function stylesApplicationCheck() {
                var left = slideItems[num].getBoundingClientRect().left;
                var right = slideItems[num - 1].getBoundingClientRect().right;
                Math.abs(left - right) <= 1 ? initSliderTransformCore() : setTimeout(function() {
                    stylesApplicationCheck();
                }, 16);
            })();
        } else initSliderTransformCore();
    }
    function initSliderTransformCore() {
        // run Fn()s which are rely on image loading
        if (!horizontal || autoWidth) {
            setSlidePositions();
            if (autoWidth) {
                rightBoundary = getRightBoundary();
                if (freezable) freeze = getFreeze();
                indexMax = getIndexMax(); // <= slidePositions, rightBoundary <=
                resetVariblesWhenDisable(disable || freeze);
            } else updateContentWrapperHeight();
        }
        // set container transform property
        if (carousel) doContainerTransformSilent();
        // update slider tools and events
        initTools();
        initEvents();
    }
    function initSheet() {
        // gallery:
        // set animation classes and left value for gallery slider
        if (!carousel) for(var i = index, l = index + Math.min(slideCount, items); i < l; i++){
            var item = slideItems[i];
            item.style.left = (i - index) * 100 / items + '%';
            (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(item, animateIn);
            (0, $e1b2571307448ef4$export$c2255604a80b4506)(item, animateNormal);
        }
        // #### LAYOUT
        // ## INLINE-BLOCK VS FLOAT
        // ## PercentageLayout:
        // slides: inline-block
        // remove blank space between slides by set font-size: 0
        // ## Non PercentageLayout:
        // slides: float
        //         margin-right: -100%
        //         margin-left: ~
        // Resource: https://docs.google.com/spreadsheets/d/147up245wwTXeQYve3BRSAD4oVcvQmuGsFteJOeA5xNQ/edit?usp=sharing
        if (horizontal) {
            if (PERCENTAGELAYOUT || autoWidth) {
                (0, $165497896d877651$export$bf97e331026f75ba)(sheet, '#' + slideId + ' > .tns-item', 'font-size:' + win.getComputedStyle(slideItems[0]).fontSize + ';', (0, $49a424328cfd7aa5$export$ccd7e907f4f59892)(sheet));
                (0, $165497896d877651$export$bf97e331026f75ba)(sheet, '#' + slideId, 'font-size:0;', (0, $49a424328cfd7aa5$export$ccd7e907f4f59892)(sheet));
            } else if (carousel) (0, $0016fe9a1a80ca23$export$4b80e395e36b5a56)(slideItems, function(slide, i) {
                slide.style.marginLeft = getSlideMarginLeft(i);
            });
        }
        // ## BASIC STYLES
        if (CSSMQ) {
            // middle wrapper style
            if (TRANSITIONDURATION) {
                var str = middleWrapper && options.autoHeight ? getTransitionDurationStyle(options.speed) : '';
                (0, $165497896d877651$export$bf97e331026f75ba)(sheet, '#' + slideId + '-mw', str, (0, $49a424328cfd7aa5$export$ccd7e907f4f59892)(sheet));
            }
            // inner wrapper styles
            str = getInnerWrapperStyles(options.edgePadding, options.gutter, options.fixedWidth, options.speed, options.autoHeight);
            (0, $165497896d877651$export$bf97e331026f75ba)(sheet, '#' + slideId + '-iw', str, (0, $49a424328cfd7aa5$export$ccd7e907f4f59892)(sheet));
            // container styles
            if (carousel) {
                str = horizontal && !autoWidth ? 'width:' + getContainerWidth(options.fixedWidth, options.gutter, options.items) + ';' : '';
                if (TRANSITIONDURATION) str += getTransitionDurationStyle(speed);
                (0, $165497896d877651$export$bf97e331026f75ba)(sheet, '#' + slideId, str, (0, $49a424328cfd7aa5$export$ccd7e907f4f59892)(sheet));
            }
            // slide styles
            str = horizontal && !autoWidth ? getSlideWidthStyle(options.fixedWidth, options.gutter, options.items) : '';
            if (options.gutter) str += getSlideGutterStyle(options.gutter);
            // set gallery items transition-duration
            if (!carousel) {
                if (TRANSITIONDURATION) str += getTransitionDurationStyle(speed);
                if (ANIMATIONDURATION) str += getAnimationDurationStyle(speed);
            }
            if (str) (0, $165497896d877651$export$bf97e331026f75ba)(sheet, '#' + slideId + ' > .tns-item', str, (0, $49a424328cfd7aa5$export$ccd7e907f4f59892)(sheet));
        // non CSS mediaqueries: IE8
        // ## update inner wrapper, container, slides if needed
        // set inline styles for inner wrapper & container
        // insert stylesheet (one line) for slides only (since slides are many)
        } else {
            // middle wrapper styles
            update_carousel_transition_duration();
            // inner wrapper styles
            innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, autoHeight);
            // container styles
            if (carousel && horizontal && !autoWidth) container.style.width = getContainerWidth(fixedWidth, gutter, items);
            // slide styles
            var str = horizontal && !autoWidth ? getSlideWidthStyle(fixedWidth, gutter, items) : '';
            if (gutter) str += getSlideGutterStyle(gutter);
            // append to the last line
            if (str) (0, $165497896d877651$export$bf97e331026f75ba)(sheet, '#' + slideId + ' > .tns-item', str, (0, $49a424328cfd7aa5$export$ccd7e907f4f59892)(sheet));
        }
        // ## MEDIAQUERIES
        if (responsive && CSSMQ) for(var bp in responsive){
            // bp: convert string to number
            bp = parseInt(bp);
            var opts = responsive[bp], str = '', middleWrapperStr = '', innerWrapperStr = '', containerStr = '', slideStr = '', itemsBP = !autoWidth ? getOption('items', bp) : null, fixedWidthBP = getOption('fixedWidth', bp), speedBP = getOption('speed', bp), edgePaddingBP = getOption('edgePadding', bp), autoHeightBP = getOption('autoHeight', bp), gutterBP = getOption('gutter', bp);
            // middle wrapper string
            if (TRANSITIONDURATION && middleWrapper && getOption('autoHeight', bp) && 'speed' in opts) middleWrapperStr = '#' + slideId + '-mw{' + getTransitionDurationStyle(speedBP) + '}';
            // inner wrapper string
            if ('edgePadding' in opts || 'gutter' in opts) innerWrapperStr = '#' + slideId + '-iw{' + getInnerWrapperStyles(edgePaddingBP, gutterBP, fixedWidthBP, speedBP, autoHeightBP) + '}';
            // container string
            if (carousel && horizontal && !autoWidth && ('fixedWidth' in opts || 'items' in opts || fixedWidth && 'gutter' in opts)) containerStr = 'width:' + getContainerWidth(fixedWidthBP, gutterBP, itemsBP) + ';';
            if (TRANSITIONDURATION && 'speed' in opts) containerStr += getTransitionDurationStyle(speedBP);
            if (containerStr) containerStr = '#' + slideId + '{' + containerStr + '}';
            // slide string
            if ('fixedWidth' in opts || fixedWidth && 'gutter' in opts || !carousel && 'items' in opts) slideStr += getSlideWidthStyle(fixedWidthBP, gutterBP, itemsBP);
            if ('gutter' in opts) slideStr += getSlideGutterStyle(gutterBP);
            // set gallery items transition-duration
            if (!carousel && 'speed' in opts) {
                if (TRANSITIONDURATION) slideStr += getTransitionDurationStyle(speedBP);
                if (ANIMATIONDURATION) slideStr += getAnimationDurationStyle(speedBP);
            }
            if (slideStr) slideStr = '#' + slideId + ' > .tns-item{' + slideStr + '}';
            // add up
            str = middleWrapperStr + innerWrapperStr + containerStr + slideStr;
            if (str) sheet.insertRule('@media (min-width: ' + bp / 16 + 'em) {' + str + '}', sheet.cssRules.length);
        }
    }
    function initTools() {
        // == slides ==
        updateSlideStatus();
        // == live region ==
        outerWrapper.insertAdjacentHTML('afterbegin', '<div class="tns-liveregion tns-visually-hidden" aria-live="polite" aria-atomic="true">slide <span class="current">' + getLiveRegionStr() + '</span>  of ' + slideCount + '</div>');
        liveregionCurrent = outerWrapper.querySelector('.tns-liveregion .current');
        // == autoplayInit ==
        if (hasAutoplay) {
            var txt = autoplay ? 'stop' : 'start';
            if (autoplayButton) (0, $2b2d8f45f82167d8$export$7e45664a2081efb1)(autoplayButton, {
                'data-action': txt
            });
            else if (options.autoplayButtonOutput) {
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.autoplayPosition), '<button type="button" data-action="' + txt + '">' + autoplayHtmlStrings[0] + txt + autoplayHtmlStrings[1] + autoplayText[0] + '</button>');
                autoplayButton = outerWrapper.querySelector('[data-action]');
            }
            // add event
            if (autoplayButton) (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(autoplayButton, {
                'click': toggleAutoplay
            });
            if (autoplay) {
                startAutoplay();
                if (autoplayHoverPause) (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(container, hoverEvents);
                if (autoplayResetOnVisibility) (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(container, visibilityEvent);
            }
        }
        // == navInit ==
        if (hasNav) {
            var initIndex = !carousel ? 0 : cloneCount;
            // customized nav
            // will not hide the navs in case they're thumbnails
            if (navContainer) {
                (0, $2b2d8f45f82167d8$export$7e45664a2081efb1)(navContainer, {
                    'aria-label': 'Carousel Pagination'
                });
                navItems = navContainer.children;
                (0, $0016fe9a1a80ca23$export$4b80e395e36b5a56)(navItems, function(item, i) {
                    (0, $2b2d8f45f82167d8$export$7e45664a2081efb1)(item, {
                        'data-nav': i,
                        'tabindex': '-1',
                        'aria-label': navStr + (i + 1),
                        'aria-controls': slideId
                    });
                });
            // generated nav
            } else {
                var navHtml = '', hiddenStr = navAsThumbnails ? '' : 'style="display:none"';
                for(var i = 0; i < slideCount; i++)// hide nav items by default
                navHtml += '<button type="button" data-nav="' + i + '" tabindex="-1" aria-controls="' + slideId + '" ' + hiddenStr + ' aria-label="' + navStr + (i + 1) + '"></button>';
                navHtml = '<div class="tns-nav" aria-label="Carousel Pagination">' + navHtml + '</div>';
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.navPosition), navHtml);
                navContainer = outerWrapper.querySelector('.tns-nav');
                navItems = navContainer.children;
            }
            updateNavVisibility();
            // add transition
            if (TRANSITIONDURATION) {
                var prefix = TRANSITIONDURATION.substring(0, TRANSITIONDURATION.length - 18).toLowerCase(), str = 'transition: all ' + speed / 1000 + 's';
                if (prefix) str = '-' + prefix + '-' + str;
                (0, $165497896d877651$export$bf97e331026f75ba)(sheet, '[aria-controls^=' + slideId + '-item]', str, (0, $49a424328cfd7aa5$export$ccd7e907f4f59892)(sheet));
            }
            (0, $2b2d8f45f82167d8$export$7e45664a2081efb1)(navItems[navCurrentIndex], {
                'aria-label': navStr + (navCurrentIndex + 1) + navStrCurrent
            });
            (0, $16dc06620e7b3f06$export$711225beb0f1ef57)(navItems[navCurrentIndex], 'tabindex');
            (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(navItems[navCurrentIndex], navActiveClass);
            // add events
            (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(navContainer, navEvents);
        }
        // == controlsInit ==
        if (hasControls) {
            if (!controlsContainer && (!prevButton || !nextButton)) {
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.controlsPosition), '<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button type="button" data-controls="prev" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[0] + '</button><button type="button" data-controls="next" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[1] + '</button></div>');
                controlsContainer = outerWrapper.querySelector('.tns-controls');
            }
            if (!prevButton || !nextButton) {
                prevButton = controlsContainer.children[0];
                nextButton = controlsContainer.children[1];
            }
            if (options.controlsContainer) (0, $2b2d8f45f82167d8$export$7e45664a2081efb1)(controlsContainer, {
                'aria-label': 'Carousel Navigation',
                'tabindex': '0'
            });
            if (options.controlsContainer || options.prevButton && options.nextButton) (0, $2b2d8f45f82167d8$export$7e45664a2081efb1)([
                prevButton,
                nextButton
            ], {
                'aria-controls': slideId,
                'tabindex': '-1'
            });
            if (options.controlsContainer || options.prevButton && options.nextButton) {
                (0, $2b2d8f45f82167d8$export$7e45664a2081efb1)(prevButton, {
                    'data-controls': 'prev'
                });
                (0, $2b2d8f45f82167d8$export$7e45664a2081efb1)(nextButton, {
                    'data-controls': 'next'
                });
            }
            prevIsButton = isButton(prevButton);
            nextIsButton = isButton(nextButton);
            updateControlsStatus();
            // add events
            if (controlsContainer) (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(controlsContainer, controlsEvents);
            else {
                (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(prevButton, controlsEvents);
                (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(nextButton, controlsEvents);
            }
        }
        // hide tools if needed
        disableUI();
    }
    function initEvents() {
        // add events
        if (carousel && TRANSITIONEND) {
            var eve = {};
            eve[TRANSITIONEND] = onTransitionEnd;
            (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(container, eve);
        }
        if (touch) (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(container, touchEvents, options.preventScrollOnTouch);
        if (mouseDrag) (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(container, dragEvents);
        if (arrowKeys) (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(doc, docmentKeydownEvent);
        if (nested === 'inner') events.on('outerResized', function() {
            resizeTasks();
            events.emit('innerLoaded', info());
        });
        else if (responsive || fixedWidth || autoWidth || autoHeight || !horizontal) (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(win, {
            'resize': onResize
        });
        if (autoHeight) {
            if (nested === 'outer') events.on('innerLoaded', doAutoHeight);
            else if (!disable) doAutoHeight();
        }
        doLazyLoad();
        if (disable) disableSlider();
        else if (freeze) freezeSlider();
        events.on('indexChanged', additionalUpdates);
        if (nested === 'inner') events.emit('innerLoaded', info());
        if (typeof onInit === 'function') onInit(info());
        isOn = true;
    }
    function destroy() {
        // sheet
        sheet.disabled = true;
        if (sheet.ownerNode) sheet.ownerNode.remove();
        // remove win event listeners
        (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(win, {
            'resize': onResize
        });
        // arrowKeys, controls, nav
        if (arrowKeys) (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(doc, docmentKeydownEvent);
        if (controlsContainer) (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(controlsContainer, controlsEvents);
        if (navContainer) (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(navContainer, navEvents);
        // autoplay
        (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(container, hoverEvents);
        (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(container, visibilityEvent);
        if (autoplayButton) (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(autoplayButton, {
            'click': toggleAutoplay
        });
        if (autoplay) clearInterval(autoplayTimer);
        // container
        if (carousel && TRANSITIONEND) {
            var eve = {};
            eve[TRANSITIONEND] = onTransitionEnd;
            (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(container, eve);
        }
        if (touch) (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(container, touchEvents);
        if (mouseDrag) (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(container, dragEvents);
        // cache Object values in options && reset HTML
        var htmlList = [
            containerHTML,
            controlsContainerHTML,
            prevButtonHTML,
            nextButtonHTML,
            navContainerHTML,
            autoplayButtonHTML
        ];
        tnsList.forEach(function(item, i) {
            var el = item === 'container' ? outerWrapper : options[item];
            if (typeof el === 'object' && el) {
                var prevEl = el.previousElementSibling ? el.previousElementSibling : false, parentEl = el.parentNode;
                el.outerHTML = htmlList[i];
                options[item] = prevEl ? prevEl.nextElementSibling : parentEl.firstElementChild;
            }
        });
        // reset variables
        tnsList = animateIn = animateOut = animateDelay = animateNormal = horizontal = outerWrapper = innerWrapper = container = containerParent = containerHTML = slideItems = slideCount = breakpointZone = windowWidth = autoWidth = fixedWidth = edgePadding = gutter = viewport = items = slideBy = viewportMax = arrowKeys = speed = rewind = loop = autoHeight = sheet = lazyload = slidePositions = slideItemsOut = cloneCount = slideCountNew = hasRightDeadZone = rightBoundary = updateIndexBeforeTransform = transformAttr = transformPrefix = transformPostfix = getIndexMax = index = indexCached = indexMin = indexMax = resizeTimer = swipeAngle = moveDirectionExpected = running = onInit = events = newContainerClasses = slideId = disable = disabled = freezable = freeze = frozen = controlsEvents = navEvents = hoverEvents = visibilityEvent = docmentKeydownEvent = touchEvents = dragEvents = hasControls = hasNav = navAsThumbnails = hasAutoplay = hasTouch = hasMouseDrag = slideActiveClass = imgCompleteClass = imgEvents = imgsComplete = controls = controlsText = controlsContainer = controlsContainerHTML = prevButton = nextButton = prevIsButton = nextIsButton = nav = navContainer = navContainerHTML = navItems = pages = pagesCached = navClicked = navCurrentIndex = navCurrentIndexCached = navActiveClass = navStr = navStrCurrent = autoplay = autoplayTimeout = autoplayDirection = autoplayText = autoplayHoverPause = autoplayButton = autoplayButtonHTML = autoplayResetOnVisibility = autoplayHtmlStrings = autoplayTimer = animating = autoplayHoverPaused = autoplayUserPaused = autoplayVisibilityPaused = initPosition = lastPosition = translateInit = disX = disY = panStart = rafIndex = getDist = touch = mouseDrag = null;
        // check variables
        // [animateIn, animateOut, animateDelay, animateNormal, horizontal, outerWrapper, innerWrapper, container, containerParent, containerHTML, slideItems, slideCount, breakpointZone, windowWidth, autoWidth, fixedWidth, edgePadding, gutter, viewport, items, slideBy, viewportMax, arrowKeys, speed, rewind, loop, autoHeight, sheet, lazyload, slidePositions, slideItemsOut, cloneCount, slideCountNew, hasRightDeadZone, rightBoundary, updateIndexBeforeTransform, transformAttr, transformPrefix, transformPostfix, getIndexMax, index, indexCached, indexMin, indexMax, resizeTimer, swipeAngle, moveDirectionExpected, running, onInit, events, newContainerClasses, slideId, disable, disabled, freezable, freeze, frozen, controlsEvents, navEvents, hoverEvents, visibilityEvent, docmentKeydownEvent, touchEvents, dragEvents, hasControls, hasNav, navAsThumbnails, hasAutoplay, hasTouch, hasMouseDrag, slideActiveClass, imgCompleteClass, imgEvents, imgsComplete, controls, controlsText, controlsContainer, controlsContainerHTML, prevButton, nextButton, prevIsButton, nextIsButton, nav, navContainer, navContainerHTML, navItems, pages, pagesCached, navClicked, navCurrentIndex, navCurrentIndexCached, navActiveClass, navStr, navStrCurrent, autoplay, autoplayTimeout, autoplayDirection, autoplayText, autoplayHoverPause, autoplayButton, autoplayButtonHTML, autoplayResetOnVisibility, autoplayHtmlStrings, autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused, initPosition, lastPosition, translateInit, disX, disY, panStart, rafIndex, getDist, touch, mouseDrag ].forEach(function(item) { if (item !== null) { console.log(item); } });
        for(var a in this)if (a !== 'rebuild') this[a] = null;
        isOn = false;
    }
    // === ON RESIZE ===
    // responsive || fixedWidth || autoWidth || !horizontal
    function onResize(e) {
        (0, $76143cc5646b0a4d$export$27f233d61a9e2fa4)(function() {
            resizeTasks(getEvent(e));
        });
    }
    function resizeTasks(e) {
        if (!isOn) return;
        if (nested === 'outer') events.emit('outerResized', info(e));
        windowWidth = getWindowWidth();
        var bpChanged, breakpointZoneTem = breakpointZone, needContainerTransform = false;
        if (responsive) {
            setBreakpointZone();
            bpChanged = breakpointZoneTem !== breakpointZone;
            // if (hasRightDeadZone) { needContainerTransform = true; } // *?
            if (bpChanged) events.emit('newBreakpointStart', info(e));
        }
        var indChanged, itemsChanged, itemsTem = items, disableTem = disable, freezeTem = freeze, arrowKeysTem = arrowKeys, controlsTem = controls, navTem = nav, touchTem = touch, mouseDragTem = mouseDrag, autoplayTem = autoplay, autoplayHoverPauseTem = autoplayHoverPause, autoplayResetOnVisibilityTem = autoplayResetOnVisibility, indexTem = index;
        if (bpChanged) {
            var fixedWidthTem = fixedWidth, autoHeightTem = autoHeight, controlsTextTem = controlsText, centerTem = center, autoplayTextTem = autoplayText;
            if (!CSSMQ) var gutterTem = gutter, edgePaddingTem = edgePadding;
        }
        // get option:
        // fixed width: viewport, fixedWidth, gutter => items
        // others: window width => all variables
        // all: items => slideBy
        arrowKeys = getOption('arrowKeys');
        controls = getOption('controls');
        nav = getOption('nav');
        touch = getOption('touch');
        center = getOption('center');
        mouseDrag = getOption('mouseDrag');
        autoplay = getOption('autoplay');
        autoplayHoverPause = getOption('autoplayHoverPause');
        autoplayResetOnVisibility = getOption('autoplayResetOnVisibility');
        if (bpChanged) {
            disable = getOption('disable');
            fixedWidth = getOption('fixedWidth');
            speed = getOption('speed');
            autoHeight = getOption('autoHeight');
            controlsText = getOption('controlsText');
            autoplayText = getOption('autoplayText');
            autoplayTimeout = getOption('autoplayTimeout');
            if (!CSSMQ) {
                edgePadding = getOption('edgePadding');
                gutter = getOption('gutter');
            }
        }
        // update options
        resetVariblesWhenDisable(disable);
        viewport = getViewportWidth(); // <= edgePadding, gutter
        if ((!horizontal || autoWidth) && !disable) {
            setSlidePositions();
            if (!horizontal) {
                updateContentWrapperHeight(); // <= setSlidePositions
                needContainerTransform = true;
            }
        }
        if (fixedWidth || autoWidth) {
            rightBoundary = getRightBoundary(); // autoWidth: <= viewport, slidePositions, gutter
            // fixedWidth: <= viewport, fixedWidth, gutter
            indexMax = getIndexMax(); // autoWidth: <= rightBoundary, slidePositions
        // fixedWidth: <= rightBoundary, fixedWidth, gutter
        }
        if (bpChanged || fixedWidth) {
            items = getOption('items');
            slideBy = getOption('slideBy');
            itemsChanged = items !== itemsTem;
            if (itemsChanged) {
                if (!fixedWidth && !autoWidth) indexMax = getIndexMax();
                 // <= items
                // check index before transform in case
                // slider reach the right edge then items become bigger
                updateIndex();
            }
        }
        if (bpChanged) {
            if (disable !== disableTem) {
                if (disable) disableSlider();
                else enableSlider(); // <= slidePositions, rightBoundary, indexMax
            }
        }
        if (freezable && (bpChanged || fixedWidth || autoWidth)) {
            freeze = getFreeze(); // <= autoWidth: slidePositions, gutter, viewport, rightBoundary
            // <= fixedWidth: fixedWidth, gutter, rightBoundary
            // <= others: items
            if (freeze !== freezeTem) {
                if (freeze) {
                    doContainerTransform(getContainerTransformValue(getStartIndex(0)));
                    freezeSlider();
                } else {
                    unfreezeSlider();
                    needContainerTransform = true;
                }
            }
        }
        resetVariblesWhenDisable(disable || freeze); // controls, nav, touch, mouseDrag, arrowKeys, autoplay, autoplayHoverPause, autoplayResetOnVisibility
        if (!autoplay) autoplayHoverPause = autoplayResetOnVisibility = false;
        if (arrowKeys !== arrowKeysTem) arrowKeys ? (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(doc, docmentKeydownEvent) : (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(doc, docmentKeydownEvent);
        if (controls !== controlsTem) {
            if (controls) {
                if (controlsContainer) (0, $3c3bbaff0c3b5176$export$998191bfdf710c72)(controlsContainer);
                else {
                    if (prevButton) (0, $3c3bbaff0c3b5176$export$998191bfdf710c72)(prevButton);
                    if (nextButton) (0, $3c3bbaff0c3b5176$export$998191bfdf710c72)(nextButton);
                }
            } else if (controlsContainer) (0, $f7020e146810fbf6$export$7669482c90f5c50f)(controlsContainer);
            else {
                if (prevButton) (0, $f7020e146810fbf6$export$7669482c90f5c50f)(prevButton);
                if (nextButton) (0, $f7020e146810fbf6$export$7669482c90f5c50f)(nextButton);
            }
        }
        if (nav !== navTem) {
            if (nav) {
                (0, $3c3bbaff0c3b5176$export$998191bfdf710c72)(navContainer);
                updateNavVisibility();
            } else (0, $f7020e146810fbf6$export$7669482c90f5c50f)(navContainer);
        }
        if (touch !== touchTem) touch ? (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(container, touchEvents, options.preventScrollOnTouch) : (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(container, touchEvents);
        if (mouseDrag !== mouseDragTem) mouseDrag ? (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(container, dragEvents) : (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(container, dragEvents);
        if (autoplay !== autoplayTem) {
            if (autoplay) {
                if (autoplayButton) (0, $3c3bbaff0c3b5176$export$998191bfdf710c72)(autoplayButton);
                if (!animating && !autoplayUserPaused) startAutoplay();
            } else {
                if (autoplayButton) (0, $f7020e146810fbf6$export$7669482c90f5c50f)(autoplayButton);
                if (animating) stopAutoplay();
            }
        }
        if (autoplayHoverPause !== autoplayHoverPauseTem) autoplayHoverPause ? (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(container, hoverEvents) : (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(container, hoverEvents);
        if (autoplayResetOnVisibility !== autoplayResetOnVisibilityTem) autoplayResetOnVisibility ? (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(doc, visibilityEvent) : (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(doc, visibilityEvent);
        if (bpChanged) {
            if (fixedWidth !== fixedWidthTem || center !== centerTem) needContainerTransform = true;
            if (autoHeight !== autoHeightTem) {
                if (!autoHeight) innerWrapper.style.height = '';
            }
            if (controls && controlsText !== controlsTextTem) {
                prevButton.innerHTML = controlsText[0];
                nextButton.innerHTML = controlsText[1];
            }
            if (autoplayButton && autoplayText !== autoplayTextTem) {
                var i = autoplay ? 1 : 0, html = autoplayButton.innerHTML, len = html.length - autoplayTextTem[i].length;
                if (html.substring(len) === autoplayTextTem[i]) autoplayButton.innerHTML = html.substring(0, len) + autoplayText[i];
            }
        } else if (center && (fixedWidth || autoWidth)) needContainerTransform = true;
        if (itemsChanged || fixedWidth && !autoWidth) {
            pages = getPages();
            updateNavVisibility();
        }
        indChanged = index !== indexTem;
        if (indChanged) {
            events.emit('indexChanged', info());
            needContainerTransform = true;
        } else if (itemsChanged) {
            if (!indChanged) additionalUpdates();
        } else if (fixedWidth || autoWidth) {
            doLazyLoad();
            updateSlideStatus();
            updateLiveRegion();
        }
        if (itemsChanged && !carousel) updateGallerySlidePositions();
        if (!disable && !freeze) {
            // non-mediaqueries: IE8
            if (bpChanged && !CSSMQ) {
                // middle wrapper styles
                // inner wrapper styles
                if (edgePadding !== edgePaddingTem || gutter !== gutterTem) innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, speed, autoHeight);
                if (horizontal) {
                    // container styles
                    if (carousel) container.style.width = getContainerWidth(fixedWidth, gutter, items);
                    // slide styles
                    var str = getSlideWidthStyle(fixedWidth, gutter, items) + getSlideGutterStyle(gutter);
                    // remove the last line and
                    // add new styles
                    (0, $48d16a7097310590$export$271e480b8a432c4a)(sheet, (0, $49a424328cfd7aa5$export$ccd7e907f4f59892)(sheet) - 1);
                    (0, $165497896d877651$export$bf97e331026f75ba)(sheet, '#' + slideId + ' > .tns-item', str, (0, $49a424328cfd7aa5$export$ccd7e907f4f59892)(sheet));
                }
            }
            // auto height
            if (autoHeight) doAutoHeight();
            if (needContainerTransform) {
                doContainerTransformSilent();
                indexCached = index;
            }
        }
        if (bpChanged) events.emit('newBreakpointEnd', info(e));
    }
    // === INITIALIZATION FUNCTIONS === //
    function getFreeze() {
        if (!fixedWidth && !autoWidth) {
            var a = center ? items - (items - 1) / 2 : items;
            return slideCount <= a;
        }
        var width = fixedWidth ? (fixedWidth + gutter) * slideCount : slidePositions[slideCount], vp = edgePadding ? viewport + edgePadding * 2 : viewport + gutter;
        if (center) vp -= fixedWidth ? (viewport - fixedWidth) / 2 : (viewport - (slidePositions[index + 1] - slidePositions[index] - gutter)) / 2;
        return width <= vp;
    }
    function setBreakpointZone() {
        breakpointZone = 0;
        for(var bp in responsive){
            bp = parseInt(bp); // convert string to number
            if (windowWidth >= bp) breakpointZone = bp;
        }
    }
    // (slideBy, indexMin, indexMax) => index
    var updateIndex = function() {
        return loop ? carousel ? // loop + carousel
        function() {
            var leftEdge = indexMin, rightEdge = indexMax;
            leftEdge += slideBy;
            rightEdge -= slideBy;
            // adjust edges when has edge paddings
            // or fixed-width slider with extra space on the right side
            if (edgePadding) {
                leftEdge += 1;
                rightEdge -= 1;
            } else if (fixedWidth) {
                if ((viewport + gutter) % (fixedWidth + gutter)) rightEdge -= 1;
            }
            if (cloneCount) {
                if (index > rightEdge) index -= slideCount;
                else if (index < leftEdge) index += slideCount;
            }
        } : // loop + gallery
        function() {
            if (index > indexMax) while(index >= indexMin + slideCount)index -= slideCount;
            else if (index < indexMin) while(index <= indexMax - slideCount)index += slideCount;
        } : // non-loop
        function() {
            index = Math.max(indexMin, Math.min(indexMax, index));
        };
    }();
    function disableUI() {
        if (!autoplay && autoplayButton) (0, $f7020e146810fbf6$export$7669482c90f5c50f)(autoplayButton);
        if (!nav && navContainer) (0, $f7020e146810fbf6$export$7669482c90f5c50f)(navContainer);
        if (!controls) {
            if (controlsContainer) (0, $f7020e146810fbf6$export$7669482c90f5c50f)(controlsContainer);
            else {
                if (prevButton) (0, $f7020e146810fbf6$export$7669482c90f5c50f)(prevButton);
                if (nextButton) (0, $f7020e146810fbf6$export$7669482c90f5c50f)(nextButton);
            }
        }
    }
    function enableUI() {
        if (autoplay && autoplayButton) (0, $3c3bbaff0c3b5176$export$998191bfdf710c72)(autoplayButton);
        if (nav && navContainer) (0, $3c3bbaff0c3b5176$export$998191bfdf710c72)(navContainer);
        if (controls) {
            if (controlsContainer) (0, $3c3bbaff0c3b5176$export$998191bfdf710c72)(controlsContainer);
            else {
                if (prevButton) (0, $3c3bbaff0c3b5176$export$998191bfdf710c72)(prevButton);
                if (nextButton) (0, $3c3bbaff0c3b5176$export$998191bfdf710c72)(nextButton);
            }
        }
    }
    function freezeSlider() {
        if (frozen) return;
        // remove edge padding from inner wrapper
        if (edgePadding) innerWrapper.style.margin = '0px';
        // add class tns-transparent to cloned slides
        if (cloneCount) {
            var str = 'tns-transparent';
            for(var i = cloneCount; i--;){
                if (carousel) (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(slideItems[i], str);
                (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(slideItems[slideCountNew - i - 1], str);
            }
        }
        // update tools
        disableUI();
        frozen = true;
    }
    function unfreezeSlider() {
        if (!frozen) return;
        // restore edge padding for inner wrapper
        // for mordern browsers
        if (edgePadding && CSSMQ) innerWrapper.style.margin = '';
        // remove class tns-transparent to cloned slides
        if (cloneCount) {
            var str = 'tns-transparent';
            for(var i = cloneCount; i--;){
                if (carousel) (0, $e1b2571307448ef4$export$c2255604a80b4506)(slideItems[i], str);
                (0, $e1b2571307448ef4$export$c2255604a80b4506)(slideItems[slideCountNew - i - 1], str);
            }
        }
        // update tools
        enableUI();
        frozen = false;
    }
    function disableSlider() {
        if (disabled) return;
        sheet.disabled = true;
        container.className = container.className.replace(newContainerClasses.substring(1), '');
        (0, $16dc06620e7b3f06$export$711225beb0f1ef57)(container, [
            'style'
        ]);
        if (loop) for(var j = cloneCount; j--;){
            if (carousel) (0, $f7020e146810fbf6$export$7669482c90f5c50f)(slideItems[j]);
            (0, $f7020e146810fbf6$export$7669482c90f5c50f)(slideItems[slideCountNew - j - 1]);
        }
        // vertical slider
        if (!horizontal || !carousel) (0, $16dc06620e7b3f06$export$711225beb0f1ef57)(innerWrapper, [
            'style'
        ]);
        // gallery
        if (!carousel) for(var i = index, l = index + slideCount; i < l; i++){
            var item = slideItems[i];
            (0, $16dc06620e7b3f06$export$711225beb0f1ef57)(item, [
                'style'
            ]);
            (0, $e1b2571307448ef4$export$c2255604a80b4506)(item, animateIn);
            (0, $e1b2571307448ef4$export$c2255604a80b4506)(item, animateNormal);
        }
        // update tools
        disableUI();
        disabled = true;
    }
    function enableSlider() {
        if (!disabled) return;
        sheet.disabled = false;
        container.className += newContainerClasses;
        doContainerTransformSilent();
        if (loop) for(var j = cloneCount; j--;){
            if (carousel) (0, $3c3bbaff0c3b5176$export$998191bfdf710c72)(slideItems[j]);
            (0, $3c3bbaff0c3b5176$export$998191bfdf710c72)(slideItems[slideCountNew - j - 1]);
        }
        // gallery
        if (!carousel) for(var i = index, l = index + slideCount; i < l; i++){
            var item = slideItems[i], classN = i < index + items ? animateIn : animateNormal;
            item.style.left = (i - index) * 100 / items + '%';
            (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(item, classN);
        }
        // update tools
        enableUI();
        disabled = false;
    }
    function updateLiveRegion() {
        var str = getLiveRegionStr();
        if (liveregionCurrent.innerHTML !== str) liveregionCurrent.innerHTML = str;
    }
    function getLiveRegionStr() {
        var arr = getVisibleSlideRange(), start = arr[0] + 1, end = arr[1] + 1;
        return start === end ? start + '' : start + ' to ' + end;
    }
    function getVisibleSlideRange(val) {
        if (val == null) val = getContainerTransformValue();
        var start = index, end, rangestart, rangeend;
        // get range start, range end for autoWidth and fixedWidth
        if (center || edgePadding) {
            if (autoWidth || fixedWidth) {
                rangestart = -(parseFloat(val) + edgePadding);
                rangeend = rangestart + viewport + edgePadding * 2;
            }
        } else if (autoWidth) {
            rangestart = slidePositions[index];
            rangeend = rangestart + viewport;
        }
        // get start, end
        // - check auto width
        if (autoWidth) slidePositions.forEach(function(point, i) {
            if (i < slideCountNew) {
                if ((center || edgePadding) && point <= rangestart + 0.5) start = i;
                if (rangeend - point >= 0.5) end = i;
            }
        });
        else {
            if (fixedWidth) {
                var cell = fixedWidth + gutter;
                if (center || edgePadding) {
                    start = Math.floor(rangestart / cell);
                    end = Math.ceil(rangeend / cell - 1);
                } else end = start + Math.ceil(viewport / cell) - 1;
            } else if (center || edgePadding) {
                var a = items - 1;
                if (center) {
                    start -= a / 2;
                    end = index + a / 2;
                } else end = index + a;
                if (edgePadding) {
                    var b = edgePadding * items / viewport;
                    start -= b;
                    end += b;
                }
                start = Math.floor(start);
                end = Math.ceil(end);
            } else end = start + items - 1;
            start = Math.max(start, 0);
            end = Math.min(end, slideCountNew - 1);
        }
        return [
            start,
            end
        ];
    }
    function doLazyLoad() {
        if (lazyload && !disable) {
            var arg = getVisibleSlideRange();
            arg.push(lazyloadSelector);
            getImageArray.apply(null, arg).forEach(function(img) {
                if (!(0, $90e8c98c0926e0bc$export$4ea3d958472af68f)(img, imgCompleteClass)) {
                    // stop propagation transitionend event to container
                    var eve = {};
                    eve[TRANSITIONEND] = function(e) {
                        e.stopPropagation();
                    };
                    (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(img, eve);
                    (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(img, imgEvents);
                    // update src
                    img.src = (0, $d1a414c0e2953e57$export$6a93fe6b2b4c71a0)(img, 'data-src');
                    // update srcset
                    var srcset = (0, $d1a414c0e2953e57$export$6a93fe6b2b4c71a0)(img, 'data-srcset');
                    if (srcset) img.srcset = srcset;
                    (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(img, 'loading');
                }
            });
        }
    }
    function onImgLoaded(e) {
        imgLoaded(getTarget(e));
    }
    function onImgFailed(e) {
        imgFailed(getTarget(e));
    }
    function imgLoaded(img) {
        (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(img, 'loaded');
        imgCompleted(img);
    }
    function imgFailed(img) {
        (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(img, 'failed');
        imgCompleted(img);
    }
    function imgCompleted(img) {
        (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(img, imgCompleteClass);
        (0, $e1b2571307448ef4$export$c2255604a80b4506)(img, 'loading');
        (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(img, imgEvents);
    }
    function getImageArray(start, end, imgSelector) {
        var imgs = [];
        if (!imgSelector) imgSelector = 'img';
        while(start <= end){
            (0, $0016fe9a1a80ca23$export$4b80e395e36b5a56)(slideItems[start].querySelectorAll(imgSelector), function(img) {
                imgs.push(img);
            });
            start++;
        }
        return imgs;
    }
    // check if all visible images are loaded
    // and update container height if it's done
    function doAutoHeight() {
        var imgs = getImageArray.apply(null, getVisibleSlideRange());
        (0, $76143cc5646b0a4d$export$27f233d61a9e2fa4)(function() {
            imgsLoadedCheck(imgs, updateInnerWrapperHeight);
        });
    }
    function imgsLoadedCheck(imgs, cb) {
        // execute callback function if all images are complete
        if (imgsComplete) return cb();
        // check image classes
        imgs.forEach(function(img, index) {
            if (!lazyload && img.complete) imgCompleted(img);
             // Check image.complete
            if ((0, $90e8c98c0926e0bc$export$4ea3d958472af68f)(img, imgCompleteClass)) imgs.splice(index, 1);
        });
        // execute callback function if selected images are all complete
        if (!imgs.length) return cb();
        // otherwise execute this functiona again
        (0, $76143cc5646b0a4d$export$27f233d61a9e2fa4)(function() {
            imgsLoadedCheck(imgs, cb);
        });
    }
    function additionalUpdates() {
        doLazyLoad();
        updateSlideStatus();
        updateLiveRegion();
        updateControlsStatus();
        updateNavStatus();
    }
    function update_carousel_transition_duration() {
        if (carousel && autoHeight) middleWrapper.style[TRANSITIONDURATION] = speed / 1000 + 's';
    }
    function getMaxSlideHeight(slideStart, slideRange) {
        var heights = [];
        for(var i = slideStart, l = Math.min(slideStart + slideRange, slideCountNew); i < l; i++)heights.push(slideItems[i].offsetHeight);
        return Math.max.apply(null, heights);
    }
    // update inner wrapper height
    // 1. get the max-height of the visible slides
    // 2. set transitionDuration to speed
    // 3. update inner wrapper height to max-height
    // 4. set transitionDuration to 0s after transition done
    function updateInnerWrapperHeight() {
        var maxHeight = autoHeight ? getMaxSlideHeight(index, items) : getMaxSlideHeight(cloneCount, slideCount), wp = middleWrapper ? middleWrapper : innerWrapper;
        if (wp.style.height !== maxHeight) wp.style.height = maxHeight + 'px';
    }
    // get the distance from the top edge of the first slide to each slide
    // (init) => slidePositions
    function setSlidePositions() {
        slidePositions = [
            0
        ];
        var attr = horizontal ? 'left' : 'top', attr2 = horizontal ? 'right' : 'bottom', base = slideItems[0].getBoundingClientRect()[attr];
        (0, $0016fe9a1a80ca23$export$4b80e395e36b5a56)(slideItems, function(item, i) {
            // skip the first slide
            if (i) slidePositions.push(item.getBoundingClientRect()[attr] - base);
            // add the end edge
            if (i === slideCountNew - 1) slidePositions.push(item.getBoundingClientRect()[attr2] - base);
        });
    }
    // update slide
    function updateSlideStatus() {
        var range = getVisibleSlideRange(), start = range[0], end = range[1];
        (0, $0016fe9a1a80ca23$export$4b80e395e36b5a56)(slideItems, function(item, i) {
            // show slides
            if (i >= start && i <= end) {
                if ((0, $6bd5c05b8d97f320$export$5608640b1bf2f6d7)(item, 'aria-hidden')) {
                    (0, $16dc06620e7b3f06$export$711225beb0f1ef57)(item, [
                        'aria-hidden',
                        'tabindex'
                    ]);
                    (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(item, slideActiveClass);
                }
            } else if (!(0, $6bd5c05b8d97f320$export$5608640b1bf2f6d7)(item, 'aria-hidden')) {
                (0, $2b2d8f45f82167d8$export$7e45664a2081efb1)(item, {
                    'aria-hidden': 'true',
                    'tabindex': '-1'
                });
                (0, $e1b2571307448ef4$export$c2255604a80b4506)(item, slideActiveClass);
            }
        });
    }
    // gallery: update slide position
    function updateGallerySlidePositions() {
        var l = index + Math.min(slideCount, items);
        for(var i = slideCountNew; i--;){
            var item = slideItems[i];
            if (i >= index && i < l) {
                // add transitions to visible slides when adjusting their positions
                (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(item, 'tns-moving');
                item.style.left = (i - index) * 100 / items + '%';
                (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(item, animateIn);
                (0, $e1b2571307448ef4$export$c2255604a80b4506)(item, animateNormal);
            } else if (item.style.left) {
                item.style.left = '';
                (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(item, animateNormal);
                (0, $e1b2571307448ef4$export$c2255604a80b4506)(item, animateIn);
            }
            // remove outlet animation
            (0, $e1b2571307448ef4$export$c2255604a80b4506)(item, animateOut);
        }
        // removing '.tns-moving'
        setTimeout(function() {
            (0, $0016fe9a1a80ca23$export$4b80e395e36b5a56)(slideItems, function(el) {
                (0, $e1b2571307448ef4$export$c2255604a80b4506)(el, 'tns-moving');
            });
        }, 300);
    }
    // set tabindex on Nav
    function updateNavStatus() {
        // get current nav
        if (nav) {
            navCurrentIndex = navClicked >= 0 ? navClicked : getCurrentNavIndex();
            navClicked = -1;
            if (navCurrentIndex !== navCurrentIndexCached) {
                var navPrev = navItems[navCurrentIndexCached], navCurrent = navItems[navCurrentIndex];
                (0, $2b2d8f45f82167d8$export$7e45664a2081efb1)(navPrev, {
                    'tabindex': '-1',
                    'aria-label': navStr + (navCurrentIndexCached + 1)
                });
                (0, $e1b2571307448ef4$export$c2255604a80b4506)(navPrev, navActiveClass);
                (0, $2b2d8f45f82167d8$export$7e45664a2081efb1)(navCurrent, {
                    'aria-label': navStr + (navCurrentIndex + 1) + navStrCurrent
                });
                (0, $16dc06620e7b3f06$export$711225beb0f1ef57)(navCurrent, 'tabindex');
                (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(navCurrent, navActiveClass);
                navCurrentIndexCached = navCurrentIndex;
            }
        }
    }
    function getLowerCaseNodeName(el) {
        return el.nodeName.toLowerCase();
    }
    function isButton(el) {
        return getLowerCaseNodeName(el) === 'button';
    }
    function isAriaDisabled(el) {
        return el.getAttribute('aria-disabled') === 'true';
    }
    function disEnableElement(isButton, el, val) {
        if (isButton) el.disabled = val;
        else el.setAttribute('aria-disabled', val.toString());
    }
    // set 'disabled' to true on controls when reach the edges
    function updateControlsStatus() {
        if (!controls || rewind || loop) return;
        var prevDisabled = prevIsButton ? prevButton.disabled : isAriaDisabled(prevButton), nextDisabled = nextIsButton ? nextButton.disabled : isAriaDisabled(nextButton), disablePrev = index <= indexMin ? true : false, disableNext = !rewind && index >= indexMax ? true : false;
        if (disablePrev && !prevDisabled) disEnableElement(prevIsButton, prevButton, true);
        if (!disablePrev && prevDisabled) disEnableElement(prevIsButton, prevButton, false);
        if (disableNext && !nextDisabled) disEnableElement(nextIsButton, nextButton, true);
        if (!disableNext && nextDisabled) disEnableElement(nextIsButton, nextButton, false);
    }
    // set duration
    function resetDuration(el, str) {
        if (TRANSITIONDURATION) el.style[TRANSITIONDURATION] = str;
    }
    function getSliderWidth() {
        return fixedWidth ? (fixedWidth + gutter) * slideCountNew : slidePositions[slideCountNew];
    }
    function getCenterGap(num) {
        if (num == null) num = index;
        var gap = edgePadding ? gutter : 0;
        return autoWidth ? (viewport - gap - (slidePositions[num + 1] - slidePositions[num] - gutter)) / 2 : fixedWidth ? (viewport - fixedWidth) / 2 : (items - 1) / 2;
    }
    function getRightBoundary() {
        var gap = edgePadding ? gutter : 0, result = viewport + gap - getSliderWidth();
        if (center && !loop) result = fixedWidth ? -(fixedWidth + gutter) * (slideCountNew - 1) - getCenterGap() : getCenterGap(slideCountNew - 1) - slidePositions[slideCountNew - 1];
        if (result > 0) result = 0;
        return result;
    }
    function getContainerTransformValue(num) {
        if (num == null) num = index;
        var val;
        if (horizontal && !autoWidth) {
            if (fixedWidth) {
                val = -(fixedWidth + gutter) * num;
                if (center) val += getCenterGap();
            } else {
                var denominator = TRANSFORM ? slideCountNew : items;
                if (center) num -= getCenterGap();
                val = -num * 100 / denominator;
            }
        } else {
            val = -slidePositions[num];
            if (center && autoWidth) val += getCenterGap();
        }
        if (hasRightDeadZone) val = Math.max(val, rightBoundary);
        val += horizontal && !autoWidth && !fixedWidth ? '%' : 'px';
        return val;
    }
    function doContainerTransformSilent(val) {
        resetDuration(container, '0s');
        doContainerTransform(val);
    }
    function doContainerTransform(val) {
        if (val == null) val = getContainerTransformValue();
        container.style[transformAttr] = transformPrefix + val + transformPostfix;
    }
    function animateSlide(number, classOut, classIn, isOut) {
        var l = number + items;
        if (!loop) l = Math.min(l, slideCountNew);
        for(var i = number; i < l; i++){
            var item = slideItems[i];
            // set item positions
            if (!isOut) item.style.left = (i - index) * 100 / items + '%';
            if (animateDelay && TRANSITIONDELAY) item.style[TRANSITIONDELAY] = item.style[ANIMATIONDELAY] = animateDelay * (i - number) / 1000 + 's';
            (0, $e1b2571307448ef4$export$c2255604a80b4506)(item, classOut);
            (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(item, classIn);
            if (isOut) slideItemsOut.push(item);
        }
    }
    // make transfer after click/drag:
    // 1. change 'transform' property for mordern browsers
    // 2. change 'left' property for legacy browsers
    var transformCore = function() {
        return carousel ? function() {
            resetDuration(container, '');
            if (TRANSITIONDURATION || !speed) {
                // for morden browsers with non-zero duration or
                // zero duration for all browsers
                doContainerTransform();
                // run fallback function manually
                // when duration is 0 / container is hidden
                if (!speed || !(0, $338723c44bd3e26e$export$795910f5f15a9633)(container)) onTransitionEnd();
            } else // for old browser with non-zero duration
            (0, $731f08330d51af49$export$e2705a83c013f564)(container, transformAttr, transformPrefix, transformPostfix, getContainerTransformValue(), speed, onTransitionEnd);
            if (!horizontal) updateContentWrapperHeight();
        } : function() {
            slideItemsOut = [];
            var eve = {};
            eve[TRANSITIONEND] = eve[ANIMATIONEND] = onTransitionEnd;
            (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(slideItems[indexCached], eve);
            (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(slideItems[index], eve);
            animateSlide(indexCached, animateIn, animateOut, true);
            animateSlide(index, animateNormal, animateIn);
            // run fallback function manually
            // when transition or animation not supported / duration is 0
            if (!TRANSITIONEND || !ANIMATIONEND || !speed || !(0, $338723c44bd3e26e$export$795910f5f15a9633)(container)) onTransitionEnd();
        };
    }();
    function render(e, sliderMoved) {
        if (updateIndexBeforeTransform) updateIndex();
        // render when slider was moved (touch or drag) even though index may not change
        if (index !== indexCached || sliderMoved) {
            // events
            events.emit('indexChanged', info());
            events.emit('transitionStart', info());
            if (autoHeight) doAutoHeight();
            // pause autoplay when click or keydown from user
            if (animating && e && [
                'click',
                'keydown'
            ].indexOf(e.type) >= 0) stopAutoplay();
            running = true;
            transformCore();
        }
    }
    /*
   * Transfer prefixed properties to the same format
   * CSS: -Webkit-Transform => webkittransform
   * JS: WebkitTransform => webkittransform
   * @param {string} str - property
   *
   */ function strTrans(str) {
        return str.toLowerCase().replace(/-/g, '');
    }
    // AFTER TRANSFORM
    // Things need to be done after a transfer:
    // 1. check index
    // 2. add classes to visible slide
    // 3. disable controls buttons when reach the first/last slide in non-loop slider
    // 4. update nav status
    // 5. lazyload images
    // 6. update container height
    function onTransitionEnd(event) {
        // check running on gallery mode
        // make sure trantionend/animationend events run only once
        if (carousel || running) {
            events.emit('transitionEnd', info(event));
            if (!carousel && slideItemsOut.length > 0) for(var i = 0; i < slideItemsOut.length; i++){
                var item = slideItemsOut[i];
                // set item positions
                item.style.left = '';
                if (ANIMATIONDELAY && TRANSITIONDELAY) {
                    item.style[ANIMATIONDELAY] = '';
                    item.style[TRANSITIONDELAY] = '';
                }
                (0, $e1b2571307448ef4$export$c2255604a80b4506)(item, animateOut);
                (0, $1537e8e483cd0adb$export$d2cf6cd1dc7067d3)(item, animateNormal);
            }
            /* update slides, nav, controls after checking ...
       * => legacy browsers who don't support 'event'
       *    have to check event first, otherwise event.target will cause an error
       * => or 'gallery' mode:
       *   + event target is slide item
       * => or 'carousel' mode:
       *   + event target is container,
       *   + event.property is the same with transform attribute
       */ if (!event || !carousel && event.target.parentNode === container || event.target === container && strTrans(event.propertyName) === strTrans(transformAttr)) {
                if (!updateIndexBeforeTransform) {
                    var indexTem = index;
                    updateIndex();
                    if (index !== indexTem) {
                        events.emit('indexChanged', info());
                        doContainerTransformSilent();
                    }
                }
                if (nested === 'inner') events.emit('innerLoaded', info());
                running = false;
                indexCached = index;
            }
        }
    }
    // # ACTIONS
    function goTo(targetIndex, e) {
        if (freeze) return;
        // prev slideBy
        if (targetIndex === 'prev') onControlsClick(e, -1);
        else if (targetIndex === 'next') onControlsClick(e, 1);
        else {
            if (running) {
                if (preventActionWhenRunning) return;
                else onTransitionEnd();
            }
            var absIndex = getAbsIndex(), indexGap = 0;
            if (targetIndex === 'first') indexGap = -absIndex;
            else if (targetIndex === 'last') indexGap = carousel ? slideCount - items - absIndex : slideCount - 1 - absIndex;
            else {
                if (typeof targetIndex !== 'number') targetIndex = parseInt(targetIndex);
                if (!isNaN(targetIndex)) {
                    // from directly called goTo function
                    if (!e) targetIndex = Math.max(0, Math.min(slideCount - 1, targetIndex));
                    indexGap = targetIndex - absIndex;
                }
            }
            // gallery: make sure new page won't overlap with current page
            if (!carousel && indexGap && Math.abs(indexGap) < items) {
                var factor = indexGap > 0 ? 1 : -1;
                indexGap += index + indexGap - slideCount >= indexMin ? slideCount * factor : slideCount * 2 * factor * -1;
            }
            index += indexGap;
            // make sure index is in range
            if (carousel && loop) {
                if (index < indexMin) index += slideCount;
                if (index > indexMax) index -= slideCount;
            }
            // if index is changed, start rendering
            if (getAbsIndex(index) !== getAbsIndex(indexCached)) render(e);
        }
    }
    // on controls click
    function onControlsClick(e, dir) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        var passEventObject;
        if (!dir) {
            e = getEvent(e);
            var target = getTarget(e);
            while(target !== controlsContainer && [
                prevButton,
                nextButton
            ].indexOf(target) < 0)target = target.parentNode;
            var targetIn = [
                prevButton,
                nextButton
            ].indexOf(target);
            if (targetIn >= 0) {
                passEventObject = true;
                dir = targetIn === 0 ? -1 : 1;
            }
        }
        if (rewind) {
            if (index === indexMin && dir === -1) {
                goTo('last', e);
                return;
            } else if (index === indexMax && dir === 1) {
                goTo('first', e);
                return;
            }
        }
        if (dir) {
            index += slideBy * dir;
            if (autoWidth) index = Math.floor(index);
            // pass e when click control buttons or keydown
            render(passEventObject || e && e.type === 'keydown' ? e : null);
        }
    }
    // on nav click
    function onNavClick(e) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        e = getEvent(e);
        var target = getTarget(e), navIndex;
        // find the clicked nav item
        while(target !== navContainer && !(0, $6bd5c05b8d97f320$export$5608640b1bf2f6d7)(target, 'data-nav'))target = target.parentNode;
        if ((0, $6bd5c05b8d97f320$export$5608640b1bf2f6d7)(target, 'data-nav')) {
            var navIndex = navClicked = Number((0, $d1a414c0e2953e57$export$6a93fe6b2b4c71a0)(target, 'data-nav')), targetIndexBase = fixedWidth || autoWidth ? navIndex * slideCount / pages : navIndex * items, targetIndex = navAsThumbnails ? navIndex : Math.min(Math.ceil(targetIndexBase), slideCount - 1);
            goTo(targetIndex, e);
            if (navCurrentIndex === navIndex) {
                if (animating) stopAutoplay();
                navClicked = -1; // reset navClicked
            }
        }
    }
    // autoplay functions
    function setAutoplayTimer() {
        autoplayTimer = setInterval(function() {
            onControlsClick(null, autoplayDirection);
        }, autoplayTimeout);
        animating = true;
    }
    function stopAutoplayTimer() {
        clearInterval(autoplayTimer);
        animating = false;
    }
    function updateAutoplayButton(action, txt) {
        (0, $2b2d8f45f82167d8$export$7e45664a2081efb1)(autoplayButton, {
            'data-action': action
        });
        autoplayButton.innerHTML = autoplayHtmlStrings[0] + action + autoplayHtmlStrings[1] + txt;
    }
    function startAutoplay() {
        setAutoplayTimer();
        if (autoplayButton) updateAutoplayButton('stop', autoplayText[1]);
    }
    function stopAutoplay() {
        stopAutoplayTimer();
        if (autoplayButton) updateAutoplayButton('start', autoplayText[0]);
    }
    // programaitcally play/pause the slider
    function play() {
        if (autoplay && !animating) {
            startAutoplay();
            autoplayUserPaused = false;
        }
    }
    function pause() {
        if (animating) {
            stopAutoplay();
            autoplayUserPaused = true;
        }
    }
    function toggleAutoplay() {
        if (animating) {
            stopAutoplay();
            autoplayUserPaused = true;
        } else {
            startAutoplay();
            autoplayUserPaused = false;
        }
    }
    function onVisibilityChange() {
        if (doc.hidden) {
            if (animating) {
                stopAutoplayTimer();
                autoplayVisibilityPaused = true;
            }
        } else if (autoplayVisibilityPaused) {
            setAutoplayTimer();
            autoplayVisibilityPaused = false;
        }
    }
    function mouseoverPause() {
        if (animating) {
            stopAutoplayTimer();
            autoplayHoverPaused = true;
        }
    }
    function mouseoutRestart() {
        if (autoplayHoverPaused) {
            setAutoplayTimer();
            autoplayHoverPaused = false;
        }
    }
    // keydown events on document
    function onDocumentKeydown(e) {
        e = getEvent(e);
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT
        ].indexOf(e.keyCode);
        if (keyIndex >= 0) onControlsClick(e, keyIndex === 0 ? -1 : 1);
    }
    // on key control
    function onControlsKeydown(e) {
        e = getEvent(e);
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT
        ].indexOf(e.keyCode);
        if (keyIndex >= 0) {
            if (keyIndex === 0) {
                if (!prevButton.disabled) onControlsClick(e, -1);
            } else if (!nextButton.disabled) onControlsClick(e, 1);
        }
    }
    // set focus
    function setFocus(el) {
        el.focus();
    }
    // on key nav
    function onNavKeydown(e) {
        e = getEvent(e);
        var curElement = doc.activeElement;
        if (!(0, $6bd5c05b8d97f320$export$5608640b1bf2f6d7)(curElement, 'data-nav')) return;
        // var code = e.keyCode,
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT,
            KEYS.ENTER,
            KEYS.SPACE
        ].indexOf(e.keyCode), navIndex = Number((0, $d1a414c0e2953e57$export$6a93fe6b2b4c71a0)(curElement, 'data-nav'));
        if (keyIndex >= 0) {
            if (keyIndex === 0) {
                if (navIndex > 0) setFocus(navItems[navIndex - 1]);
            } else if (keyIndex === 1) {
                if (navIndex < pages - 1) setFocus(navItems[navIndex + 1]);
            } else {
                navClicked = navIndex;
                goTo(navIndex, e);
            }
        }
    }
    function getEvent(e) {
        e = e || win.event;
        return isTouchEvent(e) ? e.changedTouches[0] : e;
    }
    function getTarget(e) {
        return e.target || win.event.srcElement;
    }
    function isTouchEvent(e) {
        return e.type.indexOf('touch') >= 0;
    }
    function preventDefaultBehavior(e) {
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
    }
    function getMoveDirectionExpected() {
        return (0, $3aceaf0d1e7fe0e6$export$83b6d73568c72b60)((0, $9e0a1fc4eb27d007$export$c796d9d3e501591f)(lastPosition.y - initPosition.y, lastPosition.x - initPosition.x), swipeAngle) === options.axis;
    }
    function onPanStart(e) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        if (autoplay && animating) stopAutoplayTimer();
        panStart = true;
        if (rafIndex) {
            (0, $568c83fe70cd0407$export$75aab3dbee8deceb)(rafIndex);
            rafIndex = null;
        }
        var $ = getEvent(e);
        events.emit(isTouchEvent(e) ? 'touchStart' : 'dragStart', info(e));
        if (!isTouchEvent(e) && [
            'img',
            'a'
        ].indexOf(getLowerCaseNodeName(getTarget(e))) >= 0) preventDefaultBehavior(e);
        lastPosition.x = initPosition.x = $.clientX;
        lastPosition.y = initPosition.y = $.clientY;
        if (carousel) {
            translateInit = parseFloat(container.style[transformAttr].replace(transformPrefix, ''));
            resetDuration(container, '0s');
        }
    }
    function onPanMove(e) {
        if (panStart) {
            var $ = getEvent(e);
            lastPosition.x = $.clientX;
            lastPosition.y = $.clientY;
            if (carousel) {
                if (!rafIndex) rafIndex = (0, $76143cc5646b0a4d$export$27f233d61a9e2fa4)(function() {
                    panUpdate(e);
                });
            } else {
                if (moveDirectionExpected === '?') moveDirectionExpected = getMoveDirectionExpected();
                if (moveDirectionExpected) preventScroll = true;
            }
            if ((typeof e.cancelable !== 'boolean' || e.cancelable) && preventScroll) e.preventDefault();
        }
    }
    function panUpdate(e) {
        if (!moveDirectionExpected) {
            panStart = false;
            return;
        }
        (0, $568c83fe70cd0407$export$75aab3dbee8deceb)(rafIndex);
        if (panStart) rafIndex = (0, $76143cc5646b0a4d$export$27f233d61a9e2fa4)(function() {
            panUpdate(e);
        });
        if (moveDirectionExpected === '?') moveDirectionExpected = getMoveDirectionExpected();
        if (moveDirectionExpected) {
            if (!preventScroll && isTouchEvent(e)) preventScroll = true;
            try {
                if (e.type) events.emit(isTouchEvent(e) ? 'touchMove' : 'dragMove', info(e));
            } catch (err) {}
            var x = translateInit, dist = getDist(lastPosition, initPosition);
            if (!horizontal || fixedWidth || autoWidth) {
                x += dist;
                x += 'px';
            } else {
                var percentageX = TRANSFORM ? dist * items * 100 / ((viewport + gutter) * slideCountNew) : dist * 100 / (viewport + gutter);
                x += percentageX;
                x += '%';
            }
            container.style[transformAttr] = transformPrefix + x + transformPostfix;
        }
    }
    function onPanEnd(e) {
        if (panStart) {
            if (rafIndex) {
                (0, $568c83fe70cd0407$export$75aab3dbee8deceb)(rafIndex);
                rafIndex = null;
            }
            if (carousel) resetDuration(container, '');
            panStart = false;
            var $ = getEvent(e);
            lastPosition.x = $.clientX;
            lastPosition.y = $.clientY;
            var dist = getDist(lastPosition, initPosition);
            if (Math.abs(dist)) {
                // drag vs click
                if (!isTouchEvent(e)) {
                    // prevent "click"
                    var target = getTarget(e);
                    (0, $4e0f640ba853a3f9$export$aadfb65bee660f96)(target, {
                        'click': function preventClick(e) {
                            preventDefaultBehavior(e);
                            (0, $5bed4e13e408472c$export$da5f6eb3bb522cd)(target, {
                                'click': preventClick
                            });
                        }
                    });
                }
                if (carousel) rafIndex = (0, $76143cc5646b0a4d$export$27f233d61a9e2fa4)(function() {
                    if (horizontal && !autoWidth) {
                        var indexMoved = -dist * items / (viewport + gutter);
                        indexMoved = dist > 0 ? Math.floor(indexMoved) : Math.ceil(indexMoved);
                        index += indexMoved;
                    } else {
                        var moved = -(translateInit + dist);
                        if (moved <= 0) index = indexMin;
                        else if (moved >= slidePositions[slideCountNew - 1]) index = indexMax;
                        else {
                            var i = 0;
                            while(i < slideCountNew && moved >= slidePositions[i]){
                                index = i;
                                if (moved > slidePositions[i] && dist < 0) index += 1;
                                i++;
                            }
                        }
                    }
                    render(e, dist);
                    events.emit(isTouchEvent(e) ? 'touchEnd' : 'dragEnd', info(e));
                });
                else if (moveDirectionExpected) onControlsClick(e, dist > 0 ? -1 : 1);
            }
        }
        // reset
        if (options.preventScrollOnTouch === 'auto') preventScroll = false;
        if (swipeAngle) moveDirectionExpected = '?';
        if (autoplay && !animating) setAutoplayTimer();
    }
    // === RESIZE FUNCTIONS === //
    // (slidePositions, index, items) => vertical_conentWrapper.height
    function updateContentWrapperHeight() {
        var wp = middleWrapper ? middleWrapper : innerWrapper;
        wp.style.height = slidePositions[index + items] - slidePositions[index] + 'px';
    }
    function getPages() {
        var rough = fixedWidth ? (fixedWidth + gutter) * slideCount / viewport : slideCount / items;
        return Math.min(Math.ceil(rough), slideCount);
    }
    /*
   * 1. update visible nav items list
   * 2. add "hidden" attributes to previous visible nav items
   * 3. remove "hidden" attrubutes to new visible nav items
   */ function updateNavVisibility() {
        if (!nav || navAsThumbnails) return;
        if (pages !== pagesCached) {
            var min = pagesCached, max = pages, fn = (0, $3c3bbaff0c3b5176$export$998191bfdf710c72);
            if (pagesCached > pages) {
                min = pages;
                max = pagesCached;
                fn = (0, $f7020e146810fbf6$export$7669482c90f5c50f);
            }
            while(min < max){
                fn(navItems[min]);
                min++;
            }
            // cache pages
            pagesCached = pages;
        }
    }
    function info(e) {
        return {
            container: container,
            slideItems: slideItems,
            navContainer: navContainer,
            navItems: navItems,
            controlsContainer: controlsContainer,
            hasControls: hasControls,
            prevButton: prevButton,
            nextButton: nextButton,
            items: items,
            slideBy: slideBy,
            cloneCount: cloneCount,
            slideCount: slideCount,
            slideCountNew: slideCountNew,
            index: index,
            indexCached: indexCached,
            displayIndex: getCurrentSlide(),
            navCurrentIndex: navCurrentIndex,
            navCurrentIndexCached: navCurrentIndexCached,
            pages: pages,
            pagesCached: pagesCached,
            sheet: sheet,
            isOn: isOn,
            event: e || {}
        };
    }
    return {
        version: '2.9.4',
        getInfo: info,
        events: events,
        goTo: goTo,
        play: play,
        pause: pause,
        isOn: isOn,
        updateSliderHeight: updateInnerWrapperHeight,
        refresh: initSliderTransform,
        destroy: destroy,
        rebuild: function() {
            return $dc7cb0956330e818$export$51fe319e24d9d8c9((0, $2f74ee940b1656a2$export$8b58be045bf06082)(options, optionsElements));
        }
    };
};


if (document.querySelector(".hero__slider")) {
    let heroSlider = (0, $dc7cb0956330e818$export$51fe319e24d9d8c9)({
        container: '.hero__slider',
        items: 1,
        mouseDrag: true,
        autoplay: true,
        autoplayTimeout: 7500,
        controls: false,
        nav: false,
        lazyload: true,
        autoplayButtonOutput: false
    });
}
if (document.querySelector(".products__slider")) {
    let productSlider = (0, $dc7cb0956330e818$export$51fe319e24d9d8c9)({
        container: '.products__slider',
        responsive: {
            0: {
                items: 1,
                gutter: '10',
                nav: true
            },
            768: {
                items: 2,
                gutter: '20',
                nav: false
            },
            960: {
                items: 3
            }
        },
        autoplay: true,
        controls: false,
        nav: false,
        autoplayButtonOutput: false
    });
    let prev = document.querySelector('.products__slider-nav .js-prev');
    let next = document.querySelector('.products__slider-nav .js-next');
    // slider navigation
    prev.addEventListener('click', function() {
        productSlider.goTo('prev');
    });
    next.addEventListener('click', function() {
        productSlider.goTo('next');
    });
}
if (document.querySelector(".brands__slider")) {
    let brandsSlider = (0, $dc7cb0956330e818$export$51fe319e24d9d8c9)({
        container: '.brands__slider',
        responsive: {
            0: {
                items: 2,
                gutter: '20'
            },
            768: {
                items: 3,
                gutter: '30'
            },
            960: {
                items: 4,
                gutter: '40'
            }
        },
        autoplay: true,
        mouseDrag: true,
        controls: false,
        autoplayButtonOutput: false
    });
}
if (document.querySelector(".testimonials__slider")) {
    let testimonialSlider = (0, $dc7cb0956330e818$export$51fe319e24d9d8c9)({
        container: '.testimonials__slider',
        items: 1,
        controls: false,
        autoplay: true,
        autoHeight: true,
        mouseDrag: true,
        autoplayButtonOutput: false
    });
}
// fix om dots navigatie onder de slides te positioneren
const $cfcae291ae1b2d36$var$navs = document.querySelectorAll(".tns-nav");
for(let i = 0; i < $cfcae291ae1b2d36$var$navs.length; i++)$cfcae291ae1b2d36$var$navs[i].parentNode.appendChild($cfcae291ae1b2d36$var$navs[i]);


// Source: https://rudrastyh.com/api/instagram-with-pure-javascript.html & https://humaan.com/blog/bigger-square-thumbnails-from-the-instagram-api/


var $ef34ede229894569$exports = {};
/*! Modals v10.1.2 | (c) 2017 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/modals */ !function(e, t) {
    "function" == typeof define && define.amd ? define([], t(e)) : $ef34ede229894569$exports = t(e);
}("undefined" != typeof $parcel$global ? $parcel$global : $ef34ede229894569$exports.window || $ef34ede229894569$exports.global, function(e) {
    "use strict";
    var t, o, n, l = {}, c = "querySelector" in document && "addEventListener" in e && "classList" in document.createElement("_"), r = "closed", d = {
        selectorToggle: "[data-modal]",
        selectorWindow: "[data-modal-window]",
        selectorClose: "[data-modal-close]",
        modalActiveClass: "active",
        modalBGClass: "modal-bg",
        preventBGScroll: !0,
        preventBGScrollHtml: !0,
        preventBGScrollBody: !0,
        backspaceClose: !0,
        stopVideo: !0,
        callbackOpen: function() {},
        callbackClose: function() {}
    }, a = function() {
        var e = {}, t = !1, o = 0, n = arguments.length;
        "[object Boolean]" === Object.prototype.toString.call(arguments[0]) && (t = arguments[0], o++);
        for(; o < n; o++){
            var l = arguments[o];
            !function(o) {
                for(var n in o)Object.prototype.hasOwnProperty.call(o, n) && (t && "[object Object]" === Object.prototype.toString.call(o[n]) ? e[n] = a(!0, e[n], o[n]) : e[n] = o[n]);
            }(l);
        }
        return e;
    }, s = function(e, t) {
        for(Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(e) {
            for(var t = (this.document || this.ownerDocument).querySelectorAll(e), o = t.length; --o >= 0 && t.item(o) !== this;);
            return o > -1;
        }); e && e !== document; e = e.parentNode)if (e.matches(t)) return e;
        return null;
    }, i = function(e, t) {
        if (t.stopVideo && e.classList.contains(t.modalActiveClass)) {
            var o = e.querySelector("iframe"), n = e.querySelector("video");
            if (o) {
                var l = o.src;
                o.src = l;
            }
            n && n.pause();
        }
    }, u = function() {
        var e = document.createElement("div");
        e.style.visibility = "hidden", e.style.width = "100px", e.style.msOverflowStyle = "scrollbar", document.body.appendChild(e);
        var t = e.offsetWidth;
        e.style.overflow = "scroll";
        var o = document.createElement("div");
        o.style.width = "100%", e.appendChild(o);
        var n = o.offsetWidth;
        return e.parentNode.removeChild(e), t - n;
    }, m = function() {
        if (!document.querySelector("[data-modal-bg]")) {
            var e = document.createElement("div");
            e.setAttribute("data-modal-bg", !0), e.classList.add(n.modalBGClass), document.body.appendChild(e);
        }
    }, p = function() {
        var e = document.querySelector("[data-modal-bg]");
        e && document.body.removeChild(e);
    };
    l.closeModal = function(e) {
        var t = a(n || d, e || {}), l = document.querySelector(t.selectorWindow + "." + t.modalActiveClass);
        l && (i(l, t), l.classList.remove(t.modalActiveClass), p(), r = "closed", t.preventBGScroll && (document.documentElement.style.overflowY = "", document.body.style.overflowY = "", document.body.style.paddingRight = ""), t.callbackClose(o, l), o && (o.focus(), o = null));
    }, l.openModal = function(e, c, s) {
        var i = a(n || d, s || {}), u = document.querySelector(c);
        "open" === r && l.closeModal(i), e && (o = e), u.classList.add(i.modalActiveClass), m(), r = "open", u.setAttribute("tabindex", "-1"), u.focus(), i.preventBGScroll && (i.preventBGScrollHtml && (document.documentElement.style.overflowY = "hidden"), i.preventBGScrollBody && (document.body.style.overflowY = "hidden"), document.body.style.paddingRight = t + "px"), i.callbackOpen(e, u);
    };
    var v = function(e, t, o) {
        if (o) return e.removeEventListener("touchstart", a, !1), e.removeEventListener("touchend", s, !1), void e.removeEventListener("click", i, !1);
        if (t && "function" == typeof t) {
            var n, l, c, r, d, a = function(e) {
                n = !0, l = e.changedTouches[0].pageX, c = e.changedTouches[0].pageY;
            }, s = function(e) {
                r = e.changedTouches[0].pageX - l, d = e.changedTouches[0].pageY - c, Math.abs(r) >= 7 || Math.abs(d) >= 10 || t(e);
            }, i = function(e) {
                if (n) return void (n = !1);
                t(e);
            };
            e.addEventListener("touchstart", a, !1), e.addEventListener("touchend", s, !1), e.addEventListener("click", i, !1);
        }
    }, f = function(e) {
        var t = e.target, o = s(t, n.selectorToggle), c = s(t, n.selectorClose), d = s(t, n.selectorWindow), a = e.keyCode;
        if (a && "open" === r) (27 === a || n.backspaceClose && (8 === a || 46 === a)) && l.closeModal();
        else if (t) {
            if (d && !c) return;
            !o || a && 13 !== a ? "open" === r && (e.preventDefault(), l.closeModal()) : (e.preventDefault(), l.openModal(o, o.getAttribute("data-modal"), n));
        }
    };
    return l.destroy = function() {
        n && (v(document, null, !0), document.removeEventListener("keydown", f, !1), document.documentElement.style.overflowY = "", document.body.style.overflowY = "", document.body.style.paddingRight = "", t = null, o = null, n = null);
    }, l.init = function(e) {
        c && (l.destroy(), n = a(d, e || {}), t = u(), v(document, f), document.addEventListener("keydown", f, !1));
    }, l;
});


(0, (/*@__PURE__*/$parcel$interopDefault($ef34ede229894569$exports))).init();
function $2b34b11e82598826$var$getJSON(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.onload = function(e) {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                var res = xhr.responseText;
                callback(JSON.parse(res));
            } else console.error(xhr.statusText);
        }
    };
    xhr.onerror = function(e) {
        console.error(xhr.statusText);
    };
    xhr.send(null);
}
// Blitskikker: 4639563558.8183fb1.8adf9445e6944d40b18fcf9af27aa034
let $2b34b11e82598826$var$token = 'IGQVJWRnc2bmpuQUxsYTdwYjFMaGpLMHlqZAnlGb0QtV0Y3TGNUVzdEYTRDUDhjRTRwRXNYYWhFanBlYTcweE1rZAnpWSmgxbUhWZAVdxd2ZAqLWdHdlZAoOWwwQnlpOUdWWU5SV2haRnRSbmVFVjhoS2ZAvMgZDZD', $2b34b11e82598826$var$numPhotos = 4, $2b34b11e82598826$var$container = document.querySelector('.js-insta'), $2b34b11e82598826$var$scrElement = document.createElement('script');
window.processResult = function(data) {
    var options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
    for(let i = 0; i < $2b34b11e82598826$var$numPhotos; i++){
        let x = i;
        // set variables
        let d = new Date(data.data[x].timestamp), src = data.data[x].media_url, date = new Date(d).toLocaleString('en-GB', options), fullCaption = data.data[x].caption, caption = '';
        if (fullCaption) caption = fullCaption.substring(0, 320) + '...';
        let type = data.data[x].media_type;
        if (type == 'VIDEO') src = data.data[x].thumbnail_url;
        let id = data.data[x].id;
        let link = data.data[x].permalink;
        // set HTML
        $2b34b11e82598826$var$container.innerHTML += `
            <li class="instagram__item black">
                <a data-modal="#insta_${id}" href="">
                    <img class="instagram__img" src="${src}">
                </a>
                <div class="instagram__info modal" data-modal-window id="insta_${id}">
                    <div class="modal__img">
                        <img src="${src}">
                    </div>
                    <div class="modal__content">
                        <a class="close" data-modal-close href="#">
                            <svg viewbox="0 0 40 40"><path class="close-x" d="M 10,10 L 30,30 M 30,10 L 10,30" /></svg>
                        </a>
                        <p class="instagram__text">${caption}</p>
                        <p class="instagram__date">${date}</p>
                    </div>
                </div>
            </li>`;
    }
};
if ($2b34b11e82598826$var$container) $2b34b11e82598826$var$getJSON('/instafeed', function(data) {
    processResult(data);
});
 // if (container) {
 //     scrElement.setAttribute('src', 'https://graph.instagram.com/me/media?fields=username,media_url,thumbnail_url,media_type,permalink,timestamp,caption,like_count&access_token=' + token + '&count=' + numPhotos + '&callback=mishaProcessResult');
 //     document.body.appendChild(scrElement);
 // }


var $125d1ceb57662f9a$exports = {};

$125d1ceb57662f9a$exports = (parcelRequire("81tj9"));


// Detect mobile device
function $5cb0da25e8719326$export$8de52386ea28ce8f() {
    let check = false;
    if (window.matchMedia('screen and (max-width: 61.999em)').matches) check = true;
    return check;
}
function $5cb0da25e8719326$export$5dacdde460c8d918() {
    if (window.NodeList && !NodeList.prototype.forEach) NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for(var i = 0; i < this.length; i++)callback.call(thisArg, this[i], i, this);
    };
}
function $5cb0da25e8719326$export$7cd7c12df529a1c3() {
    if (!String.prototype.includes) String.prototype.includes = function(search, start) {
        'use strict';
        if (typeof start !== 'number') start = 0;
        if (start + search.length > this.length) return false;
        else return this.indexOf(search, start) !== -1;
    };
}



(parcelRequire("gv7vu")).polyfill();
(0, $5cb0da25e8719326$export$5dacdde460c8d918)();
(0, $5cb0da25e8719326$export$7cd7c12df529a1c3)();
const $62dca846f2fecce4$var$displayMatches = (matches, query)=>{
    const container = document.querySelector('.search-results');
    container.style.display = 'block';
    let items = [];
    matches.forEach((match)=>{
        const { title: title, img: img, url: url, type: type, author: author } = match;
        const item = `
			<a href="${url}" class="search-results__item">     
				${img ? '<img src=' + img + '>' : ''}
				<div>
					<p>${title}</p>
					<p>${type} ${type === 'Blog' ? "\u2022 " + author : ''}</p>
				</div>
			</a>`;
        items.push(item);
    });
    container.innerHTML = items.join('');
    if (query.length && items.length === 0) container.innerHTML = `<p class="search-results__item">Geen resultaten voor "${query}" ...</p>`;
};
const $62dca846f2fecce4$var$findMatches = (query, results)=>{
    console.log(results);
    const matches = results.filter((result)=>{
        const { title: title } = result;
        return title.toLowerCase().includes(query.toLowerCase());
    });
    $62dca846f2fecce4$var$displayMatches(matches, query);
};
function $62dca846f2fecce4$export$2e2bcd8739ae039(el) {
    const input = document.querySelector(el);
    if (!input) return;
    const container = document.querySelector('.search-results');
    let results = null;
    (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).get(`/wp-json/rest/data`).then((res)=>{
        results = res.data;
    }).catch((err)=>console.log(err));
    input.addEventListener('keyup', ()=>{
        const query = input.value;
        if (query.length > 2) $62dca846f2fecce4$var$findMatches(query, results);
        else container.style.display = 'none';
    });
}


var $ad79992743a8d8e2$exports = {};
!function(t, n) {
    $ad79992743a8d8e2$exports = n();
}($ad79992743a8d8e2$exports, function() {
    "use strict";
    function t(t, n) {
        var e = void 0;
        return function() {
            e && clearTimeout(e), e = setTimeout(t, n);
        };
    }
    function n(t, n) {
        for(var e = t.length, r = e, o = []; e--;)o.push(n(t[r - e - 1]));
        return o;
    }
    function e(t, n) {
        var e = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if (window.Promise) return A(t, n, e);
        t.recalculate(!0, !0);
    }
    function r(t) {
        for(var n = t.options, e = t.responsiveOptions, r = t.keys, o = t.docWidth, i = void 0, s = 0; s < r.length; s++){
            var a = parseInt(r[s], 10);
            o >= a && (i = n.breakAt[a], O(i, e));
        }
        return e;
    }
    function o(t) {
        for(var n = t.options, e = t.responsiveOptions, r = t.keys, o = t.docWidth, i = void 0, s = r.length - 1; s >= 0; s--){
            var a = parseInt(r[s], 10);
            o <= a && (i = n.breakAt[a], O(i, e));
        }
        return e;
    }
    function i(t) {
        var n = t.useContainerForBreakpoints ? t.container.clientWidth : window.innerWidth, e = {
            columns: t.columns
        };
        b(t.margin) ? e.margin = {
            x: t.margin.x,
            y: t.margin.y
        } : e.margin = {
            x: t.margin,
            y: t.margin
        };
        var i = Object.keys(t.breakAt);
        return t.mobileFirst ? r({
            options: t,
            responsiveOptions: e,
            keys: i,
            docWidth: n
        }) : o({
            options: t,
            responsiveOptions: e,
            keys: i,
            docWidth: n
        });
    }
    function s(t) {
        return i(t).columns;
    }
    function a(t) {
        return i(t).margin;
    }
    function c(t) {
        var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], e = s(t), r = a(t).x, o = 100 / e;
        if (!n) return o;
        if (1 === e) return "100%";
        var i = "px";
        if ("string" == typeof r) {
            var c = parseFloat(r);
            i = r.replace(c, ""), r = c;
        }
        return r = (e - 1) * r / e, "%" === i ? o - r + "%" : "calc(" + o + "% - " + r + i + ")";
    }
    function u(t, n) {
        var e = s(t.options), r = 0, o = void 0, i = void 0;
        if (1 === ++n) return 0;
        i = a(t.options).x;
        var u = "px";
        if ("string" == typeof i) {
            var l = parseFloat(i, 10);
            u = i.replace(l, ""), i = l;
        }
        return o = (i - (e - 1) * i / e) * (n - 1), r += c(t.options, !1) * (n - 1), "%" === u ? r + o + "%" : "calc(" + r + "% + " + o + u + ")";
    }
    function l(t) {
        var n = 0, e = t.container, r = t.rows;
        v(r, function(t) {
            n = t > n ? t : n;
        }), e.style.height = n + "px";
    }
    function p(t, n) {
        var e = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], o = s(t.options), i = a(t.options).y;
        M(t, o, e), v(n, function(n) {
            var e = 0, o = parseInt(n.offsetHeight, 10);
            isNaN(o) || (t.rows.forEach(function(n, r) {
                n < t.rows[e] && (e = r);
            }), n.style.position = "absolute", n.style.top = t.rows[e] + "px", n.style.left = "" + t.cols[e], t.rows[e] += isNaN(o) ? 0 : o + i, r && (n.dataset.macyComplete = 1));
        }), r && (t.tmpRows = null), l(t);
    }
    function f(t, n) {
        var e = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], o = s(t.options), i = a(t.options).y;
        M(t, o, e), v(n, function(n) {
            t.lastcol === o && (t.lastcol = 0);
            var e = C(n, "height");
            e = parseInt(n.offsetHeight, 10), isNaN(e) || (n.style.position = "absolute", n.style.top = t.rows[t.lastcol] + "px", n.style.left = "" + t.cols[t.lastcol], t.rows[t.lastcol] += isNaN(e) ? 0 : e + i, t.lastcol += 1, r && (n.dataset.macyComplete = 1));
        }), r && (t.tmpRows = null), l(t);
    }
    var h = function t(n, e) {
        if (!(this instanceof t)) return new t(n, e);
        if (n && n.nodeName) return n;
        if (n = n.replace(/^\s*/, "").replace(/\s*$/, ""), e) return this.byCss(n, e);
        for(var r in this.selectors)if (e = r.split("/"), new RegExp(e[1], e[2]).test(n)) return this.selectors[r](n);
        return this.byCss(n);
    };
    h.prototype.byCss = function(t, n) {
        return (n || document).querySelectorAll(t);
    }, h.prototype.selectors = {}, h.prototype.selectors[/^\.[\w\-]+$/] = function(t) {
        return document.getElementsByClassName(t.substring(1));
    }, h.prototype.selectors[/^\w+$/] = function(t) {
        return document.getElementsByTagName(t);
    }, h.prototype.selectors[/^\#[\w\-]+$/] = function(t) {
        return document.getElementById(t.substring(1));
    };
    var v = function(t, n) {
        for(var e = t.length, r = e; e--;)n(t[r - e - 1]);
    }, m = function() {
        var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        this.running = !1, this.events = [], this.add(t);
    };
    m.prototype.run = function() {
        if (!this.running && this.events.length > 0) {
            var t = this.events.shift();
            this.running = !0, t(), this.running = !1, this.run();
        }
    }, m.prototype.add = function() {
        var t = this, n = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        return !!n && (Array.isArray(n) ? v(n, function(n) {
            return t.add(n);
        }) : (this.events.push(n), void this.run()));
    }, m.prototype.clear = function() {
        this.events = [];
    };
    var d = function(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return this.instance = t, this.data = n, this;
    }, y = function() {
        var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        this.events = {}, this.instance = t;
    };
    y.prototype.on = function() {
        var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return !(!t || !n) && (Array.isArray(this.events[t]) || (this.events[t] = []), this.events[t].push(n));
    }, y.prototype.emit = function() {
        var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!t || !Array.isArray(this.events[t])) return !1;
        var e = new d(this.instance, n);
        v(this.events[t], function(t) {
            return t(e);
        });
    };
    var g = function(t) {
        return !("naturalHeight" in t && t.naturalHeight + t.naturalWidth === 0) || t.width + t.height !== 0;
    }, E = function(t, n) {
        var e = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        return new Promise(function(t, e) {
            if (n.complete) return g(n) ? t(n) : e(n);
            n.addEventListener("load", function() {
                return g(n) ? t(n) : e(n);
            }), n.addEventListener("error", function() {
                return e(n);
            });
        }).then(function(n) {
            e && t.emit(t.constants.EVENT_IMAGE_LOAD, {
                img: n
            });
        }).catch(function(n) {
            return t.emit(t.constants.EVENT_IMAGE_ERROR, {
                img: n
            });
        });
    }, w = function(t, e) {
        var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        return n(e, function(n) {
            return E(t, n, r);
        });
    }, A = function(t, n) {
        var e = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        return Promise.all(w(t, n, e)).then(function() {
            t.emit(t.constants.EVENT_IMAGE_COMPLETE);
        });
    }, I = function(n) {
        return t(function() {
            n.emit(n.constants.EVENT_RESIZE), n.queue.add(function() {
                return n.recalculate(!0, !0);
            });
        }, 100);
    }, N = function(t) {
        if (t.container = h(t.options.container), t.container instanceof h || !t.container) return !!t.options.debug && console.error("Error: Container not found");
        t.container.length && (t.container = t.container[0]), t.options.container = t.container, t.container.style.position = "relative";
    }, T = function(t) {
        t.queue = new m, t.events = new y(t), t.rows = [], t.resizer = I(t);
    }, L = function(t) {
        var n = h("img", t.container);
        window.addEventListener("resize", t.resizer), t.on(t.constants.EVENT_IMAGE_LOAD, function() {
            return t.recalculate(!1, !1);
        }), t.on(t.constants.EVENT_IMAGE_COMPLETE, function() {
            return t.recalculate(!0, !0);
        }), t.options.useOwnImageLoader || e(t, n, !t.options.waitForImages), t.emit(t.constants.EVENT_INITIALIZED);
    }, _ = function(t) {
        N(t), T(t), L(t);
    }, b = function(t) {
        return t === Object(t) && "[object Array]" !== Object.prototype.toString.call(t);
    }, O = function(t, n) {
        b(t) || (n.columns = t), b(t) && t.columns && (n.columns = t.columns), b(t) && t.margin && !b(t.margin) && (n.margin = {
            x: t.margin,
            y: t.margin
        }), b(t) && t.margin && b(t.margin) && t.margin.x && (n.margin.x = t.margin.x), b(t) && t.margin && b(t.margin) && t.margin.y && (n.margin.y = t.margin.y);
    }, C = function(t, n) {
        return window.getComputedStyle(t, null).getPropertyValue(n);
    }, M = function(t, n) {
        var e = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if (t.lastcol || (t.lastcol = 0), t.rows.length < 1 && (e = !0), e) {
            t.rows = [], t.cols = [], t.lastcol = 0;
            for(var r = n - 1; r >= 0; r--)t.rows[r] = 0, t.cols[r] = u(t, r);
        } else if (t.tmpRows) {
            t.rows = [];
            for(var r = n - 1; r >= 0; r--)t.rows[r] = t.tmpRows[r];
        } else {
            t.tmpRows = [];
            for(var r = n - 1; r >= 0; r--)t.tmpRows[r] = t.rows[r];
        }
    }, V = function(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], e = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], r = n ? t.container.children : h(':scope > *:not([data-macy-complete="1"])', t.container);
        r = Array.from(r).filter(function(t) {
            return null !== t.offsetParent;
        });
        var o = c(t.options);
        return v(r, function(t) {
            n && (t.dataset.macyComplete = 0), t.style.width = o;
        }), t.options.trueOrder ? (f(t, r, n, e), t.emit(t.constants.EVENT_RECALCULATED)) : (p(t, r, n, e), t.emit(t.constants.EVENT_RECALCULATED));
    }, R = function() {
        return !!window.Promise;
    }, x = Object.assign || function(t) {
        for(var n = 1; n < arguments.length; n++){
            var e = arguments[n];
            for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
        return t;
    };
    Array.from || (Array.from = function(t) {
        for(var n = 0, e = []; n < t.length;)e.push(t[n++]);
        return e;
    });
    var k = {
        columns: 4,
        margin: 2,
        trueOrder: !1,
        waitForImages: !1,
        useImageLoader: !0,
        breakAt: {},
        useOwnImageLoader: !1,
        onInit: !1,
        cancelLegacy: !1,
        useContainerForBreakpoints: !1
    };
    !function() {
        try {
            document.createElement("a").querySelector(":scope *");
        } catch (t) {
            !function() {
                function t(t) {
                    return function(e) {
                        if (e && n.test(e)) {
                            var r = this.getAttribute("id");
                            r || (this.id = "q" + Math.floor(9e6 * Math.random()) + 1e6), arguments[0] = e.replace(n, "#" + this.id);
                            var o = t.apply(this, arguments);
                            return null === r ? this.removeAttribute("id") : r || (this.id = r), o;
                        }
                        return t.apply(this, arguments);
                    };
                }
                var n = /:scope\b/gi, e = t(Element.prototype.querySelector);
                Element.prototype.querySelector = function(t) {
                    return e.apply(this, arguments);
                };
                var r = t(Element.prototype.querySelectorAll);
                Element.prototype.querySelectorAll = function(t) {
                    return r.apply(this, arguments);
                };
            }();
        }
    }();
    var q = function t() {
        var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : k;
        if (!(this instanceof t)) return new t(n);
        this.options = {}, x(this.options, k, n), this.options.cancelLegacy && !R() || _(this);
    };
    return q.init = function(t) {
        return console.warn("Depreciated: Macy.init will be removed in v3.0.0 opt to use Macy directly like so Macy({ /*options here*/ }) "), new q(t);
    }, q.prototype.recalculateOnImageLoad = function() {
        var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        return e(this, h("img", this.container), !t);
    }, q.prototype.runOnImageLoad = function(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], r = h("img", this.container);
        return this.on(this.constants.EVENT_IMAGE_COMPLETE, t), n && this.on(this.constants.EVENT_IMAGE_LOAD, t), e(this, r, n);
    }, q.prototype.recalculate = function() {
        var t = this, n = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        return e && this.queue.clear(), this.queue.add(function() {
            return V(t, n, e);
        });
    }, q.prototype.remove = function() {
        window.removeEventListener("resize", this.resizer), v(this.container.children, function(t) {
            t.removeAttribute("data-macy-complete"), t.removeAttribute("style");
        }), this.container.removeAttribute("style");
    }, q.prototype.reInit = function() {
        this.recalculate(!0, !0), this.emit(this.constants.EVENT_INITIALIZED), window.addEventListener("resize", this.resizer), this.container.style.position = "relative";
    }, q.prototype.on = function(t, n) {
        this.events.on(t, n);
    }, q.prototype.emit = function(t, n) {
        this.events.emit(t, n);
    }, q.constants = {
        EVENT_INITIALIZED: "macy.initialized",
        EVENT_RECALCULATED: "macy.recalculated",
        EVENT_IMAGE_LOAD: "macy.image.load",
        EVENT_IMAGE_ERROR: "macy.image.error",
        EVENT_IMAGE_COMPLETE: "macy.images.complete",
        EVENT_RESIZE: "macy.resize"
    }, q.prototype.constants = q.constants, q;
});


var $4e5e8be31315b18e$exports = {};
/*!
 * baguetteBox.js
 * @author  feimosi
 * @version 1.12.0
 * @url https://github.com/feimosi/baguetteBox.js
 */ !function(e, t) {
    "use strict";
    "function" == typeof define && define.amd ? define(t) : $4e5e8be31315b18e$exports = t();
}($4e5e8be31315b18e$exports, function() {
    "use strict";
    var s, l, u, c, d, f = '<svg width="44" height="60"><polyline points="30 10 10 30 30 50" stroke="rgba(255,255,255,0.5)" stroke-width="4"stroke-linecap="butt" fill="none" stroke-linejoin="round"/></svg>', g = '<svg width="44" height="60"><polyline points="14 10 34 30 14 50" stroke="rgba(255,255,255,0.5)" stroke-width="4"stroke-linecap="butt" fill="none" stroke-linejoin="round"/></svg>', p = '<svg width="30" height="30"><g stroke="rgb(160,160,160)" stroke-width="4"><line x1="5" y1="5" x2="25" y2="25"/><line x1="5" y1="25" x2="25" y2="5"/></g></svg>', b = {}, v = {
        captions: !0,
        buttons: "auto",
        fullScreen: !1,
        noScrollbars: !1,
        bodyClass: "baguetteBox-open",
        titleTag: !1,
        async: !1,
        preload: 2,
        animation: "slideIn",
        afterShow: null,
        afterHide: null,
        onChange: null,
        overlayBackgroundColor: "rgba(0,0,0,.8)",
        closeX: p,
        leftArrow: f,
        rightArrow: g
    }, m = {}, h = [], o = 0, n = !1, i = {}, a = !1, y = /.+\.(gif|jpe?g|png|webp)/i, w = {}, k = [], r = null, x = function(e) {
        -1 !== e.target.id.indexOf("baguette-img") && X();
    }, E = function(e) {
        e.stopPropagation ? e.stopPropagation() : e.cancelBubble = !0, q();
    }, C = function(e) {
        e.stopPropagation ? e.stopPropagation() : e.cancelBubble = !0, j();
    }, B = function(e) {
        e.stopPropagation ? e.stopPropagation() : e.cancelBubble = !0, X();
    }, T = function(e) {
        i.count++, 1 < i.count && (i.multitouch = !0), i.startX = e.changedTouches[0].pageX, i.startY = e.changedTouches[0].pageY;
    }, A = function(e) {
        if (!a && !i.multitouch) {
            e.preventDefault ? e.preventDefault() : e.returnValue = !1;
            var t = e.touches[0] || e.changedTouches[0];
            40 < t.pageX - i.startX ? (a = !0, q()) : t.pageX - i.startX < -40 ? (a = !0, j()) : 100 < i.startY - t.pageY && X();
        }
    }, L = function() {
        i.count--, i.count <= 0 && (i.multitouch = !1), a = !1;
    }, N = function() {
        L();
    }, H = function(e) {
        "block" === s.style.display && s.contains && !s.contains(e.target) && (e.stopPropagation(), M());
    };
    function P(e) {
        if (w.hasOwnProperty(e)) {
            var t = w[e].galleries;
            [].forEach.call(t, function(e) {
                [].forEach.call(e, function(e) {
                    W(e.imageElement, "click", e.eventHandler);
                }), h === e && (h = []);
            }), delete w[e];
        }
    }
    function S(e) {
        switch(e.keyCode){
            case 37:
                q();
                break;
            case 39:
                j();
                break;
            case 27:
                X();
                break;
            case 36:
                !function t(e) {
                    e && e.preventDefault();
                    return D(0);
                }(e);
                break;
            case 35:
                !function n(e) {
                    e && e.preventDefault();
                    return D(h.length - 1);
                }(e);
        }
    }
    function F(e, t) {
        if (h !== e) {
            for(h = e, function r(e) {
                e = e || {};
                for(var t in v)b[t] = v[t], "undefined" != typeof e[t] && (b[t] = e[t]);
                l.style.transition = l.style.webkitTransition = "fadeIn" === b.animation ? "opacity .4s ease" : "slideIn" === b.animation ? "" : "none", "auto" === b.buttons && ("ontouchstart" in window || 1 === h.length) && (b.buttons = !1);
                u.style.display = c.style.display = b.buttons ? "" : "none", d.innerHTML = b.closeX, b.buttons && (u.innerHTML = b.leftArrow, c.innerHTML = b.rightArrow);
                try {
                    s.style.backgroundColor = b.overlayBackgroundColor;
                } catch (n) {}
            }(t); l.firstChild;)l.removeChild(l.firstChild);
            for(var n, o = [], i = [], a = k.length = 0; a < e.length; a++)(n = J("div")).className = "full-image", n.id = "baguette-img-" + a, k.push(n), o.push("baguetteBox-figure-" + a), i.push("baguetteBox-figcaption-" + a), l.appendChild(k[a]);
            s.setAttribute("aria-labelledby", o.join(" ")), s.setAttribute("aria-describedby", i.join(" "));
        }
    }
    function I(e) {
        b.noScrollbars && (document.documentElement.style.overflowY = "hidden", document.body.style.overflowY = "scroll"), "block" !== s.style.display && (U(document, "keydown", S), i = {
            count: 0,
            startX: null,
            startY: null
        }, Y(o = e, function() {
            z(o), V(o);
        }), R(), s.style.display = "block", b.fullScreen && function t() {
            s.requestFullscreen ? s.requestFullscreen() : s.webkitRequestFullscreen ? s.webkitRequestFullscreen() : s.mozRequestFullScreen && s.mozRequestFullScreen();
        }(), setTimeout(function() {
            s.className = "visible", b.bodyClass && document.body.classList && document.body.classList.add(b.bodyClass), b.afterShow && b.afterShow();
        }, 50), b.onChange && b.onChange(o, k.length), r = document.activeElement, M(), n = !0);
    }
    function M() {
        b.buttons ? u.focus() : d.focus();
    }
    function X() {
        b.noScrollbars && (document.documentElement.style.overflowY = "auto", document.body.style.overflowY = "auto"), "none" !== s.style.display && (W(document, "keydown", S), s.className = "", setTimeout(function() {
            s.style.display = "none", document.fullscreen && function e() {
                document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen && document.webkitExitFullscreen();
            }(), b.bodyClass && document.body.classList && document.body.classList.remove(b.bodyClass), b.afterHide && b.afterHide(), r && r.focus(), n = !1;
        }, 500));
    }
    function Y(t, n) {
        var e = k[t], o = h[t];
        if (void 0 !== e && void 0 !== o) {
            if (e.getElementsByTagName("img")[0]) n && n();
            else {
                var i = o.imageElement, a = i.getElementsByTagName("img")[0], r = "function" == typeof b.captions ? b.captions.call(h, i) : i.getAttribute("data-caption") || i.title, s = function d(e) {
                    var t = e.href;
                    if (e.dataset) {
                        var n = [];
                        for(var o in e.dataset)"at-" !== o.substring(0, 3) || isNaN(o.substring(3)) || (n[o.replace("at-", "")] = e.dataset[o]);
                        for(var i = Object.keys(n).sort(function(e, t) {
                            return parseInt(e, 10) < parseInt(t, 10) ? -1 : 1;
                        }), a = window.innerWidth * window.devicePixelRatio, r = 0; r < i.length - 1 && i[r] < a;)r++;
                        t = n[i[r]] || t;
                    }
                    return t;
                }(i), l = J("figure");
                if (l.id = "baguetteBox-figure-" + t, l.innerHTML = '<div class="baguetteBox-spinner"><div class="baguetteBox-double-bounce1"></div><div class="baguetteBox-double-bounce2"></div></div>', b.captions && r) {
                    var u = J("figcaption");
                    u.id = "baguetteBox-figcaption-" + t, u.innerHTML = r, l.appendChild(u);
                }
                e.appendChild(l);
                var c = J("img");
                c.onload = function() {
                    var e = document.querySelector("#baguette-img-" + t + " .baguetteBox-spinner");
                    l.removeChild(e), !b.async && n && n();
                }, c.setAttribute("src", s), c.alt = a && a.alt || "", b.titleTag && r && (c.title = r), l.appendChild(c), b.async && n && n();
            }
        }
    }
    function j() {
        return D(o + 1);
    }
    function q() {
        return D(o - 1);
    }
    function D(e, t) {
        return !n && 0 <= e && e < t.length ? (F(t, b), I(e), !0) : e < 0 ? (b.animation && O("left"), !1) : e >= k.length ? (b.animation && O("right"), !1) : (Y(o = e, function() {
            z(o), V(o);
        }), R(), b.onChange && b.onChange(o, k.length), !0);
    }
    function O(e) {
        l.className = "bounce-from-" + e, setTimeout(function() {
            l.className = "";
        }, 400);
    }
    function R() {
        var e = 100 * -o + "%";
        "fadeIn" === b.animation ? (l.style.opacity = 0, setTimeout(function() {
            m.transforms ? l.style.transform = l.style.webkitTransform = "translate3d(" + e + ",0,0)" : l.style.left = e, l.style.opacity = 1;
        }, 400)) : m.transforms ? l.style.transform = l.style.webkitTransform = "translate3d(" + e + ",0,0)" : l.style.left = e;
    }
    function z(e) {
        e - o >= b.preload || Y(e + 1, function() {
            z(e + 1);
        });
    }
    function V(e) {
        o - e >= b.preload || Y(e - 1, function() {
            V(e - 1);
        });
    }
    function U(e, t, n, o) {
        e.addEventListener ? e.addEventListener(t, n, o) : e.attachEvent("on" + t, function(e) {
            (e = e || window.event).target = e.target || e.srcElement, n(e);
        });
    }
    function W(e, t, n, o) {
        e.removeEventListener ? e.removeEventListener(t, n, o) : e.detachEvent("on" + t, n);
    }
    function G(e) {
        return document.getElementById(e);
    }
    function J(e) {
        return document.createElement(e);
    }
    return [].forEach || (Array.prototype.forEach = function(e, t) {
        for(var n = 0; n < this.length; n++)e.call(t, this[n], n, this);
    }), [].filter || (Array.prototype.filter = function(e, t, n, o, i) {
        for(n = this, o = [], i = 0; i < n.length; i++)e.call(t, n[i], i, n) && o.push(n[i]);
        return o;
    }), {
        run: function K(e, t) {
            return m.transforms = function n() {
                var e = J("div");
                return "undefined" != typeof e.style.perspective || "undefined" != typeof e.style.webkitPerspective;
            }(), m.svg = function o() {
                var e = J("div");
                return e.innerHTML = "<svg/>", "http://www.w3.org/2000/svg" === (e.firstChild && e.firstChild.namespaceURI);
            }(), m.passiveEvents = function i() {
                var e = !1;
                try {
                    var t = Object.defineProperty({}, "passive", {
                        get: function() {
                            e = !0;
                        }
                    });
                    window.addEventListener("test", null, t);
                } catch (n) {}
                return e;
            }(), function a() {
                if (s = G("baguetteBox-overlay")) return l = G("baguetteBox-slider"), u = G("previous-button"), c = G("next-button"), void (d = G("close-button"));
                (s = J("div")).setAttribute("role", "dialog"), s.id = "baguetteBox-overlay", document.getElementsByTagName("body")[0].appendChild(s), (l = J("div")).id = "baguetteBox-slider", s.appendChild(l), (u = J("button")).setAttribute("type", "button"), u.id = "previous-button", u.setAttribute("aria-label", "Previous"), u.innerHTML = m.svg ? f : "&lt;", s.appendChild(u), (c = J("button")).setAttribute("type", "button"), c.id = "next-button", c.setAttribute("aria-label", "Next"), c.innerHTML = m.svg ? g : "&gt;", s.appendChild(c), (d = J("button")).setAttribute("type", "button"), d.id = "close-button", d.setAttribute("aria-label", "Close"), d.innerHTML = m.svg ? p : "&times;", s.appendChild(d), u.className = c.className = d.className = "baguetteBox-button", function n() {
                    var e = m.passiveEvents ? {
                        passive: !1
                    } : null, t = m.passiveEvents ? {
                        passive: !0
                    } : null;
                    U(s, "click", x), U(u, "click", E), U(c, "click", C), U(d, "click", B), U(l, "contextmenu", N), U(s, "touchstart", T, t), U(s, "touchmove", A, e), U(s, "touchend", L), U(document, "focus", H, !0);
                }();
            }(), P(e), function r(e, a) {
                var t = document.querySelectorAll(e), n = {
                    galleries: [],
                    nodeList: t
                };
                return w[e] = n, [].forEach.call(t, function(e) {
                    a && a.filter && (y = a.filter);
                    var t = [];
                    if (t = "A" === e.tagName ? [
                        e
                    ] : e.getElementsByTagName("a"), 0 !== (t = [].filter.call(t, function(e) {
                        if (-1 === e.className.indexOf(a && a.ignoreClass)) return y.test(e.href);
                    })).length) {
                        var i = [];
                        [].forEach.call(t, function(e, t) {
                            var n = function(e) {
                                e.preventDefault ? e.preventDefault() : e.returnValue = !1, F(i, a), I(t);
                            }, o = {
                                eventHandler: n,
                                imageElement: e
                            };
                            U(e, "click", n), i.push(o);
                        }), n.galleries.push(i);
                    }
                }), n.galleries;
            }(e, t);
        },
        show: D,
        showNext: j,
        showPrevious: q,
        hide: X,
        destroy: function e() {
            !function n() {
                var e = m.passiveEvents ? {
                    passive: !1
                } : null, t = m.passiveEvents ? {
                    passive: !0
                } : null;
                W(s, "click", x), W(u, "click", E), W(c, "click", C), W(d, "click", B), W(l, "contextmenu", N), W(s, "touchstart", T, t), W(s, "touchmove", A, e), W(s, "touchend", L), W(document, "focus", H, !0);
            }(), function t() {
                for(var e in w)w.hasOwnProperty(e) && P(e);
            }(), W(document, "keydown", S), document.getElementsByTagName("body")[0].removeChild(document.getElementById("baguetteBox-overlay")), w = {}, h = [], o = 0;
        }
    };
});


var $95fda1bea70891c7$exports = {};
/*!
 * in-view 0.6.1 - Get notified when a DOM element enters or exits the viewport.
 * Copyright (c) 2016 Cam Wiegert <cam@camwiegert.com> - https://camwiegert.github.io/in-view
 * License: MIT
 */ !function(t, e) {
    $95fda1bea70891c7$exports = e();
}($95fda1bea70891c7$exports, function() {
    return function(t) {
        function e(r) {
            if (n[r]) return n[r].exports;
            var i = n[r] = {
                exports: {},
                id: r,
                loaded: !1
            };
            return t[r].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports;
        }
        var n = {};
        return e.m = t, e.c = n, e.p = "", e(0);
    }([
        function(t, e, n) {
            "use strict";
            function r(t) {
                return t && t.__esModule ? t : {
                    "default": t
                };
            }
            var i = n(2), o = r(i);
            t.exports = o["default"];
        },
        function(t, e) {
            function n(t) {
                var e = typeof t;
                return null != t && ("object" == e || "function" == e);
            }
            t.exports = n;
        },
        function(t, e, n) {
            "use strict";
            function r(t) {
                return t && t.__esModule ? t : {
                    "default": t
                };
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var i = n(9), o = r(i), u = n(3), f = r(u), s = n(4), c = function() {
                if ("undefined" != typeof window) {
                    var t = 100, e = [
                        "scroll",
                        "resize",
                        "load"
                    ], n = {
                        history: []
                    }, r = {
                        offset: {},
                        threshold: 0,
                        test: s.inViewport
                    }, i = (0, o["default"])(function() {
                        n.history.forEach(function(t) {
                            n[t].check();
                        });
                    }, t);
                    e.forEach(function(t) {
                        return addEventListener(t, i);
                    }), window.MutationObserver && addEventListener("DOMContentLoaded", function() {
                        new MutationObserver(i).observe(document.body, {
                            attributes: !0,
                            childList: !0,
                            subtree: !0
                        });
                    });
                    var u = function(t) {
                        if ("string" == typeof t) {
                            var e = [].slice.call(document.querySelectorAll(t));
                            return n.history.indexOf(t) > -1 ? n[t].elements = e : (n[t] = (0, f["default"])(e, r), n.history.push(t)), n[t];
                        }
                    };
                    return u.offset = function(t) {
                        if (void 0 === t) return r.offset;
                        var e = function(t) {
                            return "number" == typeof t;
                        };
                        return [
                            "top",
                            "right",
                            "bottom",
                            "left"
                        ].forEach(e(t) ? function(e) {
                            return r.offset[e] = t;
                        } : function(n) {
                            return e(t[n]) ? r.offset[n] = t[n] : null;
                        }), r.offset;
                    }, u.threshold = function(t) {
                        return "number" == typeof t && t >= 0 && t <= 1 ? r.threshold = t : r.threshold;
                    }, u.test = function(t) {
                        return "function" == typeof t ? r.test = t : r.test;
                    }, u.is = function(t) {
                        return r.test(t, r);
                    }, u.offset(0), u;
                }
            };
            e["default"] = c();
        },
        function(t, e) {
            "use strict";
            function n(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var r = function() {
                function t(t, e) {
                    for(var n = 0; n < e.length; n++){
                        var r = e[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                    }
                }
                return function(e, n, r) {
                    return n && t(e.prototype, n), r && t(e, r), e;
                };
            }(), i = function() {
                function t(e, r) {
                    n(this, t), this.options = r, this.elements = e, this.current = [], this.handlers = {
                        enter: [],
                        exit: []
                    }, this.singles = {
                        enter: [],
                        exit: []
                    };
                }
                return r(t, [
                    {
                        key: "check",
                        value: function() {
                            var t = this;
                            return this.elements.forEach(function(e) {
                                var n = t.options.test(e, t.options), r = t.current.indexOf(e), i = r > -1, o = n && !i, u = !n && i;
                                o && (t.current.push(e), t.emit("enter", e)), u && (t.current.splice(r, 1), t.emit("exit", e));
                            }), this;
                        }
                    },
                    {
                        key: "on",
                        value: function(t, e) {
                            return this.handlers[t].push(e), this;
                        }
                    },
                    {
                        key: "once",
                        value: function(t, e) {
                            return this.singles[t].unshift(e), this;
                        }
                    },
                    {
                        key: "emit",
                        value: function(t, e) {
                            for(; this.singles[t].length;)this.singles[t].pop()(e);
                            for(var n = this.handlers[t].length; --n > -1;)this.handlers[t][n](e);
                            return this;
                        }
                    }
                ]), t;
            }();
            e["default"] = function(t, e) {
                return new i(t, e);
            };
        },
        function(t, e) {
            "use strict";
            function n(t, e) {
                var n = t.getBoundingClientRect(), r = n.top, i = n.right, o = n.bottom, u = n.left, f = n.width, s = n.height, c = {
                    t: o,
                    r: window.innerWidth - u,
                    b: window.innerHeight - r,
                    l: i
                }, a = {
                    x: e.threshold * f,
                    y: e.threshold * s
                };
                return c.t > e.offset.top + a.y && c.r > e.offset.right + a.x && c.b > e.offset.bottom + a.y && c.l > e.offset.left + a.x;
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.inViewport = n;
        },
        function(t, e) {
            (function(e) {
                var n = "object" == typeof e && e && e.Object === Object && e;
                t.exports = n;
            }).call(e, function() {
                return this;
            }());
        },
        function(t, e, n) {
            var r = n(5), i = "object" == typeof self && self && self.Object === Object && self, o = r || i || Function("return this")();
            t.exports = o;
        },
        function(t, e, n) {
            function r(t, e, n) {
                function r(e) {
                    var n = x, r = m;
                    return x = m = void 0, E = e, w = t.apply(r, n);
                }
                function a(t) {
                    return E = t, j = setTimeout(h, e), M ? r(t) : w;
                }
                function l(t) {
                    var n = t - O, r = t - E, i = e - n;
                    return _ ? c(i, g - r) : i;
                }
                function d(t) {
                    var n = t - O, r = t - E;
                    return void 0 === O || n >= e || n < 0 || _ && r >= g;
                }
                function h() {
                    var t = o();
                    return d(t) ? p(t) : void (j = setTimeout(h, l(t)));
                }
                function p(t) {
                    return j = void 0, T && x ? r(t) : (x = m = void 0, w);
                }
                function v() {
                    void 0 !== j && clearTimeout(j), E = 0, x = O = m = j = void 0;
                }
                function y() {
                    return void 0 === j ? w : p(o());
                }
                function b() {
                    var t = o(), n = d(t);
                    if (x = arguments, m = this, O = t, n) {
                        if (void 0 === j) return a(O);
                        if (_) return j = setTimeout(h, e), r(O);
                    }
                    return void 0 === j && (j = setTimeout(h, e)), w;
                }
                var x, m, g, w, j, O, E = 0, M = !1, _ = !1, T = !0;
                if ("function" != typeof t) throw new TypeError(f);
                return e = u(e) || 0, i(n) && (M = !!n.leading, _ = "maxWait" in n, g = _ ? s(u(n.maxWait) || 0, e) : g, T = "trailing" in n ? !!n.trailing : T), b.cancel = v, b.flush = y, b;
            }
            var i = n(1), o = n(8), u = n(10), f = "Expected a function", s = Math.max, c = Math.min;
            t.exports = r;
        },
        function(t, e, n) {
            var r = n(6), i = function() {
                return r.Date.now();
            };
            t.exports = i;
        },
        function(t, e, n) {
            function r(t, e, n) {
                var r = !0, f = !0;
                if ("function" != typeof t) throw new TypeError(u);
                return o(n) && (r = "leading" in n ? !!n.leading : r, f = "trailing" in n ? !!n.trailing : f), i(t, e, {
                    leading: r,
                    maxWait: e,
                    trailing: f
                });
            }
            var i = n(7), o = n(1), u = "Expected a function";
            t.exports = r;
        },
        function(t, e) {
            function n(t) {
                return t;
            }
            t.exports = n;
        }
    ]);
});


var $e42377b553de1771$exports = {};
/*!
 * MoveTo - A lightweight scroll animation javascript library without any dependency.
 * Version 1.8.2 (28-06-2019 14:30)
 * Licensed under MIT
 * Copyright 2019 Hasan Aydoğdu <hsnaydd@gmail.com>
 */ "use strict";
var $e42377b553de1771$var$MoveTo = function() {
    /**
   * Defaults
   * @type {object}
   */ var defaults = {
        tolerance: 0,
        duration: 800,
        easing: 'easeOutQuart',
        container: window,
        callback: function callback() {}
    };
    /**
   * easeOutQuart Easing Function
   * @param  {number} t - current time
   * @param  {number} b - start value
   * @param  {number} c - change in value
   * @param  {number} d - duration
   * @return {number} - calculated value
   */ function easeOutQuart(t, b, c, d) {
        t /= d;
        t--;
        return -c * (t * t * t * t - 1) + b;
    }
    /**
   * Merge two object
   *
   * @param  {object} obj1
   * @param  {object} obj2
   * @return {object} merged object
   */ function mergeObject(obj1, obj2) {
        var obj3 = {};
        Object.keys(obj1).forEach(function(propertyName) {
            obj3[propertyName] = obj1[propertyName];
        });
        Object.keys(obj2).forEach(function(propertyName) {
            obj3[propertyName] = obj2[propertyName];
        });
        return obj3;
    }
    /**
   * Converts camel case to kebab case
   * @param  {string} val the value to be converted
   * @return {string} the converted value
   */ function kebabCase(val) {
        return val.replace(/([A-Z])/g, function($1) {
            return '-' + $1.toLowerCase();
        });
    }
    /**
   * Count a number of item scrolled top
   * @param  {Window|HTMLElement} container
   * @return {number}
   */ function countScrollTop(container) {
        if (container instanceof HTMLElement) return container.scrollTop;
        return container.pageYOffset;
    }
    /**
   * MoveTo Constructor
   * @param {object} options Options
   * @param {object} easeFunctions Custom ease functions
   */ function MoveTo() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var easeFunctions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.options = mergeObject(defaults, options);
        this.easeFunctions = mergeObject({
            easeOutQuart: easeOutQuart
        }, easeFunctions);
    }
    /**
   * Register a dom element as trigger
   * @param  {HTMLElement} dom Dom trigger element
   * @param  {function} callback Callback function
   * @return {function|void} unregister function
   */ MoveTo.prototype.registerTrigger = function(dom, callback) {
        var _this = this;
        if (!dom) return;
        var href = dom.getAttribute('href') || dom.getAttribute('data-target'); // The element to be scrolled
        var target = href && href !== '#' ? document.getElementById(href.substring(1)) : document.body;
        var options = mergeObject(this.options, _getOptionsFromTriggerDom(dom, this.options));
        if (typeof callback === 'function') options.callback = callback;
        var listener = function listener(e) {
            e.preventDefault();
            _this.move(target, options);
        };
        dom.addEventListener('click', listener, false);
        return function() {
            return dom.removeEventListener('click', listener, false);
        };
    };
    /**
   * Move
   * Scrolls to given element by using easeOutQuart function
   * @param  {HTMLElement|number} target Target element to be scrolled or target position
   * @param  {object} options Custom options
   */ MoveTo.prototype.move = function(target) {
        var _this2 = this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (target !== 0 && !target) return;
        options = mergeObject(this.options, options);
        var distance = typeof target === 'number' ? target : target.getBoundingClientRect().top;
        var from = countScrollTop(options.container);
        var startTime = null;
        var lastYOffset;
        distance -= options.tolerance; // rAF loop
        var loop = function loop(currentTime) {
            var currentYOffset = countScrollTop(_this2.options.container);
            if (!startTime) // To starts time from 1, we subtracted 1 from current time
            // If time starts from 1 The first loop will not do anything,
            // because easing value will be zero
            startTime = currentTime - 1;
            var timeElapsed = currentTime - startTime;
            if (lastYOffset) {
                if (distance > 0 && lastYOffset > currentYOffset || distance < 0 && lastYOffset < currentYOffset) return options.callback(target);
            }
            lastYOffset = currentYOffset;
            var val = _this2.easeFunctions[options.easing](timeElapsed, from, distance, options.duration);
            options.container.scroll(0, val);
            if (timeElapsed < options.duration) window.requestAnimationFrame(loop);
            else {
                options.container.scroll(0, distance + from);
                options.callback(target);
            }
        };
        window.requestAnimationFrame(loop);
    };
    /**
   * Adds custom ease function
   * @param {string}   name Ease function name
   * @param {function} fn   Ease function
   */ MoveTo.prototype.addEaseFunction = function(name, fn) {
        this.easeFunctions[name] = fn;
    };
    /**
   * Returns options which created from trigger dom element
   * @param  {HTMLElement} dom Trigger dom element
   * @param  {object} options The instance's options
   * @return {object} The options which created from trigger dom element
   */ function _getOptionsFromTriggerDom(dom, options) {
        var domOptions = {};
        Object.keys(options).forEach(function(key) {
            var value = dom.getAttribute("data-mt-".concat(kebabCase(key)));
            if (value) domOptions[key] = isNaN(value) ? value : parseInt(value, 10);
        });
        return domOptions;
    }
    return MoveTo;
}();
$e42377b553de1771$exports = $e42377b553de1771$var$MoveTo;


var $88f122e76165d869$exports = {};
var $9556343f6439611b$exports = {};
function $9556343f6439611b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9556343f6439611b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9556343f6439611b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9556343f6439611b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9556343f6439611b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Sticky.js
 * Library for sticky elements written in vanilla javascript. With this library you can easily set sticky elements on your website. It's also responsive.
 *
 * @version 1.3.0
 * @author Rafal Galus <biuro@rafalgalus.pl>
 * @website https://rgalus.github.io/sticky-js/
 * @repo https://github.com/rgalus/sticky-js
 * @license https://github.com/rgalus/sticky-js/blob/master/LICENSE
 */ var $9556343f6439611b$var$Sticky = /*#__PURE__*/ function() {
    /**
   * Sticky instance constructor
   * @constructor
   * @param {string} selector - Selector which we can find elements
   * @param {string} options - Global options for sticky elements (could be overwritten by data-{option}="" attributes)
   */ function Sticky() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $9556343f6439611b$var$_classCallCheck(this, Sticky);
        this.selector = selector;
        this.elements = [];
        this.version = '1.3.0';
        this.vp = this.getViewportSize();
        this.body = document.querySelector('body');
        this.options = {
            wrap: options.wrap || false,
            wrapWith: options.wrapWith || '<span></span>',
            marginTop: options.marginTop || 0,
            marginBottom: options.marginBottom || 0,
            stickyFor: options.stickyFor || 0,
            stickyClass: options.stickyClass || null,
            stickyContainer: options.stickyContainer || 'body'
        };
        this.updateScrollTopPosition = this.updateScrollTopPosition.bind(this);
        this.updateScrollTopPosition();
        window.addEventListener('load', this.updateScrollTopPosition);
        window.addEventListener('scroll', this.updateScrollTopPosition);
        this.run();
    }
    /**
   * Function that waits for page to be fully loaded and then renders & activates every sticky element found with specified selector
   * @function
   */ $9556343f6439611b$var$_createClass(Sticky, [
        {
            key: "run",
            value: function run() {
                var _this = this;
                // wait for page to be fully loaded
                var pageLoaded = setInterval(function() {
                    if (document.readyState === 'complete') {
                        clearInterval(pageLoaded);
                        var elements = document.querySelectorAll(_this.selector);
                        _this.forEach(elements, function(element) {
                            return _this.renderElement(element);
                        });
                    }
                }, 10);
            }
        },
        {
            key: "renderElement",
            value: function renderElement(element) {
                var _this2 = this;
                // create container for variables needed in future
                element.sticky = {}; // set default variables
                element.sticky.active = false;
                element.sticky.marginTop = parseInt(element.getAttribute('data-margin-top')) || this.options.marginTop;
                element.sticky.marginBottom = parseInt(element.getAttribute('data-margin-bottom')) || this.options.marginBottom;
                element.sticky.stickyFor = parseInt(element.getAttribute('data-sticky-for')) || this.options.stickyFor;
                element.sticky.stickyClass = element.getAttribute('data-sticky-class') || this.options.stickyClass;
                element.sticky.wrap = element.hasAttribute('data-sticky-wrap') ? true : this.options.wrap; // @todo attribute for stickyContainer
                // element.sticky.stickyContainer = element.getAttribute('data-sticky-container') || this.options.stickyContainer;
                element.sticky.stickyContainer = this.options.stickyContainer;
                element.sticky.container = this.getStickyContainer(element);
                element.sticky.container.rect = this.getRectangle(element.sticky.container);
                element.sticky.rect = this.getRectangle(element); // fix when element is image that has not yet loaded and width, height = 0
                if (element.tagName.toLowerCase() === 'img') element.onload = function() {
                    return element.sticky.rect = _this2.getRectangle(element);
                };
                if (element.sticky.wrap) this.wrapElement(element);
                 // activate rendered element
                this.activate(element);
            }
        },
        {
            key: "wrapElement",
            value: function wrapElement(element) {
                element.insertAdjacentHTML('beforebegin', element.getAttribute('data-sticky-wrapWith') || this.options.wrapWith);
                element.previousSibling.appendChild(element);
            }
        },
        {
            key: "activate",
            value: function activate(element) {
                if (element.sticky.rect.top + element.sticky.rect.height < element.sticky.container.rect.top + element.sticky.container.rect.height && element.sticky.stickyFor < this.vp.width && !element.sticky.active) element.sticky.active = true;
                if (this.elements.indexOf(element) < 0) this.elements.push(element);
                if (!element.sticky.resizeEvent) {
                    this.initResizeEvents(element);
                    element.sticky.resizeEvent = true;
                }
                if (!element.sticky.scrollEvent) {
                    this.initScrollEvents(element);
                    element.sticky.scrollEvent = true;
                }
                this.setPosition(element);
            }
        },
        {
            key: "initResizeEvents",
            value: function initResizeEvents(element) {
                var _this3 = this;
                element.sticky.resizeListener = function() {
                    return _this3.onResizeEvents(element);
                };
                window.addEventListener('resize', element.sticky.resizeListener);
            }
        },
        {
            key: "destroyResizeEvents",
            value: function destroyResizeEvents(element) {
                window.removeEventListener('resize', element.sticky.resizeListener);
            }
        },
        {
            key: "onResizeEvents",
            value: function onResizeEvents(element) {
                this.vp = this.getViewportSize();
                element.sticky.rect = this.getRectangle(element);
                element.sticky.container.rect = this.getRectangle(element.sticky.container);
                if (element.sticky.rect.top + element.sticky.rect.height < element.sticky.container.rect.top + element.sticky.container.rect.height && element.sticky.stickyFor < this.vp.width && !element.sticky.active) element.sticky.active = true;
                else if (element.sticky.rect.top + element.sticky.rect.height >= element.sticky.container.rect.top + element.sticky.container.rect.height || element.sticky.stickyFor >= this.vp.width && element.sticky.active) element.sticky.active = false;
                this.setPosition(element);
            }
        },
        {
            key: "initScrollEvents",
            value: function initScrollEvents(element) {
                var _this4 = this;
                element.sticky.scrollListener = function() {
                    return _this4.onScrollEvents(element);
                };
                window.addEventListener('scroll', element.sticky.scrollListener);
            }
        },
        {
            key: "destroyScrollEvents",
            value: function destroyScrollEvents(element) {
                window.removeEventListener('scroll', element.sticky.scrollListener);
            }
        },
        {
            key: "onScrollEvents",
            value: function onScrollEvents(element) {
                if (element.sticky && element.sticky.active) this.setPosition(element);
            }
        },
        {
            key: "setPosition",
            value: function setPosition(element) {
                this.css(element, {
                    position: '',
                    width: '',
                    top: '',
                    left: ''
                });
                if (this.vp.height < element.sticky.rect.height || !element.sticky.active) return;
                if (!element.sticky.rect.width) element.sticky.rect = this.getRectangle(element);
                if (element.sticky.wrap) this.css(element.parentNode, {
                    display: 'block',
                    width: element.sticky.rect.width + 'px',
                    height: element.sticky.rect.height + 'px'
                });
                if (element.sticky.rect.top === 0 && element.sticky.container === this.body) {
                    this.css(element, {
                        position: 'fixed',
                        top: element.sticky.rect.top + 'px',
                        left: element.sticky.rect.left + 'px',
                        width: element.sticky.rect.width + 'px'
                    });
                    if (element.sticky.stickyClass) element.classList.add(element.sticky.stickyClass);
                } else if (this.scrollTop > element.sticky.rect.top - element.sticky.marginTop) {
                    this.css(element, {
                        position: 'fixed',
                        width: element.sticky.rect.width + 'px',
                        left: element.sticky.rect.left + 'px'
                    });
                    if (this.scrollTop + element.sticky.rect.height + element.sticky.marginTop > element.sticky.container.rect.top + element.sticky.container.offsetHeight - element.sticky.marginBottom) {
                        if (element.sticky.stickyClass) element.classList.remove(element.sticky.stickyClass);
                        this.css(element, {
                            top: element.sticky.container.rect.top + element.sticky.container.offsetHeight - (this.scrollTop + element.sticky.rect.height + element.sticky.marginBottom) + 'px'
                        });
                    } else {
                        if (element.sticky.stickyClass) element.classList.add(element.sticky.stickyClass);
                        this.css(element, {
                            top: element.sticky.marginTop + 'px'
                        });
                    }
                } else {
                    if (element.sticky.stickyClass) element.classList.remove(element.sticky.stickyClass);
                    this.css(element, {
                        position: '',
                        width: '',
                        top: '',
                        left: ''
                    });
                    if (element.sticky.wrap) this.css(element.parentNode, {
                        display: '',
                        width: '',
                        height: ''
                    });
                }
            }
        },
        {
            key: "update",
            value: function update() {
                var _this5 = this;
                this.forEach(this.elements, function(element) {
                    element.sticky.rect = _this5.getRectangle(element);
                    element.sticky.container.rect = _this5.getRectangle(element.sticky.container);
                    _this5.activate(element);
                    _this5.setPosition(element);
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this6 = this;
                window.removeEventListener('load', this.updateScrollTopPosition);
                window.removeEventListener('scroll', this.updateScrollTopPosition);
                this.forEach(this.elements, function(element) {
                    _this6.destroyResizeEvents(element);
                    _this6.destroyScrollEvents(element);
                    delete element.sticky;
                });
            }
        },
        {
            key: "getStickyContainer",
            value: function getStickyContainer(element) {
                var container = element.parentNode;
                while(!container.hasAttribute('data-sticky-container') && !container.parentNode.querySelector(element.sticky.stickyContainer) && container !== this.body)container = container.parentNode;
                return container;
            }
        },
        {
            key: "getRectangle",
            value: function getRectangle(element) {
                this.css(element, {
                    position: '',
                    width: '',
                    top: '',
                    left: ''
                });
                var width = Math.max(element.offsetWidth, element.clientWidth, element.scrollWidth);
                var height = Math.max(element.offsetHeight, element.clientHeight, element.scrollHeight);
                var top = 0;
                var left = 0;
                do {
                    top += element.offsetTop || 0;
                    left += element.offsetLeft || 0;
                    element = element.offsetParent;
                }while (element);
                return {
                    top: top,
                    left: left,
                    width: width,
                    height: height
                };
            }
        },
        {
            key: "getViewportSize",
            value: function getViewportSize() {
                return {
                    width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                    height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
                };
            }
        },
        {
            key: "updateScrollTopPosition",
            value: function updateScrollTopPosition() {
                this.scrollTop = (window.pageYOffset || document.scrollTop) - (document.clientTop || 0) || 0;
            }
        },
        {
            key: "forEach",
            value: function forEach(array, callback) {
                for(var i = 0, len = array.length; i < len; i++)callback(array[i]);
            }
        },
        {
            key: "css",
            value: function css(element, properties) {
                for(var property in properties)if (properties.hasOwnProperty(property)) element.style[property] = properties[property];
            }
        }
    ]);
    return Sticky;
}();
/**
 * Export function that supports AMD, CommonJS and Plain Browser.
 */ (function(root, factory) {
    $9556343f6439611b$exports = factory;
})($9556343f6439611b$exports, $9556343f6439611b$var$Sticky);


$88f122e76165d869$exports = $9556343f6439611b$exports;


var $7c96b06127133ec4$exports = {};
/*! tabbyjs v12.0.3 | (c) 2019 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/tabby */ Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), function(e, t) {
    "function" == typeof define && define.amd ? define([], function() {
        return t(e);
    }) : $7c96b06127133ec4$exports = t(e);
}("undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof window ? window : $7c96b06127133ec4$exports, function(e) {
    "use strict";
    var t = {
        idPrefix: "tabby-toggle_",
        default: "[data-tabby-default]"
    }, r = function(t) {
        if (t && "true" != t.getAttribute("aria-selected")) {
            var r = document.querySelector(t.hash);
            if (r) {
                var o = function(e) {
                    var t = e.closest('[role="tablist"]');
                    if (!t) return {};
                    var r = t.querySelector('[role="tab"][aria-selected="true"]');
                    if (!r) return {};
                    var o = document.querySelector(r.hash);
                    return r.setAttribute("aria-selected", "false"), r.setAttribute("tabindex", "-1"), o ? (o.setAttribute("hidden", "hidden"), {
                        previousTab: r,
                        previousContent: o
                    }) : {
                        previousTab: r
                    };
                }(t);
                !function(e, t) {
                    e.setAttribute("aria-selected", "true"), e.setAttribute("tabindex", "0"), t.removeAttribute("hidden"), e.focus();
                }(t, r), o.tab = t, o.content = r, function(t, r) {
                    var o;
                    "function" == typeof e.CustomEvent ? o = new CustomEvent("tabby", {
                        bubbles: !0,
                        cancelable: !0,
                        detail: r
                    }) : (o = document.createEvent("CustomEvent")).initCustomEvent("tabby", !0, !0, r), t.dispatchEvent(o);
                }(t, o);
            }
        }
    }, o = function(e, t) {
        var o = function(e) {
            var t = e.closest('[role="tablist"]'), r = t ? t.querySelectorAll('[role="tab"]') : null;
            if (r) return {
                tabs: r,
                index: Array.prototype.indexOf.call(r, e)
            };
        }(e);
        if (o) {
            var n, i = o.tabs.length - 1;
            [
                "ArrowUp",
                "ArrowLeft",
                "Up",
                "Left"
            ].indexOf(t) > -1 ? n = o.index < 1 ? i : o.index - 1 : [
                "ArrowDown",
                "ArrowRight",
                "Down",
                "Right"
            ].indexOf(t) > -1 ? n = o.index === i ? 0 : o.index + 1 : "Home" === t ? n = 0 : "End" === t && (n = i), r(o.tabs[n]);
        }
    };
    return function(n, i) {
        var a, u, l = {};
        l.destroy = function() {
            var e = u.querySelectorAll("a");
            Array.prototype.forEach.call(e, function(e) {
                var t = document.querySelector(e.hash);
                t && function(e, t, r) {
                    e.id.slice(0, r.idPrefix.length) === r.idPrefix && (e.id = ""), e.removeAttribute("role"), e.removeAttribute("aria-controls"), e.removeAttribute("aria-selected"), e.removeAttribute("tabindex"), e.closest("li").removeAttribute("role"), t.removeAttribute("role"), t.removeAttribute("aria-labelledby"), t.removeAttribute("hidden");
                }(e, t, a);
            }), u.removeAttribute("role"), document.documentElement.removeEventListener("click", c, !0), u.removeEventListener("keydown", d, !0), a = null, u = null;
        }, l.setup = function() {
            if (u = document.querySelector(n)) {
                var e = u.querySelectorAll("a");
                u.setAttribute("role", "tablist"), Array.prototype.forEach.call(e, function(e) {
                    var t = document.querySelector(e.hash);
                    t && function(e, t, r) {
                        e.id || (e.id = r.idPrefix + t.id), e.setAttribute("role", "tab"), e.setAttribute("aria-controls", t.id), e.closest("li").setAttribute("role", "presentation"), t.setAttribute("role", "tabpanel"), t.setAttribute("aria-labelledby", e.id), e.matches(r.default) ? e.setAttribute("aria-selected", "true") : (e.setAttribute("aria-selected", "false"), e.setAttribute("tabindex", "-1"), t.setAttribute("hidden", "hidden"));
                    }(e, t, a);
                });
            }
        }, l.toggle = function(e) {
            var t = e;
            "string" == typeof e && (t = document.querySelector(n + ' [role="tab"][href*="' + e + '"]')), r(t);
        };
        var c = function(e) {
            var t = e.target.closest(n + ' [role="tab"]');
            t && (e.preventDefault(), r(t));
        }, d = function(e) {
            var t = document.activeElement;
            t.matches(n + ' [role="tab"]') && ([
                "ArrowUp",
                "ArrowDown",
                "ArrowLeft",
                "ArrowRight",
                "Up",
                "Down",
                "Left",
                "Right",
                "Home",
                "End"
            ].indexOf(e.key) < 0 || o(t, e.key));
        };
        return a = function() {
            var e = {};
            return Array.prototype.forEach.call(arguments, function(t) {
                for(var r in t){
                    if (!t.hasOwnProperty(r)) return;
                    e[r] = t[r];
                }
            }), e;
        }(t, i || {}), l.setup(), function(t) {
            if (!(e.location.hash.length < 1)) {
                var o = document.querySelector(t + ' [role="tab"][href*="' + e.location.hash + '"]');
                r(o);
            }
        }(n), document.documentElement.addEventListener("click", c, !0), u.addEventListener("keydown", d, !0), l;
    };
});


const $60ff56cf03458df5$var$getMap = document.querySelector('#map');
if ($60ff56cf03458df5$var$getMap) {
    var $60ff56cf03458df5$var$script = document.createElement('script');
    $60ff56cf03458df5$var$script.onload = function() {
        // get locations
        const locations = document.querySelectorAll('.js-marker');
        // const firstLocation = { lat: + locations[0].getAttribute('data-lat') + ',' + lng: + locations[0].getAttribute('data-lng') };
        // console.log(firstLocation);
        // set map
        var map = new google.maps.Map($60ff56cf03458df5$var$getMap, {
            zoom: 7,
            scrollwheel: false,
            center: new google.maps.LatLng(52.370216, 4.895168),
            mapTypeControl: false,
            streetViewControl: false,
            styles: [
                {
                    featureType: "all",
                    elementType: "geometry",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "administrative",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "administrative.country",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            color: "#afafaf"
                        }
                    ]
                },
                {
                    featureType: "administrative.province",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "off"
                        }
                    ]
                },
                {
                    featureType: "administrative.land_parcel",
                    elementType: "geometry",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "landscape",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "landscape.man_made",
                    elementType: "geometry",
                    stylers: [
                        {
                            saturation: "25"
                        },
                        {
                            lightness: "46"
                        },
                        {
                            gamma: "1.26"
                        }
                    ]
                },
                {
                    featureType: "landscape.man_made",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            visibility: "on"
                        },
                        {
                            hue: "#ff0000"
                        }
                    ]
                },
                {
                    featureType: "landscape.man_made",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            hue: "#ff0000"
                        }
                    ]
                },
                {
                    featureType: "landscape.natural",
                    elementType: "geometry",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "poi",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [
                        {
                            visibility: "on"
                        },
                        {
                            color: "#b6edb6"
                        },
                        {
                            weight: "0.33"
                        },
                        {
                            lightness: "16"
                        },
                        {
                            saturation: "-17"
                        }
                    ]
                },
                {
                    featureType: "poi.attraction",
                    elementType: "labels",
                    stylers: [
                        {
                            visibility: "off"
                        }
                    ]
                },
                {
                    featureType: "poi.business",
                    elementType: "geometry",
                    stylers: [
                        {
                            visibility: "on"
                        },
                        {
                            color: "#ede4e4"
                        },
                        {
                            saturation: "-63"
                        },
                        {
                            gamma: "0.38"
                        },
                        {
                            lightness: "61"
                        }
                    ]
                },
                {
                    featureType: "poi.medical",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#f4b4b4"
                        },
                        {
                            saturation: "-16"
                        },
                        {
                            lightness: "20"
                        }
                    ]
                },
                {
                    featureType: "poi.medical",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "poi.park",
                    elementType: "labels.text",
                    stylers: [
                        {
                            visibility: "off"
                        }
                    ]
                },
                {
                    featureType: "poi.school",
                    elementType: "geometry",
                    stylers: [
                        {
                            visibility: "on"
                        },
                        {
                            color: "#fbc99b"
                        },
                        {
                            lightness: "12"
                        },
                        {
                            gamma: "2.39"
                        }
                    ]
                },
                {
                    featureType: "road.highway",
                    elementType: "all",
                    stylers: [
                        {
                            color: "#fdcb9b"
                        }
                    ]
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            visibility: "on"
                        },
                        {
                            color: "#f2af67"
                        },
                        {
                            lightness: "47"
                        },
                        {
                            saturation: "64"
                        },
                        {
                            gamma: "0.95"
                        }
                    ]
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            visibility: "on"
                        },
                        {
                            saturation: "-18"
                        },
                        {
                            lightness: "61"
                        },
                        {
                            gamma: "7.93"
                        },
                        {
                            weight: "0.30"
                        },
                        {
                            color: "#db8828"
                        }
                    ]
                },
                {
                    featureType: "road.highway",
                    elementType: "labels.text",
                    stylers: [
                        {
                            weight: "0.79"
                        },
                        {
                            gamma: "3.19"
                        },
                        {
                            lightness: "-73"
                        },
                        {
                            saturation: "-76"
                        },
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            invert_lightness: !0
                        },
                        {
                            weight: "2.90"
                        },
                        {
                            color: "#786e6e"
                        }
                    ]
                },
                {
                    featureType: "road.highway",
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            visibility: "off"
                        }
                    ]
                },
                {
                    featureType: "road.highway",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            visibility: "off"
                        },
                        {
                            color: "#5da554"
                        }
                    ]
                },
                {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "road.local",
                    elementType: "geometry",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "water",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#7fd4ef"
                        },
                        {
                            saturation: "13"
                        },
                        {
                            lightness: "-3"
                        },
                        {
                            gamma: "1.13"
                        },
                        {
                            weight: "0.30"
                        }
                    ]
                }
            ]
        });
        const bounds = new google.maps.LatLngBounds();
        // set markers
        for(let i = 0; i < locations.length; i++){
            let lat = locations[i].getAttribute('data-lat');
            let lng = locations[i].getAttribute('data-lng');
            let infoWindow = new google.maps.InfoWindow();
            let marker = new google.maps.Marker({
                position: new google.maps.LatLng(lat, lng),
                map: map,
                icon: '/wp-content/themes/prins/img/pin.svg'
            });
            marker.addListener('click', function() {
                const contact = locations[i].querySelector('.dealer__contact').innerHTML;
                const html = `
                    <div class="map__infowindow">
                        <strong>${locations[i].getAttribute('data-name')}</strong>
                        <p style="margin: 0.5rem 0">${contact}</p>
                    </div>
                `;
                infoWindow.setContent(html);
                infoWindow.open(map, this);
            });
        }
    };
    $60ff56cf03458df5$var$script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDIGGzax1FAndCBkojJHkzhosa2DKKzx6M";
    document.head.appendChild($60ff56cf03458df5$var$script);
}


const $e8ff40c58f406c8c$var$knoppen = document.querySelectorAll('button[data-filter]');
if ($e8ff40c58f406c8c$var$knoppen.length) {
    function filterSelection(c) {
        var x, i;
        x = document.getElementsByClassName("dealer");
        if (c == "Alles") c = "";
        // Add the "show" class (display:block) to the filtered elements, and remove the "show" class from the elements that are not selected
        for(i = 0; i < x.length; i++){
            removeClass(x[i], "show");
            if (x[i].className.indexOf(c) > -1) addClass(x[i], "show");
        }
    }
    // Show filtered elements
    function addClass(element, name) {
        var i, arr1, arr2;
        arr1 = element.className.split(" ");
        arr2 = name.split(" ");
        for(i = 0; i < arr2.length; i++)if (arr1.indexOf(arr2[i]) == -1) element.className += " " + arr2[i];
    }
    // Hide elements that are not selected
    function removeClass(element, name) {
        var i, arr1, arr2;
        arr1 = element.className.split(" ");
        arr2 = name.split(" ");
        for(i = 0; i < arr2.length; i++)while(arr1.indexOf(arr2[i]) > -1)arr1.splice(arr1.indexOf(arr2[i]), 1);
        element.className = arr1.join(" ");
    }
    // Add active class to the current control button (highlight it)
    var $e8ff40c58f406c8c$var$btnContainer = document.querySelector(".dealers__filter");
    var $e8ff40c58f406c8c$var$btns = $e8ff40c58f406c8c$var$btnContainer.querySelectorAll(".btn");
    for(var $e8ff40c58f406c8c$var$i = 0; $e8ff40c58f406c8c$var$i < $e8ff40c58f406c8c$var$btns.length; $e8ff40c58f406c8c$var$i++)$e8ff40c58f406c8c$var$btns[$e8ff40c58f406c8c$var$i].addEventListener("click", function() {
        var current = document.getElementsByClassName("active");
        current[0].className = current[0].className.replace(" active", "");
        this.className += " active";
    });
    for(let i = 0; i < $e8ff40c58f406c8c$var$knoppen.length; i++)$e8ff40c58f406c8c$var$knoppen[i].addEventListener("click", function() {
        let country = this.innerHTML;
        filterSelection(country);
    });
    filterSelection('Alles');
}


/* global wc_cp_composite_scripts */ (function($) {
    $('.composite_data').on('wc-composite-initializing', function(event, composite) {
        // get_component_totals
        // component_selection_changed
        // component_selection_content_changed
        // component_totals_changed
        // composite_totals_changed
        composite.actions.add_action('composite_totals_changed', function() {
            var newPrice = composite.api.get_composite_totals().price;
            var urlLink = document.getElementById('update_finance_link');
            var urlInput = document.getElementById('update_finance_input');
            if (urlInput) {
                var urlStart = urlInput.dataset.urlStart;
                var urlEnd = String(urlInput.dataset.urlEnd);
                var urlNew = urlStart + '&v8=' + newPrice + urlEnd;
            }
            if (urlLink) urlLink.setAttribute('href', urlNew);
        }, 100);
    });
})(jQuery);


function $a29041ce1dffae10$export$2e59f49d97a9dbde() {
    const searchButton = document.querySelector('.header__search-toggle');
    const searchButton2 = document.querySelector('.contact__item--search');
    const searchContainer = document.querySelector('.header__search');
    searchButton.addEventListener('click', ()=>{
        searchButton.classList.toggle('toggled');
        searchContainer.classList.toggle('toggled');
        searchContainer.querySelector('input').focus();
    });
    searchButton2.addEventListener('click', ()=>{
        searchButton2.classList.toggle('toggled');
        searchContainer.classList.toggle('toggled');
        searchContainer.querySelector('input').focus();
    });
}


var $76dec6bf8655ca06$exports = {};
/*!
 * Modals v10.1.2: Simple modal dialogue pop-up windows
 * (c) 2017 Chris Ferdinandi
 * MIT License
 * http://github.com/cferdinandi/modals
 */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) define([], factory(root));
    else $76dec6bf8655ca06$exports = factory(root);
})(typeof $parcel$global !== 'undefined' ? $parcel$global : $76dec6bf8655ca06$exports.window || $76dec6bf8655ca06$exports.global, function(root) {
    'use strict';
    //
    // Variables
    //
    var publicApi = {}; // Object for public APIs
    var supports = 'querySelector' in document && 'addEventListener' in root && 'classList' in document.createElement('_'); // Feature test
    var state = 'closed';
    var scrollbarWidth, placeholder, settings;
    // Default settings
    var defaults = {
        selectorToggle: '[data-modal]',
        selectorWindow: '[data-modal-window]',
        selectorClose: '[data-modal-close]',
        modalActiveClass: 'active',
        modalBGClass: 'modal-bg',
        preventBGScroll: true,
        preventBGScrollHtml: true,
        preventBGScrollBody: true,
        backspaceClose: false,
        stopVideo: true,
        callbackOpen: function() {},
        callbackClose: function() {}
    };
    //
    // Methods
    //
    /**
     * A simple forEach() implementation for Arrays, Objects and NodeLists.
     * @private
     * @author Todd Motto
     * @link   https://github.com/toddmotto/foreach
     * @param {Array|Object|NodeList} collection Collection of items to iterate
     * @param {Function}              callback   Callback function for each iteration
     * @param {Array|Object|NodeList} scope      Object/NodeList/Array that forEach is iterating over (aka `this`)
     */ var forEach = function(collection, callback, scope) {
        if (Object.prototype.toString.call(collection) === '[object Object]') {
            for(var prop in collection)if (Object.prototype.hasOwnProperty.call(collection, prop)) callback.call(scope, collection[prop], prop, collection);
        } else for(var i = 0, len = collection.length; i < len; i++)callback.call(scope, collection[i], i, collection);
    };
    /**
     * Merge two or more objects. Returns a new object.
     * @private
     * @param {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
     * @param {Object}   objects  The objects to merge together
     * @returns {Object}          Merged values of defaults and options
     */ var extend = function() {
        // Variables
        var extended = {};
        var deep = false;
        var i = 0;
        var length = arguments.length;
        // Check if a deep merge
        if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
            deep = arguments[0];
            i++;
        }
        // Merge the object into the extended object
        var merge = function(obj) {
            for(var prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                // If deep merge and property is an object, merge properties
                if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') extended[prop] = extend(true, extended[prop], obj[prop]);
                else extended[prop] = obj[prop];
            }
        };
        // Loop through each object and conduct a merge
        for(; i < length; i++){
            var obj = arguments[i];
            merge(obj);
        }
        return extended;
    };
    /**
     * Get the closest matching element up the DOM tree.
     * @private
     * @param  {Element} elem     Starting element
     * @param  {String}  selector Selector to match against
     * @return {Boolean|Element}  Returns null if not match found
     */ var getClosest = function(elem, selector) {
        // Element.matches() polyfill
        if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s), i = matches.length;
            while(--i >= 0 && matches.item(i) !== this);
            return i > -1;
        };
        // Get closest match
        for(; elem && elem !== document; elem = elem.parentNode){
            if (elem.matches(selector)) return elem;
        }
        return null;
    };
    /**
     * Stop YouTube, Vimeo, and HTML5 videos from playing when leaving the slide
     * @private
     * @param  {Element} content The content container the video is in
     * @param  {String} activeClass The class asigned to expanded content areas
     */ var stopVideos = function(content, settings) {
        // Check if stop video enabled
        if (!settings.stopVideo) return;
        // Only run if content container was open
        if (!content.classList.contains(settings.modalActiveClass)) return;
        // Check if the video is an iframe or HTML5 video
        var iframe = content.querySelector('iframe');
        var video = content.querySelector('video');
        // Stop the video
        if (iframe) {
            var iframeSrc = iframe.src;
            iframe.src = iframeSrc;
        }
        if (video) video.pause();
    };
    /**
     * Get the width of the scroll bars
     * @private
     */ var getScrollbarWidth = function() {
        // Setup div
        var outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.width = '100px';
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
        document.body.appendChild(outer);
        // Force scrollbars
        var widthNoScroll = outer.offsetWidth;
        outer.style.overflow = 'scroll';
        // Add innerdiv
        var inner = document.createElement('div');
        inner.style.width = '100%';
        outer.appendChild(inner);
        var widthWithScroll = inner.offsetWidth;
        // Remove divs
        outer.parentNode.removeChild(outer);
        return widthNoScroll - widthWithScroll;
    };
    /**
     * Create the modal background and append it to the DOM
     * @private
     */ var createModalBg = function() {
        // If modal BG already exists, don't create another one
        if (document.querySelector('[data-modal-bg]')) return;
        // Define the modal background
        var modalBg = document.createElement('div');
        modalBg.setAttribute('data-modal-bg', true);
        modalBg.classList.add(settings.modalBGClass);
        // Append the modal background to the page
        document.body.appendChild(modalBg);
    };
    /**
     * Remove the modal background from the DOM
     * @private
     */ var removeModalBg = function() {
        var modalBg = document.querySelector('[data-modal-bg]');
        if (!modalBg) return;
        document.body.removeChild(modalBg);
    };
    /**
     * Close open modal window
     * @public
     * @param  {Object} options
     * @param  {Event} event
     */ publicApi.closeModal = function(options) {
        // Selectors and variables
        var localSettings = extend(settings || defaults, options || {}); // Merge user options with defaults
        var modal = document.querySelector(localSettings.selectorWindow + '.' + localSettings.modalActiveClass); // Get open modal
        // Sanity check
        if (!modal) return;
        // Stop videos from playing
        stopVideos(modal, localSettings);
        // Close the modal
        modal.classList.remove(localSettings.modalActiveClass);
        // Remove the modal background from the DOM
        removeModalBg();
        // Set state to closed
        state = 'closed';
        // Reallow background scrolling
        if (localSettings.preventBGScroll) {
            document.documentElement.style.overflowY = '';
            document.body.style.overflowY = '';
            document.body.style.paddingRight = '';
        }
        // Run callbacks after closing a modal
        localSettings.callbackClose(placeholder, modal);
        // Bring focus back to the button that toggles the modal
        if (placeholder) {
            placeholder.focus();
            placeholder = null;
        }
    };
    /**
     * Open the target modal window
     * @public
     * @param  {Element} toggle The element that toggled the open modal event
     * @param  {String} modalID ID of the modal to open
     * @param  {Object} options
     * @param  {Event} event
     */ publicApi.openModal = function(toggle, modalID, options) {
        // Define the modal
        var localSettings = extend(settings || defaults, options || {}); // Merge user options with defaults
        var modal = document.querySelector(modalID);
        // If a modal is already open, close it first
        if (state === 'open') publicApi.closeModal(localSettings);
        // Save the visitor's spot on the page
        if (toggle) placeholder = toggle;
        // Activate the modal
        modal.classList.add(localSettings.modalActiveClass);
        createModalBg();
        state = 'open';
        // Bring modal into focus
        modal.setAttribute('tabindex', '-1');
        modal.focus();
        // Prevent background scrolling
        if (localSettings.preventBGScroll) {
            if (localSettings.preventBGScrollHtml) document.documentElement.style.overflowY = 'hidden';
            if (localSettings.preventBGScrollBody) document.body.style.overflowY = 'hidden';
            document.body.style.paddingRight = scrollbarWidth + 'px';
        }
        localSettings.callbackOpen(toggle, modal); // Run callbacks after opening a modal
    };
    /**
     * Run a callback after a click or tap, without running duplicate callbacks for the same event
     * @param  {Node}   elem       The element to listen for clicks and taps on
     * @param  {Function} callback The callback function to run on a click or tap
     */ var onClickOrTap = function(elem, callback, destroy) {
        // Remove event listeners
        if (destroy) {
            elem.removeEventListener('touchstart', onTouchStartEvent, false);
            elem.removeEventListener('touchend', onTouchEndEvent, false);
            elem.removeEventListener('click', onClickEvent, false);
            return;
        }
        // Make sure a callback is provided
        if (!callback || typeof callback !== 'function') return;
        // Variables
        var isTouch, startX, startY, distX, distY;
        /**
         * touchstart handler
         * @param  {event} event The touchstart event
         */ var onTouchStartEvent = function(event) {
            // Disable click event
            isTouch = true;
            // Get the starting location and time when finger first touches surface
            startX = event.changedTouches[0].pageX;
            startY = event.changedTouches[0].pageY;
        };
        /**
         * touchend handler
         * @param  {event} event The touchend event
         */ var onTouchEndEvent = function(event) {
            // Get the distance travelled and how long it took
            distX = event.changedTouches[0].pageX - startX;
            distY = event.changedTouches[0].pageY - startY;
            // If a swipe happened, do nothing
            if (Math.abs(distX) >= 7 || Math.abs(distY) >= 10) return;
            // Run callback
            callback(event);
        };
        /**
         * click handler
         * @param  {event} event The click event
         */ var onClickEvent = function(event) {
            // If touch is active, reset and bail
            if (isTouch) {
                isTouch = false;
                return;
            }
            // Run our callback
            callback(event);
        };
        // Event listeners
        elem.addEventListener('touchstart', onTouchStartEvent, false);
        elem.addEventListener('touchend', onTouchEndEvent, false);
        elem.addEventListener('click', onClickEvent, false);
    };
    /**
     * Handle toggle click events
     * @private
     */ var eventHandler = function(event) {
        var toggle = event.target;
        var open = getClosest(toggle, settings.selectorToggle);
        var close = getClosest(toggle, settings.selectorClose);
        var modal = getClosest(toggle, settings.selectorWindow);
        var key = event.keyCode;
        // alert(event.target);
        if (key && state === 'open') {
            if (key === 27 || settings.backspaceClose && (key === 8 || key === 46)) publicApi.closeModal();
        } else if (toggle) {
            if (modal && !close) return;
            else if (open && (!key || key === 13)) {
                event.preventDefault();
                publicApi.openModal(open, open.getAttribute('data-modal'), settings);
            } else if (state === 'open' && close) {
                event.preventDefault();
                publicApi.closeModal();
            }
        }
    };
    /**
     * Destroy the current initialization.
     * @public
     */ publicApi.destroy = function() {
        if (!settings) return;
        onClickOrTap(document, null, true);
        document.removeEventListener('keydown', eventHandler, false);
        document.documentElement.style.overflowY = '';
        document.body.style.overflowY = '';
        document.body.style.paddingRight = '';
        scrollbarWidth = null;
        placeholder = null;
        settings = null;
    };
    /**
     * Initialize Modals
     * @public
     * @param {Object} options User settings
     */ publicApi.init = function(options) {
        // feature test
        if (!supports) return;
        // Destroy any existing initializations
        publicApi.destroy();
        // Merge user options with defaults
        settings = extend(defaults, options || {});
        // Get scrollbar width
        scrollbarWidth = getScrollbarWidth();
        // Listen for events
        onClickOrTap(document, eventHandler);
        document.addEventListener('keydown', eventHandler, false);
    };
    //
    // Public APIs
    //
    return publicApi;
});



// Import scripts
(parcelRequire("gv7vu")).polyfill();
// Hamburger menu
document.querySelector("#nav-toggle").addEventListener("click", function() {
    this.classList.toggle("active");
    let mainNav = document.querySelector('.main-navigation');
    mainNav.classList.toggle('toggled');
});
let $80545390e8862da1$var$tabsEls = document.querySelectorAll('[data-tabs]');
if ($80545390e8862da1$var$tabsEls.length > 0) var $80545390e8862da1$var$tabs = new (0, (/*@__PURE__*/$parcel$interopDefault($7c96b06127133ec4$exports)))('[data-tabs]');
// Masonry & Lightbox grid
const $80545390e8862da1$var$grid = document.querySelector('.grid');
if ($80545390e8862da1$var$grid) {
    const macy = (0, (/*@__PURE__*/$parcel$interopDefault($ad79992743a8d8e2$exports)))({
        container: '.grid',
        margin: 0,
        columns: 5,
        // waitForImages: true,
        breakAt: {
            940: 3,
            400: 2
        }
    });
    macy.runOnImageLoad(function() {
        macy.recalculate(true);
    }, true);
    (0, (/*@__PURE__*/$parcel$interopDefault($4e5e8be31315b18e$exports))).run('.grid', {
        animation: 'slideIn'
    });
}
(0, (/*@__PURE__*/$parcel$interopDefault($95fda1bea70891c7$exports)))('#first').on('enter', function() {
    document.querySelector('#first').classList.add('active');
});
(0, (/*@__PURE__*/$parcel$interopDefault($95fda1bea70891c7$exports)))('#second').on('enter', function() {
    document.querySelector('#second').classList.add('active');
});
(0, (/*@__PURE__*/$parcel$interopDefault($95fda1bea70891c7$exports)))('#third').on('enter', function() {
    document.querySelector('#third').classList.add('active');
});
(0, (/*@__PURE__*/$parcel$interopDefault($95fda1bea70891c7$exports))).offset(600);
// Smoothscroll
const $80545390e8862da1$var$moveTo = new (0, (/*@__PURE__*/$parcel$interopDefault($e42377b553de1771$exports)))({
    tolerance: 0,
    duration: 1000
});
// const trigger = document.getElementsByClassName('js-scroll')[0];
const $80545390e8862da1$var$triggers = document.querySelectorAll('.js-scroll');
for(let i = 0; i < $80545390e8862da1$var$triggers.length; i++)$80545390e8862da1$var$moveTo.registerTrigger($80545390e8862da1$var$triggers[i]);
// Sticky JS
new (0, (/*@__PURE__*/$parcel$interopDefault($88f122e76165d869$exports)))('.contact');
(0, $a29041ce1dffae10$export$2e59f49d97a9dbde)();
// Detect mobile device
function $80545390e8862da1$var$detectMobile() {
    var check = false;
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
// disable phone click on tablet + desktop
if ($80545390e8862da1$var$detectMobile() == false) {
    const phoneBtn = document.querySelector('.js-phone');
    if (phoneBtn) phoneBtn.addEventListener('click', function(e) {
        e.preventDefault();
    });
}
// Product fix
const $80545390e8862da1$var$prices = document.querySelectorAll('.price');
for(let i = 0; i < $80545390e8862da1$var$prices.length; i++){
    const startPrice = $80545390e8862da1$var$prices[i].querySelector('.woocommerce-Price-amount:first-child').innerHTML;
    if ($80545390e8862da1$var$prices[i].children.length > 1) $80545390e8862da1$var$prices[i].innerHTML = `Vanaf ${startPrice}`;
}
// Translate 'No selection' --> 'Geen selectie'
const $80545390e8862da1$var$selectionStr = document.querySelectorAll('dl.component p');
for(let i = 0; i < $80545390e8862da1$var$selectionStr.length; i++){
    const string = $80545390e8862da1$var$selectionStr[i].innerHTML;
    if (string === 'No selection') {
        let newString = string.replace("No selection", "Geen selectie");
        $80545390e8862da1$var$selectionStr[i].innerHTML = newString;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($bf4ef12aa93688e8$exports)))();
if (document.querySelector('.search-field')) (0, $62dca846f2fecce4$export$2e2bcd8739ae039)('.search-field');
(0, (/*@__PURE__*/$parcel$interopDefault($76dec6bf8655ca06$exports))).init({
    backspaceClose: false
});
function $80545390e8862da1$var$cookieModal() {
    const modul = document.querySelector('.modal__campagne');
    const link = document.querySelector('.modal__campagne__close');
    // Controleer of localStorage ouder is dan een dag
    const cookieTimestamp = localStorage.getItem('popupVerschuurTimestamp');
    if (cookieTimestamp) {
        const now = new Date().getTime();
        const oneDay = 86400000; // 1 dag in milliseconden
        if (now - parseInt(cookieTimestamp) > oneDay) {
            localStorage.removeItem('popupVerschuur');
            localStorage.removeItem('popupVerschuurTimestamp');
        }
    }
    if (localStorage.getItem('popupVerschuur') !== 'accepted') {
        if (link) link.addEventListener('click', ()=>{
            modul.style.display = 'none';
            localStorage.setItem('popupVerschuur', 'accepted');
            localStorage.setItem('popupVerschuurTimestamp', new Date().getTime());
        });
    }
}
if (document.querySelector('.modal__campagne') && localStorage.getItem('popupVerschuur') !== 'accepted') {
    const modal = document.querySelector('.modal__campagne');
    const modalbut = document.querySelector('.modal__button');
    window.addEventListener('load', function() {
        setTimeout(function() {
            modal.classList.add('fadeInUp');
            modal.classList.add('animated');
            modal.classList.add('active');
            (0, (/*@__PURE__*/$parcel$interopDefault($76dec6bf8655ca06$exports))).openModal(null, '#modal__campagne');
        }, 1000);
    });
}
if (document.querySelector(".modal__campagne")) $80545390e8862da1$var$cookieModal();

})();
//# sourceMappingURL=app.js.map
